<template>
  <div class="responsive-resize">
    <nav class="navbar navbar-light bg-light fixed-top">
      <div
        class="container-fluid d-flex justify-content-between align-items-center order-header m-width1920"
      >
        <!-- 左側：ロゴ + トレジャーオーダーシミュレーション -->
        <div class="d-flex align-items-center">
          <a class="navbar-brand" href="/">
            <img
              class="navbar-logo"
              src="@/assets/img/logo/treasure_logo.png"
              alt="野球グラブのオーダーメイドシミュレーション | Treasure ロゴ"
            />
          </a>

          <div class="nav-link desktop-only">
            TOP > トレジャーオーダーシミュレーション
          </div>
        </div>
        <!-- 右側：PCで表示させるボタン群 -->
        <div class="d-none d-md-flex align-items-center top-simulation-link">
          <button
            id="myButton"
            class="nav-link top-button"
            @click="saveSelections"
            data-tooltip="現在のシミュレーションを保存します"
          >
            一時保存
          </button>
          <button id="myButton" class="nav-link top-button" @click="openModal">
            確認画面
          </button>
        </div>

        <!-- 右側：モバイル時に表示させる「お問い合わせ」 -->
        <div class="d-flex d-md-none">
          <router-link to="/contact" class="nav-link">
            お問い合わせ
          </router-link>
        </div>
      </div>
    </nav>
    <!--固定ヘッダー-->

    <!-- 左右に分割 -->
    <div class="container-split">
      <!-- 左側  -->
      <div class="left-side" ref="leftSide">
        <!-- データをロード -->
        <component
          :is="!isMobile ? 'div' : 'fragment'"
          :class="!isMobile ? 'desktop-tab-sticky' : ''"
        >
          <div
            class="form-group desktop-only"
            style="display: flex; align-items: center; gap: 10px"
          >
            <label for="sessionID" class="order-id-test">ID:</label>
            <input
              type="text"
              id="sessionID"
              v-model="sessionID"
              class="form-control order-id-input"
              placeholder="IDを入力"
              style="width: 300px"
              spellcheck="false"
            />
            <button
              class="btn btn-primary order-load-btn"
              @click="loadSelections"
              data-tooltip="保存したシミュレーションを再開します"
            >
              読込
            </button>
          </div>

          <ul class="nav nav-tabs tabs-border" id="myTab" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link"
                :class="{ active: activeTab === 'パーツ' }"
                id="tab1-tab"
                @click="setActiveTab('パーツ')"
                >パーツ</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                :class="{ active: activeTab === 'カラー' }"
                id="tab2-tab"
                @click="setActiveTab('カラー')"
                >カラー</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                :class="{ active: activeTab === '刺繍' }"
                id="tab3-tab"
                @click="setActiveTab('刺繍')"
                >刺&nbsp;&nbsp;&nbsp;繍</a
              >
            </li>
          </ul>
        </component>

        <!-- パーツタブ -->
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade"
            :class="{ 'show active': activeTab === 'パーツ' }"
            id="tab1"
            role="tabpanel"
            aria-labelledby="tab1-tab"
          >
            <!-- partsDropdownItems()にfor文の内容があります -->
            <div v-for="(dropdown, index) in partsDropdownItems" :key="index">
              <label :for="dropdown.key">{{ dropdown.label }}</label>
              <CustomDropdown
                :label="dropdown.label2"
                :options="dropdown.options"
                :dropdownId="dropdown.dropdownId"
                v-model="selected[dropdown.key]"
                :isDisabled="dropdown.isDisabled"
                @update:isOpen="(isOpen) => dropdown.handleOpen?.(isOpen)"
                @update:modelValue="(value) => dropdown.handleChange?.(value)"
                @click="handleDropdownClick(dropdown.refName)"
                :ref="dropdown.refName"
                :key="dropdown.key"
                :dropdownKey="dropdown.key"
                :missingFields="missingFields"
              />
            <!-- バックスタイルのドロップダウンの場合、さらにラベルの位置のドロップダウンを表示 -->
              <div v-if="dropdown.key === 'backStyle' && selected.backStyle === 'ライナーバック'">
                <label for="labelPositionDropdown">ライナーバックのラベルの位置</label>
                <CustomDropdown
                  label="選択してください"
                  ref="labelPositionDropdown"
                  :options="labelPositionOptions"
                  dropdownId="labelPositionDropdown"
                  v-model="selected.labelPosition"
                  :key="'labelPositionDropdownKey'"
                  :dropdownKey="'labelPosition'"
                  @click="handleDropdownClick('labelPositionDropdown')"
                  :isDisabled="false"
                  :missingFields="missingFields"
                />
              </div>

              <!-- warningsがあれば、その配列をループする -->
              <div v-if="dropdown.warnings">
                <p
                  v-for="(warningItem, wIndex) in getActiveWarnings(dropdown)"
                  :key="wIndex"
                  class="warning-text"
                >
                  {{ warningItem.text }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- カラータブ -->
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade"
            :class="{ 'show active': activeTab === 'カラー' }"
            id="tab2"
            role="tabpanel"
            aria-labelledby="tab2-tab"
          >
          <!-- <div v-for="(dropdown, index) in colorDropdownItems" :key="index">
              <div
                v-if="(dropdown.key !== 'treasureBelt' || selected.beltType === 'Tベルト')
                      && (dropdown.key !== 'fingerCoverColor' || (selected.finger !== 'なし' && selected.backStyle !== 'ライナーバック'))
                      && (dropdown.key !== 'linerBackBeltColor' || (selected.backStyle === 'ライナーバック'))
                      " -->
          <template v-if="selected.backStyle=='レギュラー'">
            <!-- colorDropdownRegularItems()にfor文の内容があります -->
            <div v-for="(dropdown, index) in colorDropdownRegularItems" :key="index">
              <div v-if="(dropdown.key !== 'treasureBelt' || selected.beltType === 'Tベルト')
                      && (dropdown.key !== 'fingerCoverColor' || (selected.finger !== 'なし' && selected.finger !== null))
                      && (dropdown.key !== 'webEdge' || ['W-23', 'W-27', 'W-28', 'W-T5', 'W-T6', 'W-T8', 'W-T12'].includes(selected.web))
                      && (dropdown.key !== 'bandColor' || !['親指一体', 'Tベルト'].includes(selected.beltType))
                      "
              >
                <label :for="dropdown.key">{{ dropdown.name }}</label>
                <CustomDropdown
                  :ref="dropdown.refName"
                  :label="dropdown.label"
                  :options="dropdown.options"
                  v-model="selected[dropdown.key]"
                  @change="(value) => dropdown.handleChange?.(value)"
                  @update:isOpen="(val) => dropdown.handleOpen?.(val)"
                  @click="handleDropdownClick(dropdown.refName)"
                  :key="dropdown.key"
                  :dropdownKey="dropdown.key"
                  :missingFields="missingFields"
                />
              </div>
            </div>
          </template>

          <template v-else-if="selected.backStyle=='王冠'">
            <!-- colorDropdownRegularItems()にfor文の内容があります -->
            <div v-for="(dropdown, index) in colorDropdownCrownItems" :key="index">
              <div v-if="(dropdown.key !== 'treasureBelt' || selected.beltType === 'Tベルト')
                      && (dropdown.key !== 'fingerCoverColor' || (selected.finger !== 'なし' && selected.finger == null))
                      && (dropdown.key !== 'webEdge' || ['W-23', 'W-27', 'W-28', 'W-T5', 'W-T6', 'W-T8', 'W-T12'].includes(selected.web))
                      && (dropdown.key !== 'bandColor' || !['親指一体', 'Tベルト'].includes(selected.beltType))
                      "
              >
                <label :for="dropdown.key">{{ dropdown.name }}</label>
                <CustomDropdown
                  :ref="dropdown.refName"
                  :label="dropdown.label"
                  :options="dropdown.options"
                  v-model="selected[dropdown.key]"
                  @change="(value) => dropdown.handleChange?.(value)"
                  @update:isOpen="(val) => dropdown.handleOpen?.(val)"
                  @click="handleDropdownClick(dropdown.refName)"
                  :key="dropdown.key"
                  :dropdownKey="dropdown.key"
                  :missingFields="missingFields"
                />
              </div>
              <!-- <p
                v-if="missingFields.includes(dropdown.key)"
                class="warning-text"
              >
                選択してください
              </p> -->
            </div>
          </template>

          <template v-else-if="selected.backStyle=='ライナーバック'">
            <!-- colorDropdownRegularItems()にfor文の内容があります -->
            <div v-for="(dropdown, index) in colorDropdownLinrItems" :key="index">
              <div v-if="(dropdown.key !== 'webEdge' || ['W-23', 'W-27', 'W-28', 'W-T5', 'W-T6', 'W-T8', 'W-T12'].includes(selected.web))">
                <label :for="dropdown.key">{{ dropdown.name }}</label>
                <CustomDropdown
                  :ref="dropdown.refName"
                  :label="dropdown.label"
                  :options="dropdown.options"
                  v-model="selected[dropdown.key]"
                  @change="(value) => dropdown.handleChange?.(value)"
                  @update:isOpen="(val) => dropdown.handleOpen?.(val)"
                  @click="handleDropdownClick(dropdown.refName)"
                  :key="dropdown.key"
                  :dropdownKey="dropdown.key"
                  :missingFields="missingFields"
                />
              <!-- <p
                v-if="missingFields.includes(dropdown.key)"
                class="warning-text"
              >
                選択してください
              </p> -->
              </div>
            </div>
          </template>

            <div v-if="additionalOptions.length > 0">
              <label for="additional-dropdown">{{
                selected.hamidashiChoice
              }}</label>
              <CustomDropdown
                ref="additionalDropdown"
                id="additional-dropdown"
                label="選択してください"
                :options="additionalOptions"
                v-model="selected.additional"
                @change="updateSelection('additional', selected.additional)"
                @update:isOpen="(val) => (isAdditionalPaletteOpen = val)"
                @click="handleDropdownClick('additionalDropdown')"
                :key="'additionalDropdownKey'"
                :dropdownKey="'additional'"
                :missingFields="missingFields"
              />
            </div>

            <!-- colorDropdownSecondItems()にfor文の内容があります -->
            <div
              v-for="(dropdown, index) in colorDropdownSecondItems"
              :key="index"
            >
              <label :for="dropdown.key">{{ dropdown.name }}</label>
              <CustomDropdown
                :label="dropdown.label"
                :options="dropdown.options"
                v-model="selected[dropdown.key]"
                @change="(value) => dropdown.handleChange?.(value)"
                @update:isOpen="(val) => dropdown.handleOpen?.(val)"
                @click="handleDropdownClick(dropdown.refName)"
                :ref="dropdown.refName"
                :key="dropdown.key"
                :dropdownKey="dropdown.key"
                :missingFields="missingFields"
              />
            </div>

            <!-- トレジャーラベルドロップダウン -->
            <label for="label-dropdown1">トレジャーラベル</label>
            <CustomDropdown
              id="label-dropdown1"
              label="選択してください"
              ref="treasureLabelDropdown"
              :options="treasureLabelOptions"
              v-model="selected.treasureLabelChoice"
              @update:isOpen="
                (isOpen) => handleDropdownState(isOpen, treasureLabelOptions)
              "
              @change="updateTreasureLabelChoiceSelection"
              :key="'treasureLabelDropdownKey'"
              :dropdownKey="'treasureLabelChoice'"
              :missingFields="missingFields"
              @click="handleDropdownClick('treasureLabelDropdown')"
            />

            <!-- オリジナルが選択された場合のみ表示 -->
            <div
              v-if="
                selected.treasureLabelChoice ===
                'オリジナル（+3,300円&納期+30日）'
              "
            >
              <label for="option-main-color-dropdown">メインカラー</label>
              <CustomDropdown
                ref="optionMainColorDropdown"
                id="option-main-color-dropdown"
                label="選択してください"
                :options="filteredOptionMainColorOptions"
                v-model="selected.optionMainColor"
                @change="
                  updateSelection('optionMainColor', selected.optionMainColor)
                "
                @update:isOpen="(val) => (isOptionMainColorOpen = val)"
                :key="'optionMainColorDropdownKey'"
                :dropdownKey="'optionMainColor'"
                :missingFields="missingFields"
                @click="handleDropdownClick('optionMainColorDropdown')"
              />

              <label for="option-shadow-color-dropdown">カゲカラー</label>
              <CustomDropdown
                ref="optionShadowColorDropdown"
                id="option-shadow-color-dropdown"
                label="選択してください"
                :options="filteredOptionShadowColorOptions"
                v-model="selected.optionShadowColor"
                @change="
                  updateSelection(
                    'optionShadowColor',
                    selected.optionShadowColor
                  )
                "
                @update:isOpen="(val) => (isOptionShadowColorOpen = val)"
                :key="'optionShadowColorDropdownKey'"
                :dropdownKey="'optionShadowColor'"
                :missingFields="missingFields"
                @click="handleDropdownClick('optionShadowColorDropdown')"
              />

              <label for="option-stand-color-dropdown">台カラー</label>
              <CustomDropdown
                ref="optionStandColorDropdown"
                id="option-stand-color-dropdown"
                label="選択してください"
                :options="filteredOptionStandColorOptions"
                v-model="selected.optionStandColor"
                @change="
                  updateSelection('optionStandColor', selected.optionStandColor)
                "
                @update:isOpen="(val) => (isOptionStandColorOpen = val)"
                :key="'optionStandColorDropdownKey'"
                :dropdownKey="'optionStandColor'"
                :missingFields="missingFields"
                @click="handleDropdownClick('optionStandColorDropdown')"
              />
            </div>
          </div>
        </div>
        <!-- ↑カラータブ↑ -->

        <!-- 刺繍タブ -->
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade"
            :class="{ 'show active': activeTab === '刺繍' }"
            id="tab3"
            role="tabpanel"
            aria-labelledby="tab3-tab"
          >
            <!-- モバイル用タブ -->
            <div v-if="isMobile && activeTab === '刺繍'" class="tab-header">
              <!-- 新規タブ -->
              <div
                class="tab"
                :class="{ active: activeTabIndex === null }"
                @click="switchTab(null)"
              >
                新規
              </div>

              <!-- 動的に生成されるタブ -->
              <div
                v-for="(selection, index) in savedSelections"
                :key="index"
                class="tab"
                :class="{ active: activeTabIndex === index }"
                @click="switchTab(index)"
              >
                {{ selection.embroideryPosition }}
              </div>
            </div>

            <!-- 768px以下の場合、新規タブがアクティブなら新規フォームを表示 -->
            <div v-if="!isMobile || (isMobile && activeTabIndex === null)">
              <!-- 刺繍位置選択肢 -->
              <label for="embroidery-detailsn">刺繍位置</label>
              <CustomDropdown
                label="&nbsp;"
                ref="embroideryPositionDropdown"
                :options="availableEmbroideryPositionOptions"
                v-model="selected.embroideryPosition"
                @change="
                  updateSelection(
                    'embroideryPosition',
                    selected.embroideryPosition
                  )
                "
                @update:isOpen="(isOpen) => { activeDropdownId = isOpen ? 'embroideryPositionDropdown' : null }"
              />

              <label for="font-detail">書体</label>
              <CustomDropdown
                label="&nbsp;"
                ref="fontDropdown"
                :options="fontOptions"
                v-model="selected.font"
                @change="handleFontChange"
              />

              <label for="font-color">書体カラー</label>
              <CustomDropdown
                label="&nbsp;"
                ref="fontColorDropdown"
                :options="fontColorOptions"
                v-model="selected.fontColor"
                @change="updateSelection('fontColor', selected.fontColor)"
                @update:isOpen="(val) => (isFontColorOpen = val)"
                @click="handleDropdownClick('fontColorDropdown')"
                v-bind="item"
              />

              <label for="shadow-edge">カゲ・フチ</label>
              <CustomDropdown
                label="&nbsp;"
                ref="shadowEdgeDropdown"
                :options="shadowEdgeOptions"
                v-model="selected.shadowEdge"
                @change="(value) => handleShadowEdgeChange(value, true)"
                @click="handleDropdownClick('shadowEdgeDropdown')"
              />

              <div v-if="selected.shadowEdge === 'カゲ'">
                <label for="shadow-color">カゲカラー</label>
                <CustomDropdown
                  label="&nbsp;"
                  ref="shadowColorDropdown"
                  :options="shadowColorOptions"
                  v-model="selected.shadowColor"
                  :isDisabled="!isShadowColorEnabled"
                  @change="updateSelection('shadowColor', selected.shadowColor)"
                  @update:isOpen="(val) => (isShadowColorOpen = val)"
                  @click="handleDropdownClick('shadowColorDropdown')"
                />
              </div>

              <div v-if="selected.shadowEdge === 'フチ'">
                <label for="edge-color">フチカラー</label>
                <CustomDropdown
                  label="&nbsp;"
                  ref="edgeColorDropdown"
                  :options="edgeColorOptions"
                  v-model="selected.edgeColor"
                  :isDisabled="!isEdgeColorEnabled"
                  @change="updateSelection('edgeColor', selected.edgeColor)"
                  @update:isOpen="(val) => (isEdgeColorOpen = val)"
                  @click="handleDropdownClick('edgeColorDropdown')"
                />
              </div>

              <div class="dropdown-container">
                <label for="embroidery-detailsn">刺繍内容</label>
                <input
                  type="text"
                  class="form-control embroidery-detailsn embroidery-text"
                  :class="{ 'emb-input-error': embTextInputError }"
                  id="embroidery-detailsn"
                  v-model="selected.embroideryContent"
                  placeholder="&nbsp;"
                  spellcheck="false"
                  @input="validateEmbroideryContent"
                />

                <!-- embTextInputError が true なら警告テキストを表示 -->
                <p v-if="embTextInputError" class="warning-text">
                  {{ selected.font.replace(/\(日本語非対応\)/g, "") }}では日本語の刺繍は出来ません。
                </p>

                <p v-else-if="selected.font && isJapaneseAllowed(selected.font)" class="hint-text">
                  {{
                    selected.font.replace(/\(日本語非対応\)/g, "")
                  }}では日本語・英数字の刺繍が可能です。
                </p>

                <p v-else-if="selected.font" class="hint-text">
                  {{
                    selected.font.replace(/\(日本語非対応\)/g, "")
                  }}では日本語の刺繍はできません。
                </p>
              </div>

              <p class="mobile-only caution-text-nowrop">
                ❇︎刺繍1色:1列 2,200円、カゲ文字:1列 2,750円、フチ文字:1列
                3,300円<br />
                ❇︎2色目から1色+1,100円<br />
                ❇︎色・フォントはイメージです。実際の仕上がりとは異なる場合があります。
              </p>

              <button
                class="btn btn-primary embroidery-addition-btn"
                @click="saveAndReset()"
              >
                追加 +
              </button>
            </div>

            <button
              class="btn btn-secondary embroidery-addition-btn desktop-only"
              @click="resetEmbroidery"
            >
              リセット
            </button>

            <button
              class="btn btn-secondary embroidery-addition-btn mobile-only"
              @click="resetEmbroidery"
              v-show="
                isMobile && activeTab === '刺繍' && activeTabIndex === null
              "
            >
              リセット
            </button>

            <!-- 選択内容が表示される場所 -->
            <div v-if="savedSelections.length > 0" class="saved-message" style="font-size:0.8rem;">
              <p>刺繍位置を変更する場合は一度設定を削除してください</p>
            </div>
            <div id="savedSelections">
              <details
                v-for="(selection, index) in savedSelections"
                :key="index"
                class="selection-result"
                :open="isMobile"
                :style="
                  isMobile
                    ? { display: activeTabIndex === index ? 'block' : 'none' }
                    : {}
                "
              >
                <summary class="saved-summary">
                  刺繍設定 {{ selection.embroideryPosition }}
                </summary>

                <div class="saved-details">
                  <label for="embroidery-detailsn">刺繍位置</label>
                  <CustomDropdown
                    label="選択してください"
                    :options="embroideryPositionOptions"
                    v-model="selection.embroideryPosition"
                    :isDisabled="true"
                    @change="calculateTotal"
                    @click.prevent="onClickEmbroideryPosition()"
                    :ref="'embroideryPositionDropdown_' + index"
                  />

                  <label for="saved-font-detail">書体</label>
                  <CustomDropdown
                    label="選択してください"
                    :options="fontOptions"
                    v-model="selection.font"
                    @change="handleSavedFontChange(selection, index)"
                    @click="handleDropdownClick('fontDropdown_' + index)"
                    :ref="'fontDropdown_' + index"
                  />

                  <label for="seved-font-color">書体カラー</label>
                  <CustomDropdown
                    label="選択してください"
                    :options="fontColorOptions"
                    v-model="selection.fontColor"
                    @change="handleColorUpdateChange(index, 'fontColor', selection.fontColor)"
                    @update:isOpen="
                      (val) => {
                        // val が true ならパレットを開く
                        if (val)
                          onDropDownOpenForSaved(index, 'isFontColorOpen');
                        else selection.isFontColorOpen = false;
                      }
                    "
                    @click="handleDropdownClick('fontColorDropdown_' + index)"
                    :ref="'fontColorDropdown_' + index"
                  />

                  <label for="seved-shadow-edge">カゲ・フチ</label>
                  <CustomDropdown
                    label="選択してください"
                    :options="shadowEdgeOptions"
                    v-model="selection.shadowEdge"
                    @change="
                      (value) => handleShadowEdgeChange(value, false, index)
                    "
                    @click="handleDropdownClick('shadowEdgeDropdown_' + index)"
                    :ref="'shadowEdgeDropdown_' + index"
                  />

                  <div v-if="savedSelections[index].shadowEdge === 'カゲ'">
                    <label for="seved-shadow-color">カゲカラー</label>
                    <CustomDropdown
                      label="選択してください"
                      :options="shadowColorOptions"
                      :isDisabled="!selection.isShadowColorEnabled"
                      v-model="selection.shadowColor"
                      @change="handleColorUpdateChange(index, 'shadowColor', selection.shadowColor)"
                      @update:isOpen="
                        (val) => {
                          selection.isShadowColorOpen = val;
                        }
                      "
                      @click="handleDropdownClick('shadowColorDropdown_' + index)"
                      :ref="'shadowColorDropdown_' + index"
                    />
                  </div>

                  <div v-if="savedSelections[index].shadowEdge === 'フチ'">
                    <label for="seved-edge-color">フチカラー</label>
                    <CustomDropdown
                      label="選択してください"
                      :options="edgeColorOptions"
                      :isDisabled="!selection.isEdgeColorEnabled"
                      v-model="selection.edgeColor"
                      @change="handleColorUpdateChange(index, 'edgeColor', selection.edgeColor)"
                      @update:isOpen="
                        (val) => {
                          selection.isEdgeColorOpen = val;
                        }
                      "
                      @click="handleDropdownClick('edgeColorDropdown_' + index)"
                      :ref="'edgeColorDropdown_' + index"
                    />
                  </div>

                  <div class="dropdown-container">
                    <label for="saved-embroidery-content">刺繍内容</label>
                    <input
 
                      type="text"
                      class="form-control embroidery-detailsn embroidery-text"
                      :class="{ 'emb-input-error': selection.embSavedTextInputError }"
                      v-model="selection.embroideryContent"
                      placeholder="入力してください"
                      spellcheck="false"
                      :pattern="
                        isJapaneseAllowed(selection.font)
                          ? '.*'
                          : '[A-Za-z0-9 ]*'
                      "
                      @input="validateEmbroideryContentForSaved(selection)"
                      @blur="handleSavedFontChange(selection, index)"
                    />
                    <p v-if="selection.embSavedTextInputError" class="warning-text">
                      {{ selection.font.replace(/\(日本語非対応\)/g, "") }}では日本語の刺繍は出来ません。
                    </p>
                  </div>

                  <p class="mobile-only caution-text-nowrop">
                    ❇︎刺繍1色:1列 2,200円、カゲ文字:1列 2,750円、フチ文字:1列
                    3,300円<br />
                    ❇︎2色目から1色+1,100円<br />
                    ❇︎色・フォントはイメージです。実際の仕上がりとは異なる場合があります。
                  </p>
                  <!-- 削除ボタン -->
                  <button
                    class="btn btn-primary embroidery-addition-btn"
                    @click="confirmDelete(index)"
                  >
                    削除
                  </button>

                </div>
              </details>
            </div>

          </div>
        </div>
      </div>
      <!-- 右側 -->

      <div class="middle-side" id="middle-side" ref="middleSide">
        <div class="mds-display-total-price" ref="totalPriceHeight">
          <div class="emb-detali-flex-l">合計:</div>
          <div class="emb-detali-flex-r">
            {{ totalPrice.toLocaleString() }}円(税込)
          </div>
        </div>
        <div v-if="activeDropdownId === 'modelChoiceDropdown'">
          <h3 class="mds-type-title">モデル選択の詳細</h3>
          <div class="info-text">
            選択したモデルに関する詳細情報や追加オプションをここに表示します。
          </div>
          <!-- 必要なHTMLコンテンツを追加 -->
        </div>

        <div
          v-if="
            activeDropdownId === 'typeNameDropdown' &&
            selected.position === '投手'
          "
        >
          <h3 class="mds-type-title">投手用 型一覧</h3>
        <table>
          <thead>
            <tr>
                <td class="type-name">TSN</td>
                <td></td>
            </tr>
            <tr>
                <td class="type-length">全長29.5cm</td>
                <td class="type-detail-flex-r">小型の投手用。操作性にも優れていてポケットは深く作れる縦型モデルです</td>
            </tr>
          </thead>
        </table>

        <table>
          <thead>
            <tr>
                <td class="type-name">TLN</td>
                <td></td>
            </tr>
            <tr>
                <td class="type-length">全長30.0cm</td>
                <td class="type-detail-flex-r">大きめの投手用。握り型設計で横型のモデルです</td>
            </tr>
          </thead>
        </table>
      </div>

        <div
          v-if="
            activeDropdownId === 'typeNameDropdown' &&
            selected.position === '内野'
          "
        >
            <h3 class="mds-type-title">内野用 型一覧</h3>
            <table>
              <thead>
            <tr>
                <td class="type-name-long-text">NMN</td>
                <td></td>
            </tr>
            <tr>
                <td class="type-length">全長27.4cm</td>
                <td class="type-detail-flex-r">小型の内野手用。浅めの形状でフィット感があり軽量感にもこだわったモデルです</td>
              </tr>
            </thead>
          </table>

          <table>
            <thead>
              <tr>
                  <td class="type-name">NMA</td>
                  <td></td>
              </tr>
              <tr>
                  <td class="type-length">全長27.4cm</td>
                  <td class="type-detail-flex-r"></td>
                </tr>
              </thead>
          </table>

          <table>
            <thead>
            <tr>
                <td class="type-name">NWA</td>
                <td></td>
            </tr>
            <tr>
                <td class="type-length">全長28.0cm</td>
                <td rowspan="2" class="type-detail-flex-r">小ぶりの内野手用ですが、ポケットは深く内野全般対応できる形状です</td>
              </tr>
            </thead>
          </table>

          <table>
            <thead>
              <tr>
                  <td class="type-name">NLN</td>
                  <td></td>
              </tr>
              <tr>
                  <td class="type-length">全長28.3cm</td>
                  <td class="type-detail-flex-r"></td>
              </tr>
            </thead>
          </table>

          <table>
            <thead>
            <tr>
                <td class="type-name">NLA</td>
                <td></td>
            </tr>
            <tr>
                <td class="type-length">全長28.3cm</td>
                <td class="type-detail-flex-r"></td>
              </tr>
            </thead>
          </table>

          <table>
            <thead>
              <tr>
                  <td class="type-name-long-text">KZN</td>
                  <td></td>
              </tr>
              <tr>
                  <td class="type-length">全長28.3cm</td>
                  <td class="type-detail-flex-r">ウェブ下での捕球の際、球の収まりがよく特徴的なウェブの形状。大きさはオーソドックスな型で浅め設計です</td>
                </tr>
              </thead>
          </table>
  
          <table>
            <thead>
              <tr>
                  <td class="type-name">NQA</td>
                  <td></td>
              </tr>
              <tr>
                  <td class="type-length">全長29.0cm</td>
                  <td class="type-detail-flex-r">大きめの内野手用。ポケットも深く、握り型設計です</td>
                </tr>
              </thead>
          </table>
        </div>

        <div
          v-if="
            activeDropdownId === 'typeNameDropdown' &&
            selected.position === '外野'
          "
        >
          <h3 class="mds-type-title">外野用 型一覧</h3>
          <table>
            <thead>
              <tr>
                  <td class="type-name-long-text">GWA</td>
                  <td></td>
              </tr>
              <tr>
                  <td class="type-length">全長31.5cm</td>
                  <td class="type-detail-flex-r">大きさはオーソドックスな型で浅くも深くもできる設計です。軽量感も体感できる操作性がよい型です</td>
                </tr>
              </thead>
          </table>

          <table>
            <thead>
              <tr>
                  <td class="type-name-long-text">GLA</td>
                  <td></td>
              </tr>
              <tr>
                  <td class="type-length">全長33.0cm</td>
                  <td class="type-detail-flex-r">大きめな外野手用。縦長でポケットも深く、安心して捕球動作に入りやすい形状です</td>
                </tr>
              </thead>
          </table>
        </div>

        <!-- <div v-if="activeDropdownId === 'backStyleDropdown'">
          <h3 class="mds-type-title">バックスタイルの詳細</h3>
          <div class="font-preview-desktop">
            <img
              src="@/assets/img/backstyle/backstyle-regular.png"
              alt="バックスタイル:レギュラー"
            />
            <img
              src="@/assets/img/backstyle/backstyle-crown.png"
              alt="バックスタイル:王冠"
            />
            <img
              src="@/assets/img/backstyle/backstyle-linerback.png"
              alt="バックスタイル:ライナーバック"
            />
          </div>
        </div> -->

        <!-- <div v-if="activeDropdownId === 'backStrandDropdown'">
          <h3 class="mds-type-title">背面ひも通しの詳細</h3>
          <div class="font-preview-desktop">
            <img
              src="@/assets/img/backStrand/backStrand-none.jpg"
              alt="背面ひも通し:なし"
            />
            <img
              src="@/assets/img/backStrand/backStrand-cross.jpg"
              alt="背面ひも通し:クロス"
            />
            <img
              src="@/assets/img/backStrand/backStrand-straight.jpg"
              alt="背面ひも通し:ストレート"
            />
            <img
              src="@/assets/img/backStrand/backStrand-cross-straight.jpg"
              alt="背面ひも通し:クロス×ストレート"
            />
          </div>
        </div> -->

        <!-- <div v-if="activeDropdownId === 'hamidashiChoiceDropdown'">
          <h3 class="mds-type-title">ハミダシの詳細</h3>
          <div class="font-preview-desktop">
            <img
              src="@/assets/img/hamidashi/hamidashi-kirihami.jpg"
              alt="ハミダシ:切はみ"
            />
            <img
              src="@/assets/img/hamidashi/hamidashi-tamahami.jpg"
              alt="ハミダシ:玉はみ"
            />
          </div>
        </div> -->

        <!-- <div v-if="activeDropdownId === 'lacePortionDropdown'">
          <h3 class="mds-type-title">トジ部の詳細</h3>
          <div class="font-preview-desktop">
            <img
              src="@/assets/img/lacePortion/tatetoji.jpg"
              alt="トジ部:タテトジ"
            />
            <img
              src="@/assets/img/lacePortion/yokotoji.jpg"
              alt="トジ部:ヨコトジ"
            />
            <img
              src="@/assets/img/lacePortion/yokotoji-w.jpg"
              alt="トジ部:ヨコトジダブル"
            />
            <img
              src="@/assets/img/lacePortion/yokotoji-w-himonuki.jpg"
              alt="トジ部:ヨコトジダブルひも抜き"
            />
            <img
              src="@/assets/img/lacePortion/space-hinji.jpg"
              alt="トジ部:スペースヒンジ"
            />
            <img
              src="@/assets/img/lacePortion/space-hinji-w.jpg"
              alt="トジ部:スペースヒンジダブル"
            />
            <img
              src="@/assets/img/lacePortion/space-hinji-w-himonuki.jpg"
              alt="トジ部:スペースヒンジダブルひも抜き"
            />
          </div>
        </div> -->

       

        <!-- オリジナルトレジャーラベルに注意文 -->
        <!-- <div v-if="activeDropdownId === 'treasureLabelDropdown'">
          <p>※投手用では「ホワイト」「Lシルバー」は選択不可です。</p>
        </div> -->

        <!-- PC版description表示コード -->
        <!-- <div
          v-if="isDropdownOpen && !isMobile && activeOptions.length"
          class="dropdown-descriptions"
        >
          <div
            v-for="option in activeOptions"
            :key="option.label"
            class="description-item"
          >
            <strong>{{ option.label }}:</strong> {{ option.description }}
          </div>
        </div> -->

        <!-- カラータブ詳細 -->
        <div v-if="activeTab === 'カラー'" class="mds-active-embroidery">
          <div class="emb-detail-flex">
            <div class="emb-detali-flex-l">1色目</div>
            <div class="emb-detali-flex-r">0円</div>
          </div>
          <div class="emb-detail-flex1 te tabel-end-margin">
            <div class="emb-detali-flex-l">2色目以降</div>
            <div class="emb-detali-flex-r">+3,300円</div>
          </div>
        </div>

        <!-- 刺繍タブ詳細 -->
        <div v-if="activeTab === '刺繍'" class="mds-active-embroidery">
          <div>
            <div class="emb-detail-flex">
              <div class="emb-detali-flex-l">刺繍1色1列</div>
              <div class="emb-detali-flex-r">2,200円</div>
            </div>
            <div class="emb-detail-flex1">
              <div class="emb-detali-flex-l">カゲ文字1列</div>
              <div class="emb-detali-flex-r">2,750円</div>
            </div>
            <div class="emb-detail-flex1">
              <div class="emb-detali-flex-l">フチ文字1列</div>
              <div class="emb-detali-flex-r">3,300円</div>
            </div>
            <div class="emb-detail-flex1 tabel-end-margin">
              <div class="emb-detali-flex-l">3色目以降</div>
              <div class="emb-detali-flex-r">+1,100円</div>
            </div>
          </div>
        </div>

        <div v-if="activeDropdownId === 'embroideryPositionDropdown'">
          平裏の刺繍は二段まで設定可能です。
        </div>

        <!-- カラーパレット -->
        <!-- pcolorPaletteItems()にfor文の内容があります -->
        <div
          v-for="(item, index) in colorPaletteOpenItems"
          :key="index"
          class="mds-color-palette"
        >
          <h5>{{ item.title }}</h5>
          <ColorPalette
            ref="colorPalette"
            :options="item.options"
              :selectedColor="selected[item.colorKey]"
            @colorSelected="
              (option) => handleColorSelected(item.colorKey, option.value)
            "
            :selected="selected"
            :item="item"
          />
        </div>

        <!-- 切はみ・玉はみ -->
        <div v-if="isAdditionalPaletteOpen" class="mds-color-palette">
          <h5>{{ selected.hamidashiChoice }}</h5>
          <ColorPalette
            ref="colorPalette"
            :options="additionalOptions"
            :selectedColor="selected.hamidashiColor"
            @colorSelected="handleAdditionalColorSelected($event.value)"
            :selected="selected"
            :item="{ colorKey: 'additional' }"
          />
        </div>

        <!-- pcolorPaletteSecondItems()にfor文の内容があります -->
        <div
          v-for="(item, index) in colorPaletteOpenSecondItems"
          :key="index"
          class="mds-color-palette"
        >
          <h5>{{ item.title }}</h5>
          <ColorPalette
            ref="colorPalette"
            :options="item.options"
              :selectedColor="selected[item.colorKey]"
            @colorSelected="
              (option) => handleColorSelected(item.colorKey, option.value)
            "
            :selected="selected"
            :item="item"
          />
        </div>

        <!-- 刺繍設定切り分け後のカラーパレット -->
        <div v-for="(selection, index) in savedSelections" :key="index">
          <div v-if="selection.isFontColorOpen" class="mds-color-palette">
            <h5>書体カラー（刺繍設定 {{ selection.embroideryPosition }}）</h5>
            <ColorPalette
              ref="colorPalette"
              :options="fontColorOptions"
              :selectedColor="savedSelections[index].fontColor"
              @colorSelected="
                handleColorSelectedForSaved(index, 'fontColor', $event.value)
              "
              :selected="savedSelections[index]"
              :item="{ colorKey: 'fontColor' }" 
            />
          </div>

          <div v-if="selection.isShadowColorOpen" class="mds-color-palette">
            <h5>カゲカラー（刺繍設定 {{ selection.embroideryPosition }}）</h5>
            <ColorPalette
              ref="colorPalette"
              :options="shadowColorOptions"
              :selectedColor="savedSelections[index].shadowColor"
              @colorSelected="
                handleColorSelectedForSaved(index, 'shadowColor', $event.value)
              "
              :selected="savedSelections[index]"
              :item="{ colorKey: 'shadowColor' }"
            />
          </div>

          <div v-if="selection.isEdgeColorOpen" class="mds-color-palette">
            <h5>フチカラー（刺繍設定 {{ selection.embroideryPosition }}）</h5>
            <ColorPalette
              ref="colorPalette"
              :options="edgeColorOptions"
              :selectedColor="savedSelections[index].edgeColor"
              @colorSelected="
                handleColorSelectedForSaved(index, 'edgeColor', $event.value)
              "
              :selected="savedSelections[index]"
              :item="{ colorKey: 'edgeColor' }"
            />
          </div>
        </div>

        <!-- 刺繍フォントサンプル -->
        <div v-if="!isMobile && selectedFontImage && displayEmbroideryPreview" class="emb-font-preview-desktop">
          刺繍イメージ<br />
          <img :src="selectedFontImage" alt="書体のサンプル" />
          <p v-if="selectedFontDescription && displayEmbroideryPreview" v-html="selectedFontDescription.replace(/\+/g, '<br>')"></p>
          ※実際の仕上がりと異なる場合があります。
        </div>

        <!-- 保存済みのフォントのプレビュー & 説明文 -->
        <div v-if="!isMobile && savedFontImagesAndDescriptions.length > 0 && displayEmbroideryPreview" class="emb-font-preview-desktop">
          刺繍イメージ<br />
          <div v-for="(item, index) in savedFontImagesAndDescriptions" :key="index">
            <img :src="item.image" alt="保存された書体のサンプル" />
            <p v-if="item.description && displayEmbroideryPreview" v-html="item.description.replace(/\+/g, '<br>')"></p>
            ※実際の仕上がりと異なる場合があります。
          </div>
        </div>


      </div>

      <div class="right-side">
        <div class="order-background">
          <div class="order-button-container mobile-only">
            <button
              class="order-image-button"
              :class="{ active: isGlobeDirection === '捕球面' }"
              @click="changeDirection('捕球面')"
            >
              捕球面
            </button>
            <button
              class="order-image-button"
              :class="{ active: isGlobeDirection === '背面' }"
              @click="changeDirection('背面')"
            >
              背&nbsp;&nbsp;&nbsp;面
            </button>
            <button
              class="order-image-button"
                :class="{ active: isGlobeDirection === '親指側' }"
              @click="changeDirection('親指側')"
            >
              親指側
            </button>
            <button
              class="order-image-button"
              :class="{ active: isGlobeDirection === '小指側' }"
              @click="changeDirection('小指側')"
            >
              小指側
            </button>
          </div>

          
          <div v-show="allImagesLoaded">
          <!-- 小指ここから -->
          <!-- バンド -->
          <div class="globe-position" v-if="isGlobeDirection == '小指側'">
            <template v-if="selected['backStyle'] == 'レギュラー' || selected['backStyle'] == '王冠' ">
            <img
              v-if="selected['beltType'] == 'レギュラー' || selected['beltType'] == 'セパレート' "
              id=""
              :src="require(`@/assets/img/pk/pk_blt_share-band_${selectedColorCon('bandColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <img
              v-else-if="selected['beltType'] == '親指一体' || selected['beltType'] == 'Tベルト' "
              id=""
              :src="require(`@/assets/img/pk/pk_blt_share-band_${selectedColorCon('thumbIn')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
          <template v-if="selected['beltType'] == 'セパレート'">
            <img
              id=""
              :src="require(`@/assets/img/pk/pk_blt-sep_band_${selectedColorCon('bandColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
          <!-- バック -->
          <template v-if="selected['backStyle'] == 'レギュラー' || selected['backStyle'] == null ">
            <template v-for="reg in pk_bk_reg" :key="reg">
              <img
                v-if="reg == 'pk_bk-reg_pinky-in'"
                id=""
                :src="require(`@/assets/img/pk/${reg}_${selectedColorCon('littleFingerIn')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="reg == 'pk_bk-reg_pinky-out'"
                id=""
                :src="require(`@/assets/img/pk/${reg}_${selectedColorCon('littleFingerOut')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="reg == 'pk_bk-reg_index-in'"
                id=""
                :src="require(`@/assets/img/pk/${reg}_${selectedColorCon('indexFingerIn')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="reg == 'pk_bk-reg_index-out'"
                id=""
                :src="require(`@/assets/img/pk/${reg}_${selectedColorCon('indexFingerOut')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="reg == 'pk_bk-reg_middle-in'"
                id=""
                :src="require(`@/assets/img/pk/${reg}_${selectedColorCon('middleFingerIn')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="reg == 'pk_bk-reg_middle-out'"
                id=""
                :src="require(`@/assets/img/pk/${reg}_${selectedColorCon('middleFingerOut')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="reg == 'pk_bk-reg_third-in'"
                id=""
                :src="require(`@/assets/img/pk/${reg}_${selectedColorCon('thirdFingerIn')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="reg == 'pk_bk-reg_third-out'"
                id=""
                :src="require(`@/assets/img/pk/${reg}_${selectedColorCon('thirdFingerOut')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <!-- <img
                v-else
                id=""
                :src="require(`@/assets/img/pk/${reg}_${selectedColorCon('mainColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              /> -->
            </template>
          </template>
          <template v-else-if="selected['backStyle'] == '王冠' ">
            <template v-for="crwn in pk_bk_crwn" :key="crwn">
              <img
                v-if="crwn == 'pk_bk-crwn_pinky'"
                id=""
                :src="require(`@/assets/img/pk/${crwn}_${selectedColorCon('littleFingerOut')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="crwn == 'pk_bk-crwn_index'"
                id=""
                :src="require(`@/assets/img/pk/${crwn}_${selectedColorCon('indexFingerIn')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="crwn == 'pk_bk-crwn_index-middle'"
                id=""
                :src="require(`@/assets/img/pk/${crwn}_${selectedColorCon('indexAndMiddleFinger')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="crwn == 'pk_bk-crwn_middle-third'"
                id=""
                :src="require(`@/assets/img/pk/${crwn}_${selectedColorCon('middleAndThirdFinger')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="crwn == 'pk_bk-crwn_third-pinky'"
                id=""
                :src="require(`@/assets/img/pk/${crwn}_${selectedColorCon('thirdAndLittleFinger')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <!-- <img
                v-else
                id=""
                :src="require(`@/assets/img/pk/${crwn}_${selectedColorCon('mainColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              /> -->
            </template>
          </template>
          <template v-else-if="selected['backStyle'] == 'ライナーバック' ">
            <template v-for="linr in pk_bk_linr" :key="linr">
              <img
                v-if="linr == 'pk_bk-linr_stitch'"
                id=""
                :src="require(`@/assets/img/pk/${linr}_${selectedColorCon('stitchColor')}.png`)"
                :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
              />
              <img
                v-else-if="linr == 'pk_bk-linr_edge'"
                id=""
                :src="require(`@/assets/img/pk/${linr}_${selectedColorCon('hemLeather')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="linr == 'pk_bk-linr_blt'"
                id=""
                :src="require(`@/assets/img/pk/${linr}_${selectedColorCon('linerBackBeltColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="linr == 'pk_bk-linr_pinky'"
                id=""
                :src="require(`@/assets/img/pk/${linr}_${selectedColorCon('littleFingerOut')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="linr == 'pk_bk-linr_thumb-index'"
                id=""
                :src="require(`@/assets/img/pk/${linr}_${selectedColorCon('thumbIndexAndMiddleFinger')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="linr == 'pk_bk-linr_middle-third'"
                id=""
                :src="require(`@/assets/img/pk/${linr}_${selectedColorCon('middleAndThirdFinger')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="linr == 'pk_bk-linr_third-pinky'"
                id=""
                :src="require(`@/assets/img/pk/${linr}_${selectedColorCon('thirdAndLittleFinger')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="linr == 'pk_bk-linr_palm-lining'"
                id=""
                :src="require(`@/assets/img/pk/${linr}_${selectedColorCon('hiraura')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="linr == 'pk_bk-linr_palm-lining-lace'"
                id=""
                :src="require(`@/assets/img/pk/${linr}_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
               v-else-if="linr == 'pk_bk-linr_welting'"
              id=""
              :src="require(`@/assets/img/pk/${linr}_${selectedColorCon('additional')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
              <!-- <img
                v-else
                id=""
                :src="require(`@/assets/img/pk/${linr}_${selectedColorCon('mainColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              /> -->
            </template>
          </template>

          <!-- ハミダシ -->
          <template v-if="selected['backStyle'] == 'レギュラー'">
            <img
              id=""
              :src="require(`@/assets/img/pk/pk_bk-reg_welting_${selectedColorCon('additional')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
          <template v-else-if="selected['backStyle'] == '王冠' ">
            <img
              id=""
              :src="require(`@/assets/img/pk/pk_bk-crwn_welting_${selectedColorCon('additional')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>

            <!-- ひも通し -->
            <template v-if="selected['backStrand'] == 'クロス' ">
              <img
                id=""
                :src="require(`@/assets/img/pk/pk_lace-cross_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                id=""
                :src="require(`@/assets/img/pk/pk_lace-share_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
            </template>
            <template v-else-if="selected['backStrand'] == 'ストレート' ">
              <img
                id=""
                :src="require(`@/assets/img/pk/pk_lace-st_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                id=""
                :src="require(`@/assets/img/pk/pk_lace-share_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
            </template>
            <template v-else-if="selected['backStrand'] == 'クロス×ストレート' ">
              <img
                id=""
                :src="require(`@/assets/img/pk/pk_lace-cross-st_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                id=""
                :src="require(`@/assets/img/pk/pk_lace-share_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
            </template>

            <!-- ベルト -->
            <!-- stitchの色修正 -->
            <!-- <template v-if="selected['beltType'] == 'Tベルト' || selected['beltType'] == null ">
              <template v-for="tbelt in pk_blt_tbelt" :key="tbelt">
                <img
                  v-if="tbelt == 'pk_blt-tbelt_stitch'"
                  id=""
                  :src="require(`@/assets/img/pk/${tbelt}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/pk/${tbelt}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template> -->
            <template v-if="selected['beltType'] == 'セパレート' ">
              <template v-for="sep in pk_blt_sep" :key="sep">
                <img
                  v-if="sep == 'pk_blt-sep_stitch'"
                  id=""
                  :src="require(`@/assets/img/pk/${sep}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="sep == 'pk_blt-sep_palm-lining'"
                  id=""
                  :src="require(`@/assets/img/pk/${sep}_${selectedColorCon('hiraura')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="sep == 'pk_blt-sep_edge'"
                  id=""
                  :src="require(`@/assets/img/pk/${sep}_${selectedColorCon('hemLeather')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="sep == 'pk_blt-sep_edge-lace'"
                  id=""
                  :src="require(`@/assets/img/pk/${sep}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/pk/${sep}_red.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>

            <!-- ラベル -->
            <template v-else-if="selected['backStyle'] == 'ライナーバック' && selected['labelPosition'] == '小指側'">
                <template v-if="selected['gloveHand'] == '右投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/pk/pk_bk-linr_lbl-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                  <img
                  id=""
                  :src="require(`@/assets/img/pk/pk_bk-linr_lbl-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/pk/pk_bk-linr_lbl-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
              <template v-else-if="selected['gloveHand'] == '左投げ'">
                <img
                  id=""
                  :src="require(`@/assets/img/pk/pk_bk-linr_lbl_reflect-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                  <img
                  id=""
                  :src="require(`@/assets/img/pk/pk_bk-linr_lbl_reflect-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/pk/pk_bk-linr_lbl_reflect-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
            </template>

            <!-- 共通 -->
            <img
              id=""
              :src="require(`@/assets/img/pk/pk_shere-knot_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <img
              id=""
              :src="require(`@/assets/img/pk/pk_share-lace_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <template v-if="selected['beltType'] != 'セパレート' && selected['backStyle'] != 'ライナーバック' ">
            <img
              id=""
              :src="require(`@/assets/img/pk/pk_blt_share-palm-lining_${selectedColorCon('hiraura')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <img
              id=""
              :src="require(`@/assets/img/pk/pk_blt_share-stitch_${selectedColorCon('stitchColor')}.png`)"
              :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
            />
            <img
              id=""
              :src="require(`@/assets/img/pk/pk_blt_share-edge_${selectedColorCon('hemLeather')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <img
              id=""
              :src="require(`@/assets/img/pk/pk_blt_share-edge-lace_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <img
              id=""
              :src="require(`@/assets/img/pk/pk_blt_shere-knot_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            </template>
            <img
              id=""
              :src="require(`@/assets/img/pk/pk_shere-pinky-hanger_${selectedColorCon('littleFingerHanger')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <img
                id=""
                :src="require(`@/assets/img/pk/pk_bk-linr_edge-lace_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />

          <!-- ラベル -->
          <!-- <template v-if="selected['backStyle'] == 'ライナーバック' ">
            <img
                id=""
                :src="require(`@/assets/img/pk/pk_bk-linr_lbl-base_${selectedColorCon('optionStandColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
            <img
                id=""
                :src="require(`@/assets/img/pk/pk_bk-linr_lbl-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <img
                id=""
                :src="require(`@/assets/img/pk/pk_bk-linr_lbl-main_${selectedColorCon('optionMainColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
          </template> -->
            <!-- 指アテ -->
            <template v-if="selected['finger'] == '指アテ・人差し指' ">
              <template v-for="pfpi in pk_finger_pad_index" :key="pfpi">
                <img
                  v-if="pfpi == 'pk_finger-pad_index'"
                  id=""
                  :src="require(`@/assets/img/pk/${pfpi}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="pfpi == 'pk_finger-pad_index_stitch'"
                  id=""
                  :src="require(`@/assets/img/pk/${pfpi}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
              </template>
            </template>
            <template v-if="selected['finger'] == 'ヘリ無し指アテ・人差し指' ">
              <template v-for="pfpni in pk_finger_pad_none_index" :key="pfpni">
                <img
                  v-if="pfpni == 'pk_finger-pad-none_index'"
                  id=""
                  :src="require(`@/assets/img/pk/${pfpni}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="pfpni == 'pk_finger-pad-none_index_stitch'"
                  id=""
                  :src="require(`@/assets/img/pk/${pfpni}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
              </template>
            </template>
            <template v-if="selected['finger'] == '指アテ・中指（+5,500円）' ">
              <template v-for="pfpm in pk_finger_pad_middle" :key="pfpm">
                <img
                  v-if="pfpm == 'pk_finger-pad_middle'"
                  id=""
                  :src="require(`@/assets/img/pk/${pfpm}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="pfpm == 'pk_finger-pad_middle_stitch'"
                  id=""
                  :src="require(`@/assets/img/pk/${pfpm}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
              </template>
            </template>
            <template v-if="selected['finger'] == 'ヘリ無し指アテ・中指（+5,500円）' ">
              <template v-for="pfpnm in pk_finger_pad_none_middle" :key="pfpnm">
                <img
                  v-if="pfpnm == 'pk_finger-pad-none_middle'"
                  id=""
                  :src="require(`@/assets/img/pk/${pfpnm}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="pfpnm == 'pk_finger-pad-none_middle_stitch'"
                  id=""
                  :src="require(`@/assets/img/pk/${pfpnm}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
              </template>
            </template>
            <template v-if="selected['finger'] == '指カバー・人差し指' ">
              <template v-for="pfci in pk_finger_cov_index" :key="pfci">
                <img
                  v-if="pfci == 'pk_finger-cov_index_stitch'"
                  id=""
                  :src="require(`@/assets/img/pk/${pfci}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="pfci == 'pk_finger-cov_index'"
                  id=""
                  :src="require(`@/assets/img/pk/${pfci}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template>
            <template v-if="selected['finger'] == '指カバー・中指（+5,500円）' ">
              <template v-for="pfcm in pk_finger_cov_middle" :key="pfcm">
                <img
                  v-if="pfcm == 'pk_finger-cov_middle'"
                  id=""
                  :src="require(`@/assets/img/pk/${pfcm}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="pfcm == 'pk_finger-cov_middle_stitch'"
                  id=""
                  :src="require(`@/assets/img/pk/${pfcm}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
              </template>
            </template>
            <template v-if="selected['finger'] == '先出し指カバー・人差し指中指間（+5,500円）' ">
              <template v-for="pfocb in pk_finger_opn_cov_between" :key="pfocb">
                <img
                  v-if="pfocb == 'pk_finger-opn-cov_between'"
                  id=""
                  :src="require(`@/assets/img/pk/${pfocb}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="pfocb == 'pk_finger-opn-cov_between_stitch'"
                  id=""
                  :src="require(`@/assets/img/pk/${pfocb}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
              </template>
            </template>
            <template v-if="selected['finger'] == '先出し指カバー・人差し指' ">
              <template v-for="pfoci in pk_finger_opn_cov_index" :key="pfoci">
                <img
                  v-if="pfoci == 'pk_finger-opn-cov_index'"
                  id=""
                  :src="require(`@/assets/img/pk/${pfoci}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="pfoci == 'pk_finger-opn-cov_index_stitch'"
                  id=""
                  :src="require(`@/assets/img/pk/${pfoci}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
              </template>
            </template>
            <template v-if="selected['finger'] == '先出し指カバー・中指（+5,500円）' ">
              <template v-for="pfocm in pk_finger_opn_cov_middle" :key="pfocm">
                <img
                  v-if="pfocm == 'pk_finger-opn-cov_middle'"
                  id=""
                  :src="require(`@/assets/img/pk/${pfocm}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="pfocm == 'pk_finger-opn-cov_middle_stitch'"
                  id=""
                  :src="require(`@/assets/img/pk/${pfocm}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
              </template>
            </template>
          </div>
          <!-- 小指ここまで -->
           
          <!-- 親指ここから -->
          <div class="globe-position" v-if="isGlobeDirection == '親指側'">
            <!-- 指アテ -->
            <template v-if="selected['finger'] == 'ヘリ無し指アテ・人差し指' || selected['finger'] == 'ヘリ無し指アテ・中指（+5,500円）'">
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_finger-pad-none_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
            </template>
            <template v-else-if="selected['finger'] == '指カバー・人差し指' || selected['finger'] == '指カバー・中指（+5,500円）'|| selected['finger'] == '先出し指カバー・人差し指'|| selected['finger'] == '先出し指カバー・人差し指中指間（+5,500円）' || selected['finger'] == '先出し指カバー・中指（+5,500円）'">
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_finger-cov-opn-shar_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
            </template>
            <!-- <template v-else-if="selected['finger'] != null">
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_finger-cov-opn-shar_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
            </template>
            <template>
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_finger-cov-opn-share_stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
            </template> -->
            
             <!-- バック -->
             <template v-if="selected['backStyle'] == 'ライナーバック' ">
             <template v-for="linr in tb_bk_linr" :key="linr">
              <img
                id=""
                v-if="linr == 'tb_bk-linr_stitch'"
                :src="require(`@/assets/img/tb/${linr}_${selectedColorCon('stitchColor')}.png`)"
                :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
              />
              <img
                id=""
                v-else-if="linr == 'tb_bk-linr_thumb-index'"
                :src="require(`@/assets/img/tb/${linr}_${selectedColorCon('thumbIndexAndMiddleFinger')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                id=""
                v-else-if="linr == 'tb_bk-linr_thumb-in'"
                :src="require(`@/assets/img/tb/${linr}_${selectedColorCon('thumbOut')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
              v-else-if="linr == 'tb_share-welting'"
              id=""
              :src="require(`@/assets/img/tb/${linr}_${selectedColorCon('additional')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                id=""
                v-else-if="linr == 'tb_bk-linr_edge'"
                :src="require(`@/assets/img/tb/${linr}_${selectedColorCon('hemLeather')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                id=""
                v-else-if="linr == 'tb_bk-linr_blt'"
                :src="require(`@/assets/img/tb/${linr}_${selectedColorCon('linerBackBeltColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                id=""
                v-else-if="linr == 'tb_bk-linr_blt-reg_edge-lace'"
                :src="require(`@/assets/img/tb/${linr}_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <!-- <img
                id=""
                v-else-if="linr == 'tb_bk-linr_lbl-base'"
                :src="require(`@/assets/img/tb/${linr}_${selectedColorCon('optionStandColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                id=""
                v-else-if="linr == 'tb_bk-linr_lbl-shadow'"
                :src="require(`@/assets/img/tb/${linr}_${selectedColorCon('optionShadowColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                id=""
                v-else-if="linr == 'tb_bk-linr_lbl-main'"
                :src="require(`@/assets/img/tb/${linr}_${selectedColorCon('optionMainColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              /> -->
              <img
                id=""
                v-else-if="linr == 'tb_bk-linr_thumb-knot'"
                :src="require(`@/assets/img/tb/${linr}_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
            </template>
          </template>
            <!-- 共通 -->
            <template v-if="selected['backStyle'] == 'レギュラー' || selected['backStyle'] == '王冠' ">
              <img
              id=""
              :src="require(`@/assets/img/tb/tb_share-welting_${selectedColorCon('additional')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <img
              id=""
              :src="require(`@/assets/img/tb/tb_share-thumb-in_${selectedColorCon('thumbOut')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <img
              id=""
              :src="require(`@/assets/img/tb/tb_share-thumb-out_${selectedColorCon('thumbIn')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <img
              id=""
              :src="require(`@/assets/img/tb/tb_blt-sep_web_${selectedColorCon('catchColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            </template>
            <img
              id=""
              :src="require(`@/assets/img/tb/tb_share-lace_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <!-- ベルト -->
            <!-- stitchの色修正 -->
            <template v-if="selected['backStyle'] == 'レギュラー' || selected['backStyle'] == '王冠' ">
            <template v-if="selected['beltType'] == 'Tベルト' || selected['beltType'] == null ">
              <template v-for="tbelt in tb_blt_tbelt" :key="tbelt">
                <img
                  v-if="tbelt == 'tb_blt-tbelt_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${tbelt}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="tbelt == 'tb_blt-tbelt_mark'"
                  id=""
                  :src="require(`@/assets/img/tb/${tbelt}_${selectedColorCon('treasureBelt')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else-if="tbelt == 'tb_blt-tbelt_lbl-base'"
                  id=""
                  :src="require(`@/assets/img/tb/${tbelt}_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="tbelt == 'tb_blt-tbelt_lbl-shadow'"
                  id=""
                  :src="require(`@/assets/img/tb/${tbelt}_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="tbelt == 'tb_blt-tbelt_lbl-main'"
                  id=""
                  :src="require(`@/assets/img/tb/${tbelt}_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
                <img
                  v-else-if="tbelt == 'tb_blt-tbelt_thumb-knot'"
                  id=""
                  :src="require(`@/assets/img/tb/${tbelt}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="tbelt == 'tb_blt-reg_edge'"
                  id=""
                  :src="require(`@/assets/img/tb/${tbelt}_${selectedColorCon('hemLeather')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${tbelt}_red.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-else-if="selected['beltType'] == 'セパレート' ">
              <template v-for="sep in tb_blt_sep" :key="sep">
                <img
                  v-if="sep == 'tb_blt-sep_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${sep}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="sep == 'tb_blt-sep_web'"
                  id=""
                  :src="require(`@/assets/img/tb/${sep}_${selectedColorCon('catchColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="sep == 'tb_blt-sep_thumb-out'"
                  id=""
                  :src="require(`@/assets/img/tb/${sep}_${selectedColorCon('thumbOut')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="sep == 'tb_blt-sep_band'"
                  id=""
                  :src="require(`@/assets/img/tb/${sep}_${selectedColorCon('bandColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else-if="sep == 'tb_blt-sep_lbl-base'"
                  id=""
                  :src="require(`@/assets/img/tb/${sep}_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="sep == 'tb_blt-sep_lbl-shadow'"
                  id=""
                  :src="require(`@/assets/img/tb/${sep}_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="sep == 'tb_blt-sep_lbl-main'"
                  id=""
                  :src="require(`@/assets/img/tb/${sep}_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
                <img
                  v-else-if="sep == 'tb_blt-sep_edge'"
                  id=""
                  :src="require(`@/assets/img/tb/${sep}_${selectedColorCon('hemLeather')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="sep == 'tb_blt-sep_edge-lace'"
                  id=""
                  :src="require(`@/assets/img/tb/${sep}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${sep}_red.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-else-if="selected['beltType'] == 'レギュラー' ">
              <template v-for="reg in tb_blt_reg" :key="reg">
                <img
                  v-if="reg == 'tb_blt-reg_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${reg}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <!-- <img
                  v-else-if="reg == 'tb_blt-reg_lbl-shadow'"
                  id=""
                  :src="require(`@/assets/img/tb/${reg}_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
                <img
                  v-else-if="reg == 'tb_blt-reg_band'"
                  id=""
                  :src="require(`@/assets/img/tb/${reg}_${selectedColorCon('bandColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else-if="reg == 'tb_blt-reg_lbl-main'"
                  id=""
                  :src="require(`@/assets/img/tb/${reg}_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
                <img
                  v-else-if="reg == 'tb_blt-reg_thumb-knot'"
                  id=""
                  :src="require(`@/assets/img/tb/${reg}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else-if="reg == 'tb_blt-reg_lbl-base'"
                  id=""
                  :src="require(`@/assets/img/tb/${reg}_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
                <img
                v-else-if="reg == 'tb_blt-reg_edge'"
                  id=""
                  :src="require(`@/assets/img/tb/${reg}_${selectedColorCon('hemLeather')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${reg}_red.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-else-if="selected['beltType'] == '親指一体' ">
              <template v-for="lbl in tb_blt_tmb_lbl" :key="lbl">
                <img
                  v-if="lbl == 'tb_blt-tmb_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${lbl}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <!-- <img
                  v-else-if="lbl == 'tb_blt-tmb_lbl-base'"
                  id=""
                  :src="require(`@/assets/img/tb/${lbl}_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="lbl == 'tb_blt-tmb_lbl-shadow'"
                  id=""
                  :src="require(`@/assets/img/tb/${lbl}_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="lbl == 'tb_blt-tmb_lbl-main'"
                  id=""
                  :src="require(`@/assets/img/tb/${lbl}_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
                <!-- <img
                  v-else-if="lbl == 'tb_blt-tmb_thumb-knot'"
                  id=""
                  :src="require(`@/assets/img/tb/${lbl}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
                <img
                  v-else-if="lbl == 'tb_blt-tmb_edge'"
                  id=""
                  :src="require(`@/assets/img/tb/${lbl}_${selectedColorCon('hemLeather')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${lbl}_red.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
          </template>

           <!-- ラベル -->
           <template v-if="selected['beltType'] == 'レギュラー' || selected['beltType'] == null && selected['backStyle'] != 'ライナーバック'">
                <template v-if="selected['gloveHand'] == '右投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-reg_lbl-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-reg_lbl-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-reg_lbl-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
              <template v-else-if="selected['gloveHand'] == '左投げ' && selected['backStyle'] != 'ライナーバック'">
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-reg_lbl_reflect-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-reg_lbl_reflect-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-reg_lbl_reflect-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                /> 
              </template>
              </template>
              <template v-else-if="selected['beltType'] == '親指一体'">
                <template v-if="selected['gloveHand'] == '右投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-tmb_lbl-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                  <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-tmb_lbl-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-tmb_lbl-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
              <template v-else-if="selected['gloveHand'] == '左投げ'">
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-tmb_lbl_reflect-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                  <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-tmb_lbl_reflect-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-tmb_lbl_reflect-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
              </template>
              <template v-else-if="selected['beltType'] == 'セパレート'">
                <template v-if="selected['gloveHand'] == '右投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-sep_lbl-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                  <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-sep_lbl-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-sep_lbl-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
              <template v-else-if="selected['gloveHand'] == '左投げ'">
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-sep_lbl_reflect-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                  <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-sep_lbl_reflect-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-sep_lbl_reflect-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
            </template>
            <template v-else-if="selected['beltType'] == 'Tベルト'">
                <template v-if="selected['gloveHand'] == '右投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-tbelt_lbl-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                  <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-tbelt_lbl-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-tbelt_lbl-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
              <template v-else-if="selected['gloveHand'] == '左投げ'">
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-tbelt_lbl_reflect-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                  <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-tbelt_lbl_reflect-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-tbelt_lbl_reflect-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
            </template>
            <template v-else-if="selected['backStyle'] == 'ライナーバック' && selected['labelPosition'] == '親指側'">
                <template v-if="selected['gloveHand'] == '右投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_bk-linr_lbl-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                  <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_bk-linr_lbl-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_bk-linr_lbl-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
              <template v-else-if="selected['gloveHand'] == '左投げ'">
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_bk-linr_lbl_reflect-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                  <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_bk-linr_lbl_reflect-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_bk-linr_lbl_reflect-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
            </template>

            <!-- 共通前面 -->
            <img
              id=""
              :src="require(`@/assets/img/tb/tb_bk-linr_blt-reg_edge-lace_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <img
              id=""
              :src="require(`@/assets/img/tb/tb_share-thumb-hanger_${selectedColorCon('thumbHanger')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
             <img
                  v-if="selected['beltType'] == '親指一体'"
                  id=""
                  :src="require(`@/assets/img/tb/tb_blt-tmb_thumb-knot_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />

          <!-- ウェブ -->
          <img
              id=""
              :src="require(`@/assets/img/tb/tb_share-web-inside_${selectedColorCon('indexFingerIn')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          <img
              id=""
              :src="require(`@/assets/img/tb/tb_share-web-inside-ft_${selectedColorCon('catchColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <template v-if="selected['web'] == 'W-3'">
              <template v-for="w3 in tb_w_3" :key="w3">
                <img
                  v-if="w3 == 'tb_w-3_w-6_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${w3}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w3 == 'tb_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w3}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w3 == 'tb_web_lace_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w3}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w3 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w3}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w3 == 'tb_web_lace_base01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w3}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w3 == 'tb_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w3}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w3 == 'tb_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w3}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w3 == 'tb_w-3_w-6_w-7_lining'"
                  id=""
                  :src="require(`@/assets/img/tb/${w3}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w3 == 'tb_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w3}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${w3}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-5'">
              <template v-for="w5 in tb_w_5" :key="w5">
                <img
                  v-if="w5 == 'tb_web_stitch_base01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w5}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w5 == 'tb_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w5}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w5 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w5}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w5 == 'tb_web_lace_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w5}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w5 == 'tb_web_lace_base01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w5}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w5 == 'tb_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w5}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w5 == 'tb_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w5}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w5 == 'tb_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w5}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${w5}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-6'">
              <template v-for="w6 in tb_w_6" :key="w6">
                <img
                  v-if="w6 == 'tb_web_stitch_base02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w6}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w6 == 'tb_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w6}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w6 == 'tb_web_stitch_vertical01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w6}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w6 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w6}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w6 == 'tb_web_lace_base03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w6}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w6 == 'tb_web_lace_top03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w6}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w6 == 'tb_web_lace_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w6}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w6 == 'tb_web_front-lace_middle01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w6}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w6 == 'tb_web_front-lace_bottom01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w6}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w6 == 'tb_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w6}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w6 == 'tb_web_frame_base03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w6}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w6 == 'tb_web_frame_base-vertical02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w6}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${w6}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-8'">
              <template v-for="w8 in tb_w_8" :key="w8">
                <img
                  v-if="w8 == 'tb_web_stitch_base02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w8}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w8 == 'tb_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w8}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w8 == 'tb_web_stitch_vertical02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w8}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w8 == 'tb_web_lace_base03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w8}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w8 == 'tb_web_lace_top03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w8}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w8 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w8}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w8 == 'tb_web_lace_vertical'"
                  id=""
                  :src="require(`@/assets/img/tb/${w8}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w8 == 'tb_w-8_front-lace'"
                  id=""
                  :src="require(`@/assets/img/tb/${w8}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w8 == 'tb_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w8}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w8 == 'tb_web_frame_base03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w8}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w8== 'tb_web_frame_base-vertical02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w8}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${w8}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-10'">
              <template v-for="w10 in tb_w_10" :key="w10">
                <img
                  v-if="w10 == 'tb_web_stitch_base02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w10}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w10 == 'tb_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w10}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w10 == 'tb_web_stitch_vertical02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w10}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w10 == 'tb_web_lace_base03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w10}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w10 == 'tb_web_lace_top03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w10}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w10 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w10}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w10 == 'tb_web_lace_vertical'"
                  id=""
                  :src="require(`@/assets/img/tb/${w10}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w10 == 'tb_web_front-lace_bottom05'"
                  id=""
                  :src="require(`@/assets/img/tb/${w10}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w10 == 'tb_web_front-lace_bottom01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w10}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w10 == 'tb_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w10}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w10 == 'tb_web_frame_base03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w10}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w10 == 'tb_web_frame_base-vertical02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w10}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${w10}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-11'">
              <template v-for="w11 in tb_w_11" :key="w11">
                <img
                  v-if="w11 == 'tb_web_stitch_base03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w11}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w11 == 'tb_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w11}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w11 == 'tb_w-11_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${w11}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w11 == 'tb_web_lace_top03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w11}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w11 == 'tb_web_lace_base04'"
                  id=""
                  :src="require(`@/assets/img/tb/${w11}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w11 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w11}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w11 == 'tb_web_lace_base02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w11}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w11 == 'tb_w-11_t-5_front-lace'"
                  id=""
                  :src="require(`@/assets/img/tb/${w11}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w11 == 'tb_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w11}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w11 == 'tb_web_frame_base04'"
                  id=""
                  :src="require(`@/assets/img/tb/${w11}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w11 == 'tb_w-11_base-vertical'"
                  id=""
                  :src="require(`@/assets/img/tb/${w11}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${w11}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-12'">
              <template v-for="w12 in tb_w_12" :key="w12">
                <img
                  v-if="w12 == 'tb_w-12_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${w12}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w12 == 'tb_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w12}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w12 == 'tb_w-12_back-lace'"
                  id=""
                  :src="require(`@/assets/img/tb/${w12}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w12 == 'tb_web_lace_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w12}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w12 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w12}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w12 == 'tb_web_front-lace_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w12}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w12 == 'tb_web_lace_base01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w12}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w12 == 'tb_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w12}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w12 == 'tb_w-12_base'"
                  id=""
                  :src="require(`@/assets/img/tb/${w12}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w12 == 'tb_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w12}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${w12}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-13'">
              <template v-for="w13 in tb_w_13" :key="w13">
                <img
                  v-if="w13 == 'tb_w-13_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${w13}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w13 == 'tb_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w13}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w13 == 'tb_w-13_back-lace'"
                  id=""
                  :src="require(`@/assets/img/tb/${w13}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w13 == 'tb_web_lace_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w13}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w13 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w13}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w13 == 'tb_web_front-lace_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w13}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w13 == 'tb_web_lace_base01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w13}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w13 == 'tb_w-13_front-lace'"
                  id=""
                  :src="require(`@/assets/img/tb/${w13}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w13 == 'tb_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w13}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w13 == 'tb_w-13_base'"
                  id=""
                  :src="require(`@/assets/img/tb/${w13}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w13 == 'tb_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w13}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${w13}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-14'">
              <template v-for="w14 in tb_w_14" :key="w14">
                <img
                  v-if="w14 == 'tb_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w14}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w14 == 'tb_web_stitch_vertical03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w14}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w14 == 'tb_web_lace_top03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w14}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w14 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w14}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w14 == 'tb_web_front-lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w14}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w14 == 'tb_w-14_front-lace'"
                  id=""
                  :src="require(`@/assets/img/tb/${w14}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w14 == 'tb_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w14}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w14 == 'tb_web_frame_base-vertical01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w14}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${w14}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-15'">
              <template v-for="w15 in tb_w_15" :key="w15">
                <img
                  v-if="w15 == 'tb_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w15}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w15 == 'tb_web_stitch_vertical03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w15}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w15 == 'tb_web_lace_top03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w15}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w15 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w15}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w15 == 'tb_web_front-lace_bottom06'"
                  id=""
                  :src="require(`@/assets/img/tb/${w15}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w15 == 'tb_w-15_front-lace'"
                  id=""
                  :src="require(`@/assets/img/tb/${w15}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w15 == 'tb_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w15}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w15 == 'tb_web_frame_base-vertical01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w15}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${w15}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-16'">
              <template v-for="w16 in tb_w_16" :key="w16">
                <img
                  v-if="w16 == 'tb_w-16_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${w16}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w16 == 'tb_web_front-lace_bottom06'"
                  id=""
                  :src="require(`@/assets/img/tb/${w16}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w16 == 'tb_w-16_front-lace'"
                  id=""
                  :src="require(`@/assets/img/tb/${w16}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w16 == 'tb_w-16_base'"
                  id=""
                  :src="require(`@/assets/img/tb/${w16}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w16 == 'tb_w-16_edge'"
                  id=""
                  :src="require(`@/assets/img/tb/${w16}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${w16}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-17'">
              <template v-for="w17 in tb_w_17" :key="w17">
                <img
                  v-if="w17 == 'tb_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w17}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w17 == 'tb_web_stitch_vertical03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w17}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w17 == 'tb_web_lace_top03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w17}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w17 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w17}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w17 == 'tb_web_front-lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w17}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w17 == 'tb_w-17_front-lace'"
                  id=""
                  :src="require(`@/assets/img/tb/${w17}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w17 == 'tb_web_front-lace_bottom06'"
                  id=""
                  :src="require(`@/assets/img/tb/${w17}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w17 == 'tb_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w17}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w17 == 'tb_web_frame_base-vertical01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w17}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${w17}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-19'">
              <template v-for="w19 in tb_w_19" :key="w19">
                <img
                  v-if="w19 == 'tb_w-19_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${w19}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w19 == 'tb_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w19}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w19 == 'tb_web_stitch_vertical02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w19}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w19 == 'tb_w-19_back-lace'"
                  id=""
                  :src="require(`@/assets/img/tb/${w19}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w19 == 'tb_web_lace_top03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w19}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w19 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w19}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w19 == 'tb_web_lace_vertical'"
                  id=""
                  :src="require(`@/assets/img/tb/${w19}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w19 == 'tb_web_front-lace_bottom01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w19}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w19 == 'tb_web_front-lace_bottom03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w19}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w19 == 'tb_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w19}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w19 == 'tb_w-19_base'"
                  id=""
                  :src="require(`@/assets/img/tb/${w19}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w19 == 'tb_web_frame_base-vertical02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w19}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                v-else
                  id=""
                  :src="require(`@/assets/img/tb/${w19}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-22'">
              <template v-for="w22 in tb_w_22" :key="w22">
                <img
                  v-if="w22 == 'tb_web_stitch_base02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w22}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w22 == 'tb_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w22}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w22 == 'tb_web_stitch_vertical01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w22}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w22 == 'tb_web_lace_base03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w22}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w22 == 'tb_web_lace_top03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w22}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w22 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w22}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w22 == 'tb_web_front-lace_bottom01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w22}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w22 == 'tb_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w22}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w22 == 'tb_web_frame_base03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w22}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w22 == 'tb_web_frame_base-vertical02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w22}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${w22}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-23'">
              <template v-for="w23 in tb_w_23" :key="w23">
                <img
                  v-if="w23 == 'tb_web_stitch_base02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w23}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w23 == 'tb_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w23}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w23 == 'tb_w-23_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${w23}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w23 == 'tb_web_lace_base03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w23}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w23 == 'tb_web_lace_top03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w23}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w23 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w23}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w23 == 'tb_w-23_front-lace'"
                  id=""
                  :src="require(`@/assets/img/tb/${w23}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w23 == 'tb_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w23}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w23 == 'tb_web_frame_base03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w23}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w23 == 'tb_w-23_base'"
                  id=""
                  :src="require(`@/assets/img/tb/${w23}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w23 == 'tb_w-23_base-vertical'"
                  id=""
                  :src="require(`@/assets/img/tb/${w23}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${w23}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-24'">
              <template v-for="w24 in tb_w_24" :key="w24">
                <img
                  v-if="w24 == 'tb_w-24_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${w24}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w24 == 'tb_web_lace_base02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w24}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w24 == 'tb_web_lace_top03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w24}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w24 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w24}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w24 == 'tb_w-24_front-lace'"
                  id=""
                  :src="require(`@/assets/img/tb/${w24}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w24 == 'tb_w-24_base'"
                  id=""
                  :src="require(`@/assets/img/tb/${w24}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /><img
                  v-else-if="w24 == 'tb_w-24_top'"
                  id=""
                  :src="require(`@/assets/img/tb/${w24}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${w24}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-27'">
              <template v-for="w27 in tb_w_27" :key="w27">
                <img
                  v-if="w27 == 'tb_web_stitch_base03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w27}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w27 == 'tb_web_stitch_top03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w27}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w27 == 'tb_w-27_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${w27}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w27 == 'tb_web_lace_base04'"
                  id=""
                  :src="require(`@/assets/img/tb/${w27}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w27 == 'tb_web_lace_top04'"
                  id=""
                  :src="require(`@/assets/img/tb/${w27}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w27 == 'tb_web_lace_base02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w27}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w27 == 'tb_w-27_front-lace'"
                  id=""
                  :src="require(`@/assets/img/tb/${w27}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w27 == 'tb_web_frame_top03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w27}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w27 == 'tb_web_frame_top04'"
                  id=""
                  :src="require(`@/assets/img/tb/${w27}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w27 == 'tb_web_frame_base04'"
                  id=""
                  :src="require(`@/assets/img/tb/${w27}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w27 == 'tb_w-27_base-vertical'"
                  id=""
                  :src="require(`@/assets/img/tb/${w27}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${w27}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-28'">
              <template v-for="w28 in tb_w_28" :key="w28">
                <img
                  v-if="w28 == 'tb_web_stitch_top03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w28}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w28 == 'tb_w-28_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${w28}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w28 == 'tb_web_stitch_base02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w28}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w28 == 'tb_web_lace_base03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w28}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w28 == 'tb_web_lace_top04'"
                  id=""
                  :src="require(`@/assets/img/tb/${w28}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w28 == 'tb_w-28_back-lace'"
                  id=""
                  :src="require(`@/assets/img/tb/${w28}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w28 == 'tb_web_front-lace_bottom01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w28}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w28 == 'tb_web_front-lace_bottom03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w28}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w28 == 'tb_web_frame_top03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w28}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w28 == 'tb_web_frame_top04'"
                  id=""
                  :src="require(`@/assets/img/tb/${w28}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w28== 'tb_web_frame_base03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w28}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w28 == 'tb_w-28_base'"
                  id=""
                  :src="require(`@/assets/img/tb/${w28}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${w28}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-29'">
              <template v-for="w29 in tb_w_29" :key="w29">
                <img
                  v-if="w29 == 'tb_web_stitch_base02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w29}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w29 == 'tb_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w29}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w29 == 'tb_web_stitch_vertical01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w29}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w29 == 'tb_web_lace_base03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w29}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w29 == 'tb_web_lace_top03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w29}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w29 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w29}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w29 == 'tb_web_front-lace_middle01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w29}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w29 == 'tb_web_front-lace_bottom05'"
                  id=""
                  :src="require(`@/assets/img/tb/${w29}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w29 == 'tb_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w29}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w29 == 'tb_web_frame_base03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w29}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w29 == 'tb_web_frame_base-vertical02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w29}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${w29}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-30'">
              <template v-for="w30 in tb_w_30" :key="w30">
                <img
                  v-if="w30 == 'tb_web_stitch_base02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w30}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w30 == 'tb_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w30}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w30 == 'tb_w-30_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${w30}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w30 == 'tb_web_lace_base03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w30}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w30 == 'tb_web_lace_top03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w30}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w30 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w30}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w30 == 'tb_web_front-lace_bottom01'"
                  id=""
                  :src="require(`@/assets/img/tb/${w30}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w30 == 'tb_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${w30}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w30 == 'tb_web_frame_base03'"
                  id=""
                  :src="require(`@/assets/img/tb/${w30}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w30 == 'tb_w-30_base-vertical'"
                  id=""
                  :src="require(`@/assets/img/tb/${w30}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${w30}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <!-- <template v-if="selected['web'] == 'W-T1'">
              <template v-for="t1 in tb_t_1" :key="t1">
                <img
                  v-if="t1 == 'tb_web_stitch_base01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t1}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t1 == 'tb_t-1_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${t1}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t1 == 'tb_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t1}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t1 == 'tb_web_lace_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${t1}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t1 == 'tb_web_lace_base01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t1}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t1 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t1}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t1 == 'tb_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t1}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t1 == 'tb_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t1}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t1 == 'tb_t-1_lining'"
                  id=""
                  :src="require(`@/assets/img/tb/${t1}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t1 == 'tb_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/tb/${t1}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${t1}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template> -->
            <template v-if="selected['web'] == 'W-T1'">
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_frame_base02_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_frame_top01_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_frame_base01_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_stitch_base01_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_stitch_top01_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_lace_top02_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_lace_base01_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${t1}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
                <template v-if="selected['gloveHand'] == '右投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_t-1_stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_t-1_lining_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                />
                </template>
                <template v-if="selected['gloveHand'] == '左投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_t-1_reflect-stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_t-1_reflect-lining_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                />
                </template>
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_lace_top01_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            <!-- <template v-if="selected['web'] == 'W-T2'">
              <template v-for="t2 in tb_t_2" :key="t2">
                <img
                  v-if="t2 == 'tb_t-2_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${t2}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t2 == 'tb_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t2}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t2 == 'tb_web_lace_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${t2}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t2 == 'tb_web_lace_base01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t2}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t2 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t2}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t2 == 'tb_t-2_front-lace'"
                  id=""
                  :src="require(`@/assets/img/tb/${t2}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t2 == 'tb_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t2}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t2 == 'tb_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t2}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t2 == 'tb_t-2_lining'"
                  id=""
                  :src="require(`@/assets/img/tb/${t2}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t2 == 'tb_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/tb/${t2}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${t2}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template> -->
            <template v-if="selected['web'] == 'W-T2'">
              <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_frame_base02_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_frame_top01_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_frame_base01_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_stitch_top01_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_lace_top02_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_lace_base01_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${t1}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
                <template v-if="selected['gloveHand'] == '右投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_t-2_stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_t-2_lining_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_t-2_front-lace_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                />
                </template>
                <template v-if="selected['gloveHand'] == '左投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_t-2_reflect-stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_t-2_reflect-lining_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_t-2_reflect-front-lace_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                />
                </template>
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_lace_top01_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            <!-- <template v-if="selected['web'] == 'W-T3'">
              <template v-for="t3 in tb_t_3" :key="t3">
                <img
                  v-if="t3 == 'tb_web_stitch_base01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t3}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t3 == 'tb_t-3_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${t3}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t3 == 'tb_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t3}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t3 == 'tb_web_lace_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${t3}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t3 == 'tb_web_lace_base01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t3}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t3 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t3}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t3 == 'tb_t-3_lining'"
                  id=""
                  :src="require(`@/assets/img/tb/${t3}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t3 == 'tb_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t3}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t3 == 'tb_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t3}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t3 == 'tb_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/tb/${t3}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${t3}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template> -->
            <template v-if="selected['web'] == 'W-T3'">
              <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_frame_base02_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_frame_top01_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_frame_base01_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_stitch_top01_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_stitch_base01_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_lace_top02_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_lace_base01_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${t1}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
                <template v-if="selected['gloveHand'] == '右投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_t-3_stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_t-3_lining_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                />
                </template>
                <template v-if="selected['gloveHand'] == '左投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_t-3_reflect-stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_t-3_reflect-lining_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                />
                </template>
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_lace_top01_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            <!-- <template v-if="selected['web'] == 'W-T4'">
              <template v-for="t4 in tb_t_4" :key="t4">
                <img
                  v-if="t4 == 'tb_t-4_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${t4}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t4 == 'tb_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t4}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t4 == 'tb_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${t4}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t4 == 'tb_web_lace_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${t4}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t4 == 'tb_web_lace_base01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t4}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t4 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t4}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t4 == 'tb_t-4_front-lace'"
                  id=""
                  :src="require(`@/assets/img/tb/${t4}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t4 == 'tb_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t4}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t4 == 'tb_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t4}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t4 == 'tb_t-4_lining'"
                  id=""
                  :src="require(`@/assets/img/tb/${t4}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t4 == 'tb_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/tb/${t4}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${t4}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template> -->
            <template v-if="selected['web'] == 'W-T4'">
              <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_frame_base02_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_frame_top01_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_frame_base01_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_stitch_top01_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_lace_top02_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_lace_base01_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${t1}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
                <template v-if="selected['gloveHand'] == '右投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_t-4_stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_t-4_lining_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_t-4_front-lace_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                />
                </template>
                <template v-if="selected['gloveHand'] == '左投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_t-4_reflect-stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_t-4_reflect-lining_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_t-4_reflect-front-lace_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                />
                </template>
                <img
                  id=""
                  :src="require(`@/assets/img/tb/tb_web_lace_top01_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            <template v-if="selected['web'] == 'W-T5'">
              <template v-for="t5 in tb_t_5" :key="t5">
                <img
                  v-if="t5 == 'tb_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${t5}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t5 == 'tb_t-5_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${t5}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t5 == 'tb_web_stitch_base03'"
                  id=""
                  :src="require(`@/assets/img/tb/${t5}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t5 == 'tb_web_lace_top03'"
                  id=""
                  :src="require(`@/assets/img/tb/${t5}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t5 == 'tb_web_lace_base04'"
                  id=""
                  :src="require(`@/assets/img/tb/${t5}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t5 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t5}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t5 == 'tb_web_front-lace_bottom01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t5}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t5 == 'tb_w-11_t-5_front-lace'"
                  id=""
                  :src="require(`@/assets/img/tb/${t5}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t5 == 'tb_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${t5}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t5 == 'tb_web_frame_base04'"
                  id=""
                  :src="require(`@/assets/img/tb/${t5}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t5 == 'tb_t-5_base'"
                  id=""
                  :src="require(`@/assets/img/tb/${t5}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t5 == 'tb_t-5_base-vertical'"
                  id=""
                  :src="require(`@/assets/img/tb/${t5}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${t5}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-T6'">
              <template v-for="t6 in tb_t_6" :key="t6">
                <img
                  v-if="t6 == 'tb_t-6_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${t6}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t6 == 'tb_web_stitch_top03'"
                  id=""
                  :src="require(`@/assets/img/tb/${t6}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t6 == 'tb_w-3_w-6_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${t6}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t6 == 'tb_web_stitch_base01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t6}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t6 == 'tb_web_lace_top04'"
                  id=""
                  :src="require(`@/assets/img/tb/${t6}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t6 == 'tb_web_lace_base01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t6}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t6 == 'tb_web_frame_top03'"
                  id=""
                  :src="require(`@/assets/img/tb/${t6}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t6 == 'tb_web_frame_top04'"
                  id=""
                  :src="require(`@/assets/img/tb/${t6}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t6 == 'tb_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t6}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t6 == 'tb_w-3_w-6_w-7_lining'"
                  id=""
                  :src="require(`@/assets/img/tb/${t6}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t6 == 'tb_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/tb/${t6}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${t6}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-T7'">
              <template v-for="t7 in tb_t_7" :key="t7">
                <img
                  v-if="t7 == 'tb_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t7}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t7 == 'tb_t-7_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${t7}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t7 == 'tb_web_lace_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${t7}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t7 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t7}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t7 == 'tb_t-7_front-lace'"
                  id=""
                  :src="require(`@/assets/img/tb/${t7}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t7 == 'tb_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t7}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t7 == 'tb_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t7}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t7 == 'tb_w-3_w-6_w-7_lining'"
                  id=""
                  :src="require(`@/assets/img/tb/${t7}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t7 == 'tb_t-7_base'"
                  id=""
                  :src="require(`@/assets/img/tb/${t7}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${t7}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-T8'">
              <template v-for="t8 in tb_t_8" :key="t8">
                <img
                  v-if="t8 == 'tb_web_stitch_top03'"
                  id=""
                  :src="require(`@/assets/img/tb/${t8}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t8 == 'tb_t-8_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${t8}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t8 == 'tb_web_lace_top04'"
                  id=""
                  :src="require(`@/assets/img/tb/${t8}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t8 == 'tb_web_front-lace_bottom06'"
                  id=""
                  :src="require(`@/assets/img/tb/${t8}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t8 == 'tb_t-8_front-lace'"
                  id=""
                  :src="require(`@/assets/img/tb/${t8}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t8 == 'tb_web_frame_top03'"
                  id=""
                  :src="require(`@/assets/img/tb/${t8}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t8 == 'tb_web_frame_top04'"
                  id=""
                  :src="require(`@/assets/img/tb/${t8}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t8 == 'tb_t-8_base'"
                  id=""
                  :src="require(`@/assets/img/tb/${t8}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                v-else
                  id=""
                  :src="require(`@/assets/img/tb/${t8}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-T9'">
              <template v-for="t9 in tb_t_9" :key="t9">
                <img
                  v-if="t9 == 'tb_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t9}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t9 == 'tb_t-9_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${t9}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t9 == 'tb_web_lace_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${t9}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t9 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t9}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t9 == 'tb_t-9_front-lace'"
                  id=""
                  :src="require(`@/assets/img/tb/${t9}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t9 == 'tb_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t9}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t9 == 'tb_t-9_base'"
                  id=""
                  :src="require(`@/assets/img/tb/${t9}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t9 == 'tb_t-9_base02'"
                  id=""
                  :src="require(`@/assets/img/tb/${t9}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${t9}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-T12' || selected['web'] == null ">
              <template v-for="t12 in tb_t_12" :key="t12">
                <img
                  v-if="t12 == 'tb_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${t12}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t12 == 'tb_t-12_stitch'"
                  id=""
                  :src="require(`@/assets/img/tb/${t12}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t12 == 'tb_web_lace_top03'"
                  id=""
                  :src="require(`@/assets/img/tb/${t12}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t12 == 'tb_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t12}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t12 == 'tb_web_front-lace_top01'"
                  id=""
                  :src="require(`@/assets/img/tb/${t12}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t12 == 'tb_t-12_front-lace'"
                  id=""
                  :src="require(`@/assets/img/tb/${t12}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t12 == 'tb_web_front-lace_bottom06'"
                  id=""
                  :src="require(`@/assets/img/tb/${t12}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t12 == 'tb_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/tb/${t12}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t12 == 'tb_t-12_base'"
                  id=""
                  :src="require(`@/assets/img/tb/${t12}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t12 == 'tb_t-12_lining'"
                  id=""
                  :src="require(`@/assets/img/tb/${t12}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/tb/${t12}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
          </div>
          <!-- 親指ここまで -->

          <!-- 背面ここから -->
          <div class="globe-position" v-if="isGlobeDirection == '背面'">
          <!-- 共通背面 -->
           <!-- 小指かけ -->
            <img
              id=""
              :src="require(`@/assets/img/bs/bs_shere-pinky-hanger_${selectedColorCon('littleFingerHanger')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          <!-- バック -->
          <template v-if="selected['backStyle'] == 'レギュラー' || selected['backStyle'] == null ">
            <template v-for="reg in bs_bk_reg" :key="reg">
              <img
                v-if="reg == 'bs_bk-reg_pinky-in'"
                id=""
                :src="require(`@/assets/img/bs/${reg}_${selectedColorCon('littleFingerIn')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="reg == 'bs_bk-reg_pinky-out'"
                id=""
                :src="require(`@/assets/img/bs/${reg}_${selectedColorCon('littleFingerOut')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="reg == 'bs_bk-reg_thumb-out'"
                id=""
                :src="require(`@/assets/img/bs/${reg}_${selectedColorCon('thumbIn')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="reg == 'bs_bk-reg_index-in'"
                id=""
                :src="require(`@/assets/img/bs/${reg}_${selectedColorCon('indexFingerIn')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="reg == 'bs_bk-reg_index-out'"
                id=""
                :src="require(`@/assets/img/bs/${reg}_${selectedColorCon('indexFingerOut')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="reg == 'bs_bk-reg_third-in'"
                id=""
                :src="require(`@/assets/img/bs/${reg}_${selectedColorCon('middleFingerIn')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="reg == 'bs_bk-reg_third-out'"
                id=""
                :src="require(`@/assets/img/bs/${reg}_${selectedColorCon('middleFingerOut')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="reg == 'bs_bk-reg_ft'"
                id=""
                :src="require(`@/assets/img/bs/${reg}_${selectedColorCon('catchColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="reg == 'bs_bk-reg_middle-in'"
                id=""
                :src="require(`@/assets/img/bs/${reg}_${selectedColorCon('thirdFingerIn')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="reg == 'bs_bk-reg_middle-out'"
                id=""
                :src="require(`@/assets/img/bs/${reg}_${selectedColorCon('thirdFingerOut')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <!-- <img
                v-else
                id=""
                :src="require(`@/assets/img/bs/${reg}_${selectedColorCon('mainColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              /> -->
            </template>
          </template>
          <template v-else-if="selected['backStyle'] == '王冠' ">
            <template v-for="crwn in bs_bk_crwn" :key="crwn">
              <img
                v-if="crwn == 'bs_bk-crwn_pinky'"
                id=""
                :src="require(`@/assets/img/bs/${crwn}_${selectedColorCon('littleFingerOut')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="crwn == 'bs_bk-crwn_thumb-out'"
                id=""
                :src="require(`@/assets/img/bs/${crwn}_${selectedColorCon('thumbIn')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="crwn == 'bs_bk-crwn_index-in'"
                id=""
                :src="require(`@/assets/img/bs/${crwn}_${selectedColorCon('indexFingerIn')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="crwn == 'bs_bk-crwn_index-middle'"
                id=""
                :src="require(`@/assets/img/bs/${crwn}_${selectedColorCon('indexFingerIn')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="crwn == 'bs_bk-crwn_index'"
                id=""
                :src="require(`@/assets/img/bs/${crwn}_${selectedColorCon('indexAndMiddleFinger')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="crwn == 'bs_bk-crwn_middle-third'"
                id=""
                :src="require(`@/assets/img/bs/${crwn}_${selectedColorCon('middleAndThirdFinger')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="crwn == 'bs_bk-crwn_ft'"
                id=""
                :src="require(`@/assets/img/bs/${crwn}_${selectedColorCon('catchColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="crwn == 'bs_bk-crwn_third-pinky'"
                id=""
                :src="require(`@/assets/img/bs/${crwn}_${selectedColorCon('thirdAndLittleFinger')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <!-- <img
                v-else
                id=""
                :src="require(`@/assets/img/bs/${crwn}_${selectedColorCon('mainColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              /> -->
            </template>
          </template>
          <template v-else-if="selected['backStyle'] == 'ライナーバック' ">
            <template v-for="linr in bs_bk_linr" :key="linr">
              <img
                v-if="linr == 'bs_bk-linr_pinky-all'"
                id=""
                :src="require(`@/assets/img/bs/${linr}_${selectedColorCon('littleFingerOut')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="linr == 'bs_bk-linr_thumb-index'"
                id=""
                :src="require(`@/assets/img/bs/${linr}_${selectedColorCon('thumbIndexAndMiddleFinger')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="linr == 'bs_bk-linr_middle-third'"
                id=""
                :src="require(`@/assets/img/bs/${linr}_${selectedColorCon('middleAndThirdFinger')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="linr == 'bs_bk-linr_index-out'"
                id=""
                :src="require(`@/assets/img/bs/${linr}_${selectedColorCon('indexFingerOut')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="linr == 'bs_bk-linr_third-in'"
                id=""
                :src="require(`@/assets/img/bs/${linr}_${selectedColorCon('middleFingerIn')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="linr == 'bs_bk-linr_third-out'"
                id=""
                :src="require(`@/assets/img/bs/${linr}_${selectedColorCon('middleFingerOut')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="linr == 'bs_bk-linr_ft'"
                id=""
                :src="require(`@/assets/img/bs/${linr}_${selectedColorCon('catchColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="linr == 'bs_bk-linr_third-pinky'"
                id=""
                :src="require(`@/assets/img/bs/${linr}_${selectedColorCon('thirdAndLittleFinger')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="linr == 'bs_bk-linr_middle-out'"
                id=""
                :src="require(`@/assets/img/bs/${linr}_${selectedColorCon('thirdFingerOut')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="linr == 'bs_bk-linr_stitch'"
                id=""
                :src="require(`@/assets/img/bs/${linr}_${selectedColorCon('stitchColor')}.png`)"
                :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
              />
              <img
                v-else-if="linr == 'bs_bk-linr_edge'"
                id=""
                :src="require(`@/assets/img/bs/${linr}_${selectedColorCon('hemLeather')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="linr == 'bs_bk-linr_blt'"
                id=""
                :src="require(`@/assets/img/bs/${linr}_${selectedColorCon('linerBackBeltColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="linr == 'bs_bk-linr_thumb-knot'"
                id=""
                :src="require(`@/assets/img/bs/${linr}_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="linr == 'bs_bk-linr_palm-lining'"
                id=""
                :src="require(`@/assets/img/bs/${linr}_${selectedColorCon('hiraura')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="linr == 'bs_bk-linr_welting'"
                id=""
                :src="require(`@/assets/img/bs/${linr}_${selectedColorCon('additional')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                v-else-if="linr == 'bs_bk-linr_palm-lining-lace'"
                id=""
                :src="require(`@/assets/img/bs/${linr}_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <!-- <img
              v-else-if="linr == 'bs_bk-linr_thumb_lbl-base'"
                id=""
                :src="require(`@/assets/img/bs/${linr}_${selectedColorCon('optionStandColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
              v-else-if="linr == 'bs_bk-linr_thumb_lbl-shadow'"
                id=""
                :src="require(`@/assets/img/bs/${linr}_${selectedColorCon('optionShadowColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
              v-else-if="linr == 'bs_bk-linr_thumb_lbl-main'"
                id=""
                :src="require(`@/assets/img/bs/${linr}_${selectedColorCon('optionMainColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              /> -->
              <!-- <img
                v-else
                id=""
                :src="require(`@/assets/img/bs/${linr}_${selectedColorCon('mainColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              /> -->
            </template>
          </template>

            <!-- ハミダシ -->
          <template v-if="selected['backStyle'] == 'レギュラー'">
            <template v-if="selected['beltType'] == 'レギュラー'">
            <img
              v-if="selected['typeName'] == 'NMA' || selected['typeName'] == 'NWA' || selected['typeName'] == 'NLA' || selected['typeName'] == 'KZN' || selected['typeName'] == 'NQA' || selected['typeName'] == 'GWA' || selected['typeName'] == 'GLA'"
              id=""
              :src="require(`@/assets/img/bs/bs_blt-reg_web_crotch_${selectedColorCon('catchColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <img
              v-if="selected['typeName'] == 'NMA' || selected['typeName'] == 'NWA' || selected['typeName'] == 'NLA' || selected['typeName'] == 'KZN' || selected['typeName'] == 'NQA' || selected['typeName'] == 'GWA' || selected['typeName'] == 'GLA'"
              id=""
              :src="require(`@/assets/img/bs/bs_crotch_${selectedColorCon('additional')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <img
            v-else
              id=""
              :src="require(`@/assets/img/bs/bs_crotch-none_${selectedColorCon('additional')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
          <template v-else-if="selected['backStyle'] == 'レギュラー' && selected['beltType'] == null">
            <img
              id=""
              :src="require(`@/assets/img/bs/bs_crotch-none_${selectedColorCon('additional')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            </template>
            <template v-else-if="selected['beltType'] == 'Tベルト'">
            <img
             v-if="selected['typeName'] == 'NMA' || selected['typeName'] == 'NWA' || selected['typeName'] == 'NLA' || selected['typeName'] == 'KZN' || selected['typeName'] == 'NQA' || selected['typeName'] == 'GWA' || selected['typeName'] == 'GLA'"
              id=""
              :src="require(`@/assets/img/bs/bs_blt-tbelt_crotch_${selectedColorCon('catchColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <img
             v-if="selected['typeName'] == 'NMA' || selected['typeName'] == 'NWA' || selected['typeName'] == 'NLA' || selected['typeName'] == 'KZN' || selected['typeName'] == 'NQA' || selected['typeName'] == 'GWA' || selected['typeName'] == 'GLA'"
              id=""
              :src="require(`@/assets/img/bs/bs_crotch_${selectedColorCon('additional')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <img
            v-else
              id=""
              :src="require(`@/assets/img/bs/bs_crotch-none_${selectedColorCon('additional')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            </template>
            <template v-else-if="selected['beltType'] == 'セパレート'">
            <img
             v-if="selected['typeName'] == 'NMA' || selected['typeName'] == 'NWA' || selected['typeName'] == 'NLA' || selected['typeName'] == 'KZN' || selected['typeName'] == 'NQA' || selected['typeName'] == 'GWA' || selected['typeName'] == 'GLA'"
              id=""
              :src="require(`@/assets/img/bs/bs_blt-sep_web_crotch_${selectedColorCon('catchColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <img
             v-if="selected['typeName'] == 'NMA' || selected['typeName'] == 'NWA' || selected['typeName'] == 'NLA' || selected['typeName'] == 'KZN' || selected['typeName'] == 'NQA' || selected['typeName'] == 'GWA' || selected['typeName'] == 'GLA'"
              id=""
              :src="require(`@/assets/img/bs/bs_crotch_${selectedColorCon('additional')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <img
            v-else-if = "selected['backStyle'] == null "
              id=""
              :src="require(`@/assets/img/bs/bs_crotch-none_${selectedColorCon('additional')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <img
            v-else
              id=""
              :src="require(`@/assets/img/bs/bs_crotch-none_${selectedColorCon('additional')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            </template>
            <template v-else-if="selected['beltType'] == '親指一体'">
            <img
             v-if="selected['typeName'] == 'NMA' || selected['typeName'] == 'NWA' || selected['typeName'] == 'NLA' || selected['typeName'] == 'KZN' || selected['typeName'] == 'NQA' || selected['typeName'] == 'GWA' || selected['typeName'] == 'GLA'"
              id=""
              :src="require(`@/assets/img/bs/bs_blt-reg_web_crotch_${selectedColorCon('catchColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <img
             v-if="selected['typeName'] == 'NMA' || selected['typeName'] == 'NWA' || selected['typeName'] == 'NLA' || selected['typeName'] == 'KZN' || selected['typeName'] == 'NQA' || selected['typeName'] == 'GWA' || selected['typeName'] == 'GLA'"
              id=""
              :src="require(`@/assets/img/bs/bs_crotch_${selectedColorCon('additional')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <img
            v-else
              id=""
              :src="require(`@/assets/img/bs/bs_crotch-none_${selectedColorCon('additional')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
        </template>
          <template v-else-if="selected['backStyle'] == '王冠' ">
            <img
              id=""
              :src="require(`@/assets/img/bs/bs_bk-crwn_welting_${selectedColorCon('additional')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>        

            <!-- ひも通し -->
            <template v-if="selected['backStrand'] == 'クロス' ">
              <img
                id=""
                :src="require(`@/assets/img/bs/bs_lace-cross_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                id=""
                :src="require(`@/assets/img/bs/bs_lace-share_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
            </template>
            <template v-else-if="selected['backStrand'] == 'ストレート' ">
              <img
                id=""
                :src="require(`@/assets/img/bs/bs_lace-st_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                id=""
                :src="require(`@/assets/img/bs/bs_lace-share_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
            </template>
            <template v-else-if="selected['backStrand'] == 'クロス×ストレート' ">
              <img
                id=""
                :src="require(`@/assets/img/bs/bs_lace-cross-st_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                id=""
                :src="require(`@/assets/img/bs/bs_lace-share_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
            </template>

            <!-- ベルト -->
            <!-- stitchの色修正 -->
            <template v-if="selected['beltType'] == 'レギュラー' || selected['beltType'] == null && selected['backStyle'] != 'ライナーバック'">
              <template v-for="reg in bs_blt_reg" :key="reg">
                <img
                  v-if="reg == 'bs_blt-reg_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${reg}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="reg == 'bs_blt-reg_band'"
                  id=""
                  :src="require(`@/assets/img/bs/${reg}_${selectedColorCon('bandColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else-if="reg == 'bs_blt-reg_lbl-shadow'"
                  id=""
                  :src="require(`@/assets/img/bs/${reg}_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="reg == 'bs_blt-reg_lbl-main'"
                  id=""
                  :src="require(`@/assets/img/bs/${reg}_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="reg == 'bs_blt-reg_lbl-base'"
                  id=""
                  :src="require(`@/assets/img/bs/${reg}_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
                <img
                  v-else-if="reg == 'bs_blt-reg_thumb-knot'"
                  id=""
                  :src="require(`@/assets/img/bs/${reg}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="reg == 'bs_blt-reg_edge'"
                  id=""
                  :src="require(`@/assets/img/bs/${reg}_${selectedColorCon('hemLeather')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="reg == 'bs_blt-reg_palm-lining'"
                  id=""
                  :src="require(`@/assets/img/bs/${reg}_${selectedColorCon('hiraura')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="reg == 'bs_blt-reg_web_crotch'"
                  id=""
                  :src="require(`@/assets/img/bs/${reg}_${selectedColorCon('catchColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="reg == 'bs_blt-reg_web_crotch-none'"
                  id=""
                  :src="require(`@/assets/img/bs/${reg}_${selectedColorCon('catchColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${reg}_red.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-else-if="selected['beltType'] == 'Tベルト' && selected['backStyle'] != 'ライナーバック'">
              <template v-for="tbelt in bs_blt_tbelt" :key="tbelt">
                <img
                  v-if="tbelt == 'bs_blt-tbelt_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${tbelt}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="tbelt == 'bs_blt-tbelt_edge'"
                  id=""
                  :src="require(`@/assets/img/bs/${tbelt}_${selectedColorCon('hemLeather')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="tbelt == 'bs_blt-tbelt_mark'"
                  id=""
                  :src="require(`@/assets/img/bs/${tbelt}_${selectedColorCon('treasureBelt')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else-if="tbelt == 'bs_blt-tbelt_lbl-shadow'"
                  id=""
                  :src="require(`@/assets/img/bs/${tbelt}_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="tbelt == 'bs_blt-tbelt_lbl-main'"
                  id=""
                  :src="require(`@/assets/img/bs/${tbelt}_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="tbelt == 'bs_blt-tbelt_lbl-base'"
                  id=""
                  :src="require(`@/assets/img/bs/${tbelt}_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
                <img
                  v-else-if="tbelt == 'bs_blt-tbelt_palm-lining'"
                  id=""
                  :src="require(`@/assets/img/bs/${tbelt}_${selectedColorCon('hiraura')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="tbelt == 'bs_blt-tbelt_crotch'"
                  id=""
                  :src="require(`@/assets/img/bs/${tbelt}_${selectedColorCon('catchColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="tbelt == 'bs_blt-tbelt_crotch-none'"
                  id=""
                  :src="require(`@/assets/img/bs/${tbelt}_${selectedColorCon('catchColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="tbelt == 'bs_blt-tbelt_thumb-knot'"
                  id=""
                  :src="require(`@/assets/img/bs/${tbelt}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${tbelt}_${selectedColorCon('treasureBelt')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-else-if="selected['beltType'] == 'セパレート' && selected['backStyle'] != 'ライナーバック'">
              <template v-for="sep in bs_blt_sep" :key="sep">
                <img
                  v-if="sep == 'bs_blt-sep_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${sep}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="sep == 'bs_blt-sep_band'"
                  id=""
                  :src="require(`@/assets/img/bs/${sep}_${selectedColorCon('bandColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="sep == 'bs_blt-sep_edge'"
                  id=""
                  :src="require(`@/assets/img/bs/${sep}_${selectedColorCon('hemLeather')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="sep == 'bs_blt-sep_edge-lace'"
                  id=""
                  :src="require(`@/assets/img/bs/${sep}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else-if="sep == 'bs_blt-sep_lbl-shadow'"
                  id=""
                  :src="require(`@/assets/img/bs/${sep}_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="sep == 'bs_blt-sep_lbl-main'"
                  id=""
                  :src="require(`@/assets/img/bs/${sep}_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="sep == 'bs_blt-sep_lbl-base'"
                  id=""
                  :src="require(`@/assets/img/bs/${sep}_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
                <img
                  v-else-if="sep == 'bs_blt-sep_palm-lining'"
                  id=""
                  :src="require(`@/assets/img/bs/${sep}_${selectedColorCon('hiraura')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="sep == 'bs_blt-sep_web_crotch'"
                  id=""
                  :src="require(`@/assets/img/bs/${sep}_${selectedColorCon('catchColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="sep == 'bs_blt-sep_web_crotch-none'"
                  id=""
                  :src="require(`@/assets/img/bs/${sep}_${selectedColorCon('catchColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${sep}_red.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-else-if="selected['beltType'] == '親指一体' && selected['backStyle'] != 'ライナーバック'">
              <template v-for="lbl in bs_blt_tmb_lbl" :key="lbl">
                <img
                  v-if="lbl == 'bs_blt-tmb_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${lbl}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <!-- <img
                  v-else-if="lbl == 'bs_blt-tmb_lbl-shadow'"
                  id=""
                  :src="require(`@/assets/img/bs/${lbl}_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="lbl == 'bs_blt-tmb_lbl-main'"
                  id=""
                  :src="require(`@/assets/img/bs/${lbl}_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="lbl == 'bs_blt-tmb_lbl-base'"
                  id=""
                  :src="require(`@/assets/img/bs/${lbl}_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
                <img
                  v-else-if="lbl == 'bs_blt-tmb_thumb-knot'"
                  id=""
                  :src="require(`@/assets/img/bs/${lbl}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="lbl == 'bs_blt-tmb_edge'"
                  id=""
                  :src="require(`@/assets/img/bs/${lbl}_${selectedColorCon('hemLeather')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="lbl == 'bs_blt-tmb_palm-lining'"
                  id=""
                  :src="require(`@/assets/img/bs/${lbl}_${selectedColorCon('hiraura')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="lbl == 'bs_blt-reg_web_crotch'"
                  id=""
                  :src="require(`@/assets/img/bs/${lbl}_${selectedColorCon('catchColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="lbl == 'bs_blt-reg_web_crotch-none'"
                  id=""
                  :src="require(`@/assets/img/bs/${lbl}_${selectedColorCon('catchColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${lbl}_red.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>

            <!-- ラベル -->
              <template v-if="selected['beltType'] == 'レギュラー' || selected['beltType'] == null && selected['backStyle'] != 'ライナーバック'">
                <template v-if="selected['gloveHand'] == '右投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-reg_lbl-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-reg_lbl-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-reg_lbl-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
              <template v-else-if="selected['gloveHand'] == '左投げ' && selected['backStyle'] != 'ライナーバック'">
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-reg_lbl_reflect-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-reg_lbl_reflect-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-reg_lbl_reflect-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                /> 
              </template>
              </template>
              <template v-else-if="selected['beltType'] == '親指一体'">
                <template v-if="selected['gloveHand'] == '右投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-tmb_lbl-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                  <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-tmb_lbl-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-tmb_lbl-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
              <template v-else-if="selected['gloveHand'] == '左投げ'">
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-tmb_lbl_reflect-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                  <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-tmb_lbl_reflect-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-tmb_lbl_reflect-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
              </template>
              <template v-else-if="selected['beltType'] == 'セパレート'">
                <template v-if="selected['gloveHand'] == '右投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-sep_lbl-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                  <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-sep_lbl-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-sep_lbl-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
              <template v-else-if="selected['gloveHand'] == '左投げ'">
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-sep_lbl_reflect-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                  <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-sep_lbl_reflect-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-sep_lbl_reflect-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
            </template>
            <template v-else-if="selected['beltType'] == 'Tベルト'">
                <template v-if="selected['gloveHand'] == '右投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-tbelt_lbl-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                  <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-tbelt_lbl-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-tbelt_lbl-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
              <template v-else-if="selected['gloveHand'] == '左投げ'">
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-tbelt_lbl_reflect-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                  <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-tbelt_lbl_reflect-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_blt-tbelt_lbl_reflect-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
            </template>
            <template v-else-if="selected['backStyle'] == 'ライナーバック' && selected['labelPosition'] == '親指側'">
                <template v-if="selected['gloveHand'] == '右投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_bk-linr_thumb_lbl-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                  <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_bk-linr_thumb_lbl-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_bk-linr_thumb_lbl-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
              <template v-else-if="selected['gloveHand'] == '左投げ'">
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_bk-linr_thumb_lbl_reflect-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                  <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_bk-linr_thumb_lbl_reflect-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_bk-linr_thumb_lbl_reflect-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
            </template>
            <template v-else-if="selected['backStyle'] == 'ライナーバック' && selected['labelPosition'] == '小指側'">
                <template v-if="selected['gloveHand'] == '右投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_bk-linr_pinky_lbl-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                  <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_bk-linr_pinky_lbl-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_bk-linr_pinky_lbl-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
              <template v-else-if="selected['gloveHand'] == '左投げ'">
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_bk-linr_pinky_lbl_reflect-base_${selectedColorCon('optionStandColor')}.png`)"
                  class="order-center-image position-all"
                />
                  <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_bk-linr_pinky_lbl_reflect-shadow_${selectedColorCon('optionShadowColor')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_bk-linr_pinky_lbl_reflect-main_${selectedColorCon('optionMainColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
            </template>
            <!-- 共通前面 -->
            <img
              id=""
              :src="require(`@/assets/img/bs/bs_share-lace_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <img
              id=""
              :src="require(`@/assets/img/bs/bs_share-thumb-hanger_${selectedColorCon('thumbHanger')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <template v-if="selected['beltType'] != 'セパレート' && selected['backStyle'] != 'ライナーバック' ">
              <img
              id=""
              :src="require(`@/assets/img/bs/bs_blt_share-edge-lace_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            </template>

            <!-- 指アテ -->
            <template v-if="selected['finger'] == '指アテ・人差し指' && selected['beltType'] != 'Tベルト' && selected['beltType'] != 'セパレート' ">
              <template v-for="bfpi in bs_finger_pad_index" :key="bfpi">
                <img
                  v-if="bfpi == 'bs_finger-pad_index_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfpi}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="bfpi == 'bs_finger-pad_index_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfpi}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template>
            <template v-if="selected['finger'] == '指アテ・人差し指' && selected['beltType'] == 'Tベルト' ">
              <template v-for="bfpit in bs_finger_pad_index_tbelt" :key="bfpit">
                <img
                  v-if="bfpit == 'bs_finger-pad_index-tbelt_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfpit}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="bfpit == 'bs_finger-pad_index-tbelt_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfpit}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template>
            <template v-if="selected['finger'] == '指アテ・人差し指'&& selected['beltType'] == 'セパレート' ">
              <template v-for="bfpis in bs_finger_pad_index_sep" :key="bfpis">
                <img
                  v-if="bfpis == 'bs_finger-pad_index-sep_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfpis}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="bfpis == 'bs_finger-pad_index-sep_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfpis}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template>
            <template v-if="selected['finger'] == 'ヘリ無し指アテ・人差し指' && selected['beltType'] != 'Tベルト' && selected['beltType'] != 'セパレート'">
              <template v-for="bfpni in bs_finger_pad_none_index" :key="bfpni">
                <img
                  v-if="bfpni == 'bs_finger-pad-none_index_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfpni}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="bfpni == 'bs_finger-pad-none_index_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfpni}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
              <img
                  v-if="tbelt"
                  id=""
                  :src="require(`@/assets/img/bs/bs_finger-pad-none_index-tbelt_stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-if="sep"
                  id=""
                  :src="require(`@/assets/img/bs/bs_finger-pad-none_index-sep_stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
            </template>
              <template v-if="selected['finger'] == 'ヘリ無し指アテ・人差し指' && selected['beltType'] == 'Tベルト'">
              <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_finger-pad-none_index_base_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_finger-pad-none_index-tbelt_stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
              </template>
              <template v-if="selected['finger'] == 'ヘリ無し指アテ・人差し指' && selected['beltType'] == 'セパレート'">
              <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_finger-pad-none_index_base_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_finger-pad-none_index-sep_stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
              </template>
            <template v-if="selected['finger'] == '指アテ・中指（+5,500円）' && selected['beltType'] != 'Tベルト' && selected['beltType'] != 'セパレート' ">
              <template v-for="bfpm in bs_finger_pad_middle" :key="bfpm">
                <img
                  v-if="bfpm == 'bs_finger-pad_middle_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfpm}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="bfpm == 'bs_finger-pad_middle_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfpm}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template>
            <template v-if="selected['finger'] == '指アテ・中指（+5,500円）'&& selected['beltType'] == 'Tベルト' ">
              <template v-for="bfpmt in bs_finger_pad_middle_tbelt" :key="bfpmt">
                <img
                  v-if="bfpmt == 'bs_finger-pad_middle-tbelt_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfpmt}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="bfpmt == 'bs_finger-pad_middle-tbelt_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfpmt}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template>
            <template v-if="selected['finger'] == '指アテ・中指（+5,500円）'&& selected['beltType'] == 'セパレート' ">
              <template v-for="bfpms in bs_finger_pad_middle_sep" :key="bfpms">
                <img
                  v-if="bfpms == 'bs_finger-pad_middle-sep_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfpms}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="bfpms == 'bs_finger-pad_middle-sep_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfpms}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template>
            <template v-if="selected['finger'] == '指アテ・中指（+5,500円）'&& selected['beltType'] == 'Tベルト' ">
              <template v-for="bfpmt in bs_finger_pad_middle_tbelt" :key="bfpmt">
                <img
                  v-if="bfpmt == 'bs_finger-pad_middle-tbelt_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfpmt}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="bfpmt == 'bs_finger-pad_middle-tbelt_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfpmt}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template>
            <template v-if="selected['finger'] == '指アテ・中指（+5,500円）'&& selected['beltType'] == 'セパレート' ">
              <template v-for="bfpms in bs_finger_pad_middle_sep" :key="bfpms">
                <img
                  v-if="bfpms == 'bs_finger-pad_middle-sep_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfpms}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="bfpms == 'bs_finger-pad_middle-sep_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfpms}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template>
            <template v-if="selected['finger'] == 'ヘリ無し指アテ・中指（+5,500円）' ">
              <template v-for="bfpnm in bs_finger_pad_none_middle" :key="bfpnm">
                <img
                  v-if="bfpnm == 'bs_finger-pad-none_middle-sep_stitch'&& selected['beltType'] == 'セパレート' "
                  id=""
                  :src="require(`@/assets/img/bs/${bfpnm}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="bfpnm == 'bs_finger-pad-none_middle-tbelt_stitch'&& selected['beltType'] == 'Tベルト' "
                  id=""
                  :src="require(`@/assets/img/bs/${bfpnm}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="bfpnm == 'bs_finger-pad-none_middle_stitch' && selected['beltType'] == 'レギュラー' "
                  id=""
                  :src="require(`@/assets/img/bs/${bfpnm}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="bfpnm == 'bs_finger-pad-none_middle_stitch' && selected['beltType'] == '親指一体' "
                  id=""
                  :src="require(`@/assets/img/bs/${bfpnm}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="bfpnm == 'bs_finger-pad-none_middle_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfpnm}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template>
            <template v-if="selected['finger'] == '指カバー・人差し指' ">
              <template v-for="bfci in bs_finger_cov_index" :key="bfci">
                <img
                  v-if="bfci == 'bs_finger-cov_index_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfci}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="bfci == 'bs_finger-cov_index_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfci}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template>
            <template v-if="selected['finger'] == '指カバー・中指（+5,500円）' ">
              <template v-for="bfcm in bs_finger_cov_middle" :key="bfcm">
                <img
                  v-if="bfcm == 'bs_finger-cov_middle_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfcm}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="bfcm == 'bs_finger-cov_middle_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfcm}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template>
            <template v-if="selected['finger'] == '先出し指カバー・人差し指中指間（+5,500円）' ">
              <template v-for="bfocb in bs_finger_opn_cov_between" :key="bfocb">
                <img
                  v-if="bfocb == 'bs_finger-opn-cov_between_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfocb}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="bfocb == 'bs_finger-opn-cov_between_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfocb}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template>
            <template v-if="selected['finger'] == '先出し指カバー・人差し指' ">
              <template v-for="bfoci in bs_finger_opn_cov_index" :key="bfoci">
                <img
                  v-if="bfoci == 'bs_finger-opn-cov_index_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfoci}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="bfoci == 'bs_finger-opn-cov_index_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfoci}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template>
            <template v-if="selected['finger'] == '先出し指カバー・中指（+5,500円）' ">
              <template v-for="bfocm in bs_finger_opn_cov_middle" :key="bfocm">
                <img
                  v-if="bfocm == 'bs_finger-opn-cov_middle_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfocm}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="bfocm == 'bs_finger-opn-cov_middle_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${bfocm}_${selectedColorCon('fingerCoverColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template>

            <!-- ウェブ -->
            <template v-if="selected['web'] == 'W-3'">
              <template v-for="w3 in bs_w_3" :key="w3">
                <img
                  v-if="w3 == 'bs_w-3_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${w3}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w3 == 'bs_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/bs/${w3}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w3 == 'bs_web_stitch_base01'"
                  id=""
                  :src="require(`@/assets/img/bs/${w3}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w3 == 'bs_web_lace_top01' || w3 == 'bs_web_lace_top02' || w3 == 'bs_web_lace_base01'"
                  id=""
                  :src="require(`@/assets/img/bs/${w3}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w3 == 'bs_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w3}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w3 == 'bs_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/bs/${w3}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w3 == 'bs_w-3_w-7_lining'"
                  id=""
                  :src="require(`@/assets/img/bs/${w3}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w3 == 'bs_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/bs/${w3}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${w3}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-5'">
              <template v-for="w5 in bs_w_5" :key="w5">
                <img
                  v-if="w5 == 'bs_web_stitch_base01'"
                  id=""
                  :src="require(`@/assets/img/bs/${w5}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w5 == 'bs_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/bs/${w5}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w5 == 'bs_web_lace_top01' || w5 == 'bs_web_lace_top02' || w5 == 'bs_web_lace_base01'"
                  id=""
                  :src="require(`@/assets/img/bs/${w5}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w5 == 'bs_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w5}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w5 == 'bs_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/bs/${w5}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w5 == 'bs_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/bs/${w5}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${w5}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-6'">
              <template v-for="w6 in bs_w_6" :key="w6">
                <img
                  v-if="w6 == 'bs_web_stitch_base02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w6}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w6 == 'bs_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w6}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w6 == 'bs_web_stitch_vertical01'"
                  id=""
                  :src="require(`@/assets/img/bs/${w6}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w6 == 'bs_web_lace_base03' || w6 == 'bs_web_lace_top03' || w6 == 'bs_web_lace_top01' || w6 == 'bs_web_lace_vertical' || w6 == 'bs_web_front-lace_middle01' || w6 == 'bs_web_front-lace_bottom01' || w6 == 'bs_web_front-lace_bottom02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w6}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w6 == 'bs_web_frame_base03'"
                  id=""
                  :src="require(`@/assets/img/bs/${w6}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w6 == 'bs_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w6}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w6 == 'bs_web_frame_base-vertical02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w6}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${w6}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-8'">
              <template v-for="w8 in bs_w_8" :key="w8">
                <img
                  v-if="w8 == 'bs_web_stitch_base02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w8}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w8 == 'bs_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w8}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w8 == 'bs_web_stitch_vertical02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w8}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w8 == 'bs_web_lace_base03' || w8 == 'bs_web_lace_top03' || w8 == 'bs_web_lace_top01' || w8 == 'bs_web_lace_vertical' || w8 == 'bs_w-8_front-lace'"
                  id=""
                  :src="require(`@/assets/img/bs/${w8}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w8 == 'bs_web_frame_base03'"
                  id=""
                  :src="require(`@/assets/img/bs/${w8}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w8 == 'bs_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w8}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w8 == 'bs_web_frame_base-vertical02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w8}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${w8}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-10'">
              <template v-for="w10 in bs_w_10" :key="w10">
                <img
                  v-if="w10 == 'bs_web_stitch_base02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w10}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w10 == 'bs_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w10}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w10 == 'bs_web_stitch_vertical02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w10}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w10 == 'bs_web_lace_base03' || w10 == 'bs_web_lace_top03' || w10 == 'bs_web_lace_top01' || w10 == 'bs_web_lace_vertical' || w10 == 'bs_web_front-lace_bottom01' || w10 == 'bs_web_front-lace_bottom05'"
                  id=""
                  :src="require(`@/assets/img/bs/${w10}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w10 == 'bs_web_frame_base03'"
                  id=""
                  :src="require(`@/assets/img/bs/${w10}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w10 == 'bs_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w10}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w10 == 'bs_web_frame_base-vertical02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w10}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${w10}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-11'">
              <template v-for="w11 in bs_w_11" :key="w11">
                <img
                  v-if="w11 == 'bs_web_stitch_base03'"
                  id=""
                  :src="require(`@/assets/img/bs/${w11}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w11 == 'bs_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w11}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w11 == 'bs_w-11_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${w11}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w11 == 'bs_web_lace_top03' || w11 == 'bs_web_lace_top01' || w11 == 'bs_web_lace_base02' || w11 == 'bs_w-11_front-lace' || w11 == 'bs_web_lace_base04'"
                  id=""
                  :src="require(`@/assets/img/bs/${w11}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w11 == 'bs_web_frame_base04'"
                  id=""
                  :src="require(`@/assets/img/bs/${w11}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w11 == 'bs_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w11}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w11 == 'bs_w-11_base-vertical'"
                  id=""
                  :src="require(`@/assets/img/bs/${w11}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${w11}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-12'">
              <template v-for="w12 in bs_w_12" :key="w12">
                <img
                  v-if="w12 == 'bs_w-12_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${w12}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w12 == 'bs_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/bs/${w12}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w12 == 'bs_w-12_back-lace' || w12 == 'bs_web_lace_top01' || w12 == 'bs_web_lace_top02' || w12 == 'bs_web_front-lace_top02' || w12 == 'bs_web_lace_base01'"
                  id=""
                  :src="require(`@/assets/img/bs/${w12}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w12 == 'bs_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w12}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w12 == 'bs_w-12_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${w12}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w12 == 'bs_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/bs/${w12}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${w12}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-13'">
              <template v-for="w13 in bs_w_13" :key="w13">
                <img
                  v-if="w13 == 'bs_w-13_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${w13}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w13 == 'bs_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/bs/${w13}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w13 == 'bs_web_lace_top01' || w13 == 'bs_web_lace_top02' || w13 == 'bs_w-13_back-lace' || w13 == 'bs_w-13_front-lace' || w13 == 'bs_web_front-lace_top02' || w13 == 'bs_web_lace_base01'"
                  id=""
                  :src="require(`@/assets/img/bs/${w13}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w13 == 'bs_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w13}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w13 == 'bs_w-13_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${w13}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w13 == 'bs_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/bs/${w13}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${w13}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-14'">
              <template v-for="w14 in bs_w_14" :key="w14">
                <img
                  v-if="w14 == 'bs_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w14}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w14 == 'bs_web_stitch_vertical03'"
                  id=""
                  :src="require(`@/assets/img/bs/${w14}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w14 == 'bs_web_lace_top03' || w14 == 'bs_web_lace_top01' || w14 == 'bs_w-14_front-lace' || w14 == 'bs_web_front-lace_top01'"
                  id=""
                  :src="require(`@/assets/img/bs/${w14}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w14 == 'bs_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w14}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w14 == 'bs_web_frame_base-vertical01'"
                  id=""
                  :src="require(`@/assets/img/bs/${w14}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${w14}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-15'">
              <template v-for="w15 in bs_w_15" :key="w15">
                <img
                  v-if="w15 == 'bs_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w15}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w15 == 'bs_web_stitch_vertical03'"
                  id=""
                  :src="require(`@/assets/img/bs/${w15}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w15 == 'bs_web_lace_top03' || w15 == 'bs_web_lace_top01' || w15 == 'bs_w-15_front-lace' || w15 == 'bs_web_front-lace_bottom06'"
                  id=""
                  :src="require(`@/assets/img/bs/${w15}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w15 == 'bs_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w15}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w15 == 'bs_web_frame_base-vertical01'"
                  id=""
                  :src="require(`@/assets/img/bs/${w15}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${w15}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-16'">
              <template v-for="w16 in bs_w_16" :key="w16">
                <img
                  v-if="w16 == 'bs_w-16_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${w16}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w16 == 'bs_w-16_front-lace' || w16 == 'bs_web_front-lace_bottom06'"
                  id=""
                  :src="require(`@/assets/img/bs/${w16}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-if="w16 == 'bs_w-16_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${w16}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-if="w16 == 'bs_w-16_edge'"
                  id=""
                  :src="require(`@/assets/img/bs/${w16}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${w16}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-17'">
              <template v-for="w17 in bs_w_17" :key="w17">
                <img
                  v-if="w17 == 'bs_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w17}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w17 == 'bs_web_stitch_vertical03'"
                  id=""
                  :src="require(`@/assets/img/bs/${w17}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w17 == 'bs_web_lace_top03' || w17 == 'bs_web_lace_top01' || w17 == 'bs_w-17_front-lace' || w17 == 'bs_web_front-lace_top01' || w17 == 'bs_web_front-lace_bottom06'"
                  id=""
                  :src="require(`@/assets/img/bs/${w17}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w17 == 'bs_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w17}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w17 == 'bs_web_frame_base-vertical01'"
                  id=""
                  :src="require(`@/assets/img/bs/${w17}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${w17}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-19'">
              <template v-for="w19 in bs_w_19" :key="w19">
                <img
                  v-if="w19 == 'bs_w-19_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${w19}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w19 == 'bs_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w19}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w19 == 'bs_web_stitch_vertical02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w19}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w19 == 'bs_w-19_back-lace' || w19 == 'bs_web_lace_top03' || w19 == 'bs_web_lace_top01' || w19 == 'bs_web_lace_vertical' || w19 == 'bs_web_front-lace_bottom04' || w19 == 'bs_web_front-lace_bottom01' || w19 == 'bs_web_front-lace_bottom02' || w19 == 'bs_web_front-lace_bottom03'"
                  id=""
                  :src="require(`@/assets/img/bs/${w19}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w19 == 'bs_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w19}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w19 == 'bs_w-19_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${w19}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w19 == 'bs_web_frame_base-vertical02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w19}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${w19}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-22'">
              <template v-for="w22 in bs_w_22" :key="w22">
                <img
                  v-if="w22 == 'bs_web_stitch_base02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w22}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w22 == 'bs_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w22}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w22 == 'bs_web_stitch_vertical01'"
                  id=""
                  :src="require(`@/assets/img/bs/${w22}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w22 == 'bs_web_lace_top03' || w22 == 'bs_web_lace_top01' || w22 == 'bs_web_front-lace_bottom01' || w22 == 'bs_web_front-lace_bottom02' || w22 == 'bs_web_lace_base03'"
                  id=""
                  :src="require(`@/assets/img/bs/${w22}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w22 == 'bs_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w22}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w22 == 'bs_web_frame_base03'"
                  id=""
                  :src="require(`@/assets/img/bs/${w22}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w22 == 'bs_web_frame_base-vertical02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w22}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${w22}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-23'">
              <template v-for="w23 in bs_w_23" :key="w23">
                <img
                  v-if="w23 == 'bs_web_stitch_base02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w23}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w23 == 'bs_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w23}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w23 == 'bs_w-23_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${w23}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w23 == 'bs_web_lace_base03' || w23 == 'bs_web_lace_top01' || w23 == 'bs_web_lace_top03' || w23 == 'bs_w-23_back-lace' || w23 == 'bs_w-23_front-lace'"
                  id=""
                  :src="require(`@/assets/img/bs/${w23}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w23 == 'bs_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w23}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w23 == 'bs_web_frame_base03'"
                  id=""
                  :src="require(`@/assets/img/bs/${w23}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w23 == 'bs_w-23_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${w23}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w23 == 'bs_w-23_base-vertical'"
                  id=""
                  :src="require(`@/assets/img/bs/${w23}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${w23}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-24'">
              <template v-for="w24 in bs_w_24" :key="w24">
                <img
                  v-if="w24 == 'bs_w-24_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${w24}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w24 == 'bs_w-24_back-lace' || w24 == 'bs_web_lace_top01' || w24 == 'bs_web_lace_base02' || w24 == 'bs_w-24_front-lace'"
                  id=""
                  :src="require(`@/assets/img/bs/${w24}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w24 == 'bs_w-24_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${w24}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w24 == 'bs_w-24_top'"
                  id=""
                  :src="require(`@/assets/img/bs/${w24}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${w24}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-27'">
              <template v-for="w27 in bs_w_27" :key="w27">
                <img
                  v-if="w27 == 'bs_web_stitch_base03'"
                  id=""
                  :src="require(`@/assets/img/bs/${w27}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w27 == 'bs_web_stitch_top03'"
                  id=""
                  :src="require(`@/assets/img/bs/${w27}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w27 == 'bs_w-27_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${w27}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w27 == 'bs_web_lace_base04' || w27 == 'bs_web_lace_top04' || w27 == 'bs_web_lace_base02' || w27 == 'bs_w-27_front-lace'"
                  id=""
                  :src="require(`@/assets/img/bs/${w27}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w27 == 'bs_web_frame_top03'"
                  id=""
                  :src="require(`@/assets/img/bs/${w27}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w27 == 'bs_web_frame_top04'"
                  id=""
                  :src="require(`@/assets/img/bs/${w27}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w27 == 'bs_web_frame_base04'"
                  id=""
                  :src="require(`@/assets/img/bs/${w27}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w27 == 'bs_w-27_base-vertical'"
                  id=""
                  :src="require(`@/assets/img/bs/${w27}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${w27}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-28'">
              <template v-for="w28 in bs_w_28" :key="w28">
                <img
                  v-if="w28 == 'bs_web_stitch_top03'"
                  id=""
                  :src="require(`@/assets/img/bs/${w28}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w28 == 'bs_w-28_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${w28}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w28 == 'bs_web_lace_top04' || w28 == 'bs_w-28_back-lace' || w28 == 'bs_web_lace_base02' || w28 == 'bs_web_front-lace_bottom04' || w28 == 'bs_w-28_front-lace'  || w28 == 'bs_web_front-lace_bottom01'  || w28 == 'bs_web_front-lace_bottom02'  || w28 == 'bs_web_front-lace_bottom03'"
                  id=""
                  :src="require(`@/assets/img/bs/${w28}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w28 == 'bs_web_frame_top03'"
                  id=""
                  :src="require(`@/assets/img/bs/${w28}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w28 == 'bs_web_frame_top04'"
                  id=""
                  :src="require(`@/assets/img/bs/${w28}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w28 == 'bs_w-28_base-horizontal'"
                  id=""
                  :src="require(`@/assets/img/bs/${w28}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w28 == 'bs_w-28_base-vertical'"
                  id=""
                  :src="require(`@/assets/img/bs/${w28}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${w28}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-29'">
              <template v-for="w29 in bs_w_29" :key="w29">
                <img
                  v-if="w29 == 'bs_web_stitch_base02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w29}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w29 == 'bs_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w29}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w29 == 'bs_web_stitch_vertical01'"
                  id=""
                  :src="require(`@/assets/img/bs/${w29}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w29 == 'bs_web_lace_base03' || w29 == 'bs_web_lace_top03' || w29 == 'bs_web_lace_top01' || w29 == 'bs_web_front-lace_middle01' || w29 == 'bs_web_front-lace_bottom05'"
                  id=""
                  :src="require(`@/assets/img/bs/${w29}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w29 == 'bs_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w29}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w29 == 'bs_web_frame_base03'"
                  id=""
                  :src="require(`@/assets/img/bs/${w29}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w29 == 'bs_web_frame_base-vertical02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w29}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${w29}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-30'">
              <template v-for="w30 in bs_w_30" :key="w30">
                <img
                  v-if="w30 == 'bs_web_stitch_base02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w30}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w30 == 'bs_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w30}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w30 == 'bs_w-30_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${w30}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w30 == 'bs_web_lace_base03' || w30 == 'bs_web_lace_top03' || w30 == 'bs_web_lace_top01' || w30 == 'bs_web_front-lace_bottom01' || w30 == 'bs_web_front-lace_bottom02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w30}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w30 == 'bs_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${w30}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w30 == 'bs_web_frame_base03'"
                  id=""
                  :src="require(`@/assets/img/bs/${w30}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w30 == 'bs_w-30_base-vertical'"
                  id=""
                  :src="require(`@/assets/img/bs/${w30}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${w30}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <!-- <template v-if="selected['web'] == 'W-T1'">
              <template v-for="t1 in bs_t_1" :key="t1">
                <img
                  v-if="t1 == 'bs_web_stitch_base01'"
                  id=""
                  :src="require(`@/assets/img/bs/${t1}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t1 == 'bs_t-1_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${t1}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t1 == 'bs_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/bs/${t1}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t1 == 'bs_web_lace_top01' || t1 == 'bs_web_lace_top02' || t1 == 'bs_web_lace_base01'"
                  id=""
                  :src="require(`@/assets/img/bs/${t1}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t1 == 'bs_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/bs/${t1}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t1 == 'bs_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/bs/${t1}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t1 == 'bs_t-1_lining'"
                  id=""
                  :src="require(`@/assets/img/bs/${t1}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t1 == 'bs_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/bs/${t1}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${t1}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template> -->
            <template v-if="selected['web'] == 'W-T1'">
              <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_frame_base02_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_frame_base01_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_frame_top01_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_stitch_top01_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_lace_top01_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_lace_top02_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_stitch_base01_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_lace_base01_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <template v-if="selected['gloveHand'] == '右投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_t-1_lining_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_t-1_stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${t1}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
              <template v-if="selected['gloveHand'] == '左投げ'">
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_t-1_reflect-lining_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_t-1_reflect-stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
              </template>
            </template>
            <!-- <template v-if="selected['web'] == 'W-T2'">
              <template v-for="t2 in bs_t_2" :key="t2">
                <img
                  v-if="t2 == 'bs_t-2_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${t2}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t2 == 'bs_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/bs/${t2}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t2 == 'bs_web_lace_top01' || t2 == 'bs_web_lace_top02' || t2 == 'bs_web_lace_base01' || t2 == 'bs_t-2_front-lace'"
                  id=""
                  :src="require(`@/assets/img/bs/${t2}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t2 == 'bs_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/bs/${t2}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t2 == 'bs_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/bs/${t2}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t2 == 'bs_t-2_lining'"
                  id=""
                  :src="require(`@/assets/img/bs/${t2}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t2 == 'bs_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/bs/${t2}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${t2}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template> -->
            <template v-if="selected['web'] == 'W-T2'">
              <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_frame_base02_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_frame_base01_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_frame_top01_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_stitch_top01_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_lace_top01_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_lace_top02_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <template v-if="selected['gloveHand'] == '右投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_t-2_lining_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_t-2_stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_t-2_front-lace_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${t1}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
              <template v-if="selected['gloveHand'] == '左投げ'">
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_t-2_reflect-lining_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_t-2_reflect-stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_t-2_reflect-front-lace_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
              <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_lace_base01_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
            </template>
            <!-- <template v-if="selected['web'] == 'W-T3'">
              <template v-for="t3 in bs_t_3" :key="t3">
                <img
                  v-if="t3 == 'bs_web_stitch_base01'"
                  id=""
                  :src="require(`@/assets/img/bs/${t3}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t3 == 'bs_t-3_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${t3}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t3 == 'bs_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/bs/${t3}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t3 == 'bs_web_lace_top01' || t3 == 'bs_web_lace_top02' || t3 == 'bs_web_lace_base01' || t3 == 'bs_t-3_lining'"
                  id=""
                  :src="require(`@/assets/img/bs/${t3}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t3 == 'bs_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/bs/${t3}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t3 == 'bs_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/bs/${t3}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t3 == 'bs_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/bs/${t3}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${t3}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template> -->
            <template v-if="selected['web'] == 'W-T3'">
              <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_frame_base02_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_frame_base01_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_frame_top01_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_stitch_top01_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_stitch_base01_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_lace_top01_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_lace_top02_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <template v-if="selected['gloveHand'] == '右投げ'">
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_t-3_stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_t-3_lining_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${t1}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
              <template v-if="selected['gloveHand'] == '左投げ'">
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_t-3_reflect-stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_t-3_reflect-lining_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
              <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_lace_base01_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
            </template>
            <!-- <template v-if="selected['web'] == 'W-T4'">
              <template v-for="t4 in bs_t_4" :key="t4">
                <img
                  v-if="t4 == 'bs_t-4_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${t4}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t4 == 'bs_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/bs/${t4}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t4 == 'bs_web_lace_top01' || t4 == 'bs_web_lace_top02' || t4 == 'bs_web_lace_base01' || t4 == 'bs_t-4_front-lace'"
                  id=""
                  :src="require(`@/assets/img/bs/${t4}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t4 == 'bs_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/bs/${t4}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t4 == 'bs_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/bs/${t4}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t4 == 'bs_t-4_lining'"
                  id=""
                  :src="require(`@/assets/img/bs/${t4}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t4 == 'bs_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/bs/${t4}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${t4}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template> -->
            <template v-if="selected['web'] == 'W-T4'">
              <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_frame_base02_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_frame_base01_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_frame_top01_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_stitch_top01_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_lace_top01_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_lace_top02_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <template v-if="selected['gloveHand'] == '右投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_t-4_stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_t-4_lining_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_t-4_front-lace_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${t1}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
              <template v-if="selected['gloveHand'] == '左投げ'">
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_t-4_reflect-stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_t-4_reflect-lining_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_t-4_reflect-front-lace_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                />
              </template>
              <img
                  id=""
                  :src="require(`@/assets/img/bs/bs_web_lace_base01_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
            </template>
            <template v-if="selected['web'] == 'W-T5'">
              <template v-for="t5 in bs_t_5" :key="t5">
                <img
                  v-if="t5 == 'bs_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${t5}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t5 == 'bs_t-5_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${t5}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t5 == 'bs_web_lace_top03' || t5 == 'bs_web_lace_top01' || t5 == 'bs_t-5_front-lace'"
                  id=""
                  :src="require(`@/assets/img/bs/${t5}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t5 == 'bs_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${t5}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t5 == 'bs_t-5_base-horizontal'"
                  id=""
                  :src="require(`@/assets/img/bs/${t5}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t5 == 'bs_t-5_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${t5}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t5 == 'bs_t-5_base-vertical'"
                  id=""
                  :src="require(`@/assets/img/bs/${t5}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${t5}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-T6'">
              <template v-for="t6 in bs_t_6" :key="t6">
                <img
                  v-if="t6 == 'bs_t-6_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${t6}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t6 == 'bs_web_stitch_top03'"
                  id=""
                  :src="require(`@/assets/img/bs/${t6}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t6 == 'bs_web_lace_base04' || t6 == 'bs_web_lace_top04' || t6 == 'bs_web_lace_base02'|| t6 == 'bs_web_lace_base01'"
                  id=""
                  :src="require(`@/assets/img/bs/${t6}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t6 == 'bs_web_frame_top03'"
                  id=""
                  :src="require(`@/assets/img/bs/${t6}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t6 == 'bs_web_frame_top04'"
                  id=""
                  :src="require(`@/assets/img/bs/${t6}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t6 == 'bs_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/bs/${t6}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t6 == 'bs_t-6_lining'"
                  id=""
                  :src="require(`@/assets/img/bs/${t6}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t6 == 'bs_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/bs/${t6}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${t6}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-T7'">
              <template v-for="t7 in bs_t_7" :key="t7">
                <img
                  v-if="t7 == 'bs_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/bs/${t7}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t7 == 'bs_t-7_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${t7}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t7 == 'bs_web_lace_top01' || t7 == 'bs_web_lace_top02' || t7 == 'bs_t-7_front-lace'"
                  id=""
                  :src="require(`@/assets/img/bs/${t7}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t7 == 'bs_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/bs/${t7}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t7 == 'bs_w-3_w-7_lining'"
                  id=""
                  :src="require(`@/assets/img/bs/${t7}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t7 == 'bs_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/bs/${t7}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t7 == 'bs_t-7_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${t7}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${t7}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-T8'">
              <template v-for="t8 in bs_t_8" :key="t8">
                <img
                  v-if="t8 == 'bs_web_stitch_top03'"
                  id=""
                  :src="require(`@/assets/img/bs/${t8}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t8 == 'bs_t-8_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${t8}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t8 == 'bs_web_lace_top04' || t8 == 'bs_t-8_front-lace' || t8 == 'bs_web_front-lace_bottom06'"
                  id=""
                  :src="require(`@/assets/img/bs/${t8}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t8 == 'bs_web_frame_top03'"
                  id=""
                  :src="require(`@/assets/img/bs/${t8}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t8 == 'bs_web_frame_top05'"
                  id=""
                  :src="require(`@/assets/img/bs/${t8}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t8 == 'bs_t-8_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${t8}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${t8}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>


            <template v-if="selected['web'] == 'W-T9'">
              <template v-for="t9 in bs_t_9" :key="t9">
                <img
                  v-if="t9 == 'bs_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/bs/${t9}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t9 == 'bs_t-9_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${t9}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t9 == 'bs_web_lace_top01' || t9 == 'bs_web_lace_top02' || t9 == 'bs_t-9_front-lace'"
                  id=""
                  :src="require(`@/assets/img/bs/${t9}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t9 == 'bs_t-9_base02'"
                  id=""
                  :src="require(`@/assets/img/bs/${t9}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t9 == 'bs_t-9_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${t9}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t9 == 'bs_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/bs/${t9}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${t9}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>

            <template v-if="selected['web'] == 'W-T12' || selected['web'] == null ">
              <template v-for="t12 in bs_t_12" :key="t12">
                <img
                  v-if="t12 == 'bs_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${t12}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t12 == 'bs_t-12_stitch'"
                  id=""
                  :src="require(`@/assets/img/bs/${t12}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t12 == 'bs_web_lace_top03' || t12 == 'bs_web_lace_top01' || t12 == 'bs_t-12_front-lace' || t12 == 'bs_web_front-lace_top01' || t12 == 'bs_web_front-lace_bottom06'"
                  id=""
                  :src="require(`@/assets/img/bs/${t12}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t12 == 'bs_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/bs/${t12}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t12 == 'bs_t-12_base'"
                  id=""
                  :src="require(`@/assets/img/bs/${t12}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t12 == 'bs_t-12_lining'"
                  id=""
                  :src="require(`@/assets/img/bs/${t12}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/bs/${t12}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
          </div>
          <!-- 背面ここまで -->
          <!-- 捕球面ここから -->
          <div class="globe-position" v-if="isGlobeDirection == '捕球面'">
          <!-- ウェブ -->
            <template v-if="selected['web'] == 'W-3'">
              <template v-for="w3 in ft_w_3" :key="w3">
                <img
                  v-if="w3 == 'ft_w-3_stitch'"
                  id=""
                  :src="require(`@/assets/img/ft/${w3}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w3 == 'ft_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w3}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w3 == 'ft_web_stitch_base01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w3}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w3 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w3}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w3 == 'ft_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w3}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w3 == 'ft_w-3_w-7_lining'"
                  id=""
                  :src="require(`@/assets/img/ft/${w3}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${w3}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-5'">
              <template v-for="w5 in ft_w_5" :key="w5">
                <img
                  v-if="w5 == 'ft_web_stitch_base01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w5}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w5 == 'ft_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w5}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w5 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w5}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w5 == 'ft_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w5}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${w5}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-6'">
              <template v-for="w6 in ft_w_6" :key="w6">
                <img
                  v-if="w6 == 'ft_web_stitch_base02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w6}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w6 == 'ft_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w6}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w6 == 'ft_web_stitch_vertical01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w6}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w6 == 'ft_web_lace_base02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w6}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w6 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w6}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w6 == 'ft_web_frame_base-vertical01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w6}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w6 == 'ft_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w6}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w6 == 'ft_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w6}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${w6}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-8'">
              <template v-for="w8 in ft_w_8" :key="w8">
                <img
                  v-if="w8 == 'ft_web_stitch_base02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w8}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w8 == 'ft_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w8}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w8 == 'bs_web_stitch_vertical02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w8}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w8 == 'ft_web_stitch_vertical01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w8}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w8 == 'ft_web_lace_base02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w8}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w8 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w8}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w8 == 'ft_web_frame_base-vertical01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w8}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w8 == 'ft_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w8}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w8 == 'ft_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w8}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${w8}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-10'">
              <template v-for="w10 in ft_w_10" :key="w10">
                <img
                  v-if="w10 == 'ft_web_stitch_base02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w10}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w10 == 'ft_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w10}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w10 == 'ft_web_stitch_vertical02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w10}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w10 == 'ft_web_stitch_vertical01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w10}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w10 == 'ft_web_lace_base02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w10}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w10 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w10}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w10 == 'ft_web_frame_base-vertical01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w10}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w10 == 'ft_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w10}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w10 == 'ft_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w10}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${w10}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-11'">
              <template v-for="w11 in ft_w_11" :key="w11">
                <img
                  v-if="w11 == 'ft_web_stitch_base03'"
                  id=""
                  :src="require(`@/assets/img/ft/${w11}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w11 == 'ft_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w11}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w11 == 'ft_w-11_stitch'"
                  id=""
                  :src="require(`@/assets/img/ft/${w11}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w11 == 'ft_web_lace_base03'"
                  id=""
                  :src="require(`@/assets/img/ft/${w11}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w11 == 'ft_web_lace_base04'"
                  id=""
                  :src="require(`@/assets/img/ft/${w11}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w11 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w11}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w11 == 'ft_w-11_base'"
                  id=""
                  :src="require(`@/assets/img/ft/${w11}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w11 == 'ft_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w11}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w11 == 'ft_web_frame_base03'"
                  id=""
                  :src="require(`@/assets/img/ft/${w11}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${w11}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-12'">
              <template v-for="w12 in ft_w_12" :key="w12">
                <img
                  v-if="w12 == 'ft_w-12_stitch'"
                  id=""
                  :src="require(`@/assets/img/ft/${w12}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w12 == 'ft_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w12}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w12 == 'ft_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w12}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w12 == 'ft_w-12_back-lace'"
                  id=""
                  :src="require(`@/assets/img/ft/${w12}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w12 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w12}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w12 == 'ft_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w12}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w12 == 'ft_w-12_base'"
                  id=""
                  :src="require(`@/assets/img/ft/${w12}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${w12}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-13'">
              <template v-for="w13 in ft_w_13" :key="w13">
                <img
                  v-if="w13 == 'ft_w-13_stitch'"
                  id=""
                  :src="require(`@/assets/img/ft/${w13}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w13 == 'ft_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w13}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w13 == 'ft_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w13}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w13 == 'ft_w-13_back-lace'"
                  id=""
                  :src="require(`@/assets/img/ft/${w13}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w13 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w13}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w13 == 'ft_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w13}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w13 == 'ft_w-13_base'"
                  id=""
                  :src="require(`@/assets/img/ft/${w13}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${w13}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-14'">
              <template v-for="w14 in ft_w_14" :key="w14">
                <img
                  v-if="w14 == 'ft_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w14}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w14 == 'ft_web_stitch_vertical03'"
                  id=""
                  :src="require(`@/assets/img/ft/${w14}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w14 == 'ft_web_stitch_vertical02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w14}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w14 == 'ft_w-14_back-lace'"
                  id=""
                  :src="require(`@/assets/img/ft/${w14}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w14 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w14}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w14 == 'ft_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w14}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w14 == 'ft_web_frame_base-vertical02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w14}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${w14}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-15'">
              <template v-for="w15 in ft_w_15" :key="w15">
                <img
                  v-if="w15 == 'ft_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w15}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w15 == 'ft_web_stitch_vertical03'"
                  id=""
                  :src="require(`@/assets/img/ft/${w15}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w15 == 'ft_web_stitch_vertical02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w15}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w15 == 'ft_w-15_back-lace'"
                  id=""
                  :src="require(`@/assets/img/ft/${w15}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w15 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w15}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w15 == 'ft_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w15}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w15 == 'ft_web_frame_base-vertical02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w15}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${w15}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-16'">
              <template v-for="w16 in ft_w_16" :key="w16">
                <img
                  v-if="w16 == 'ft_w-16_stitch'"
                  id=""
                  :src="require(`@/assets/img/ft/${w16}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w16 == 'ft_w-16_back-lace'"
                  id=""
                  :src="require(`@/assets/img/ft/${w16}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w16 == 'ft_w-16_base'"
                  id=""
                  :src="require(`@/assets/img/ft/${w16}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w16 == 'ft_w-16_edge'"
                  id=""
                  :src="require(`@/assets/img/ft/${w16}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${w16}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-17'">
              <template v-for="w17 in ft_w_17" :key="w17">
                <img
                  v-if="w17 == 'ft_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w17}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w17 == 'ft_web_stitch_vertical03'"
                  id=""
                  :src="require(`@/assets/img/ft/${w17}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w17 == 'ft_web_stitch_vertical02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w17}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w17 == 'ft_w-17_back-lace'"
                  id=""
                  :src="require(`@/assets/img/ft/${w17}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w17 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w17}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w17 == 'ft_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w17}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w17 == 'ft_web_frame_base-vertical02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w17}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${w17}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-19'">
              <template v-for="w19 in ft_w_19" :key="w19">
                <img
                  v-if="w19 == 'ft_w-19_stitch'"
                  id=""
                  :src="require(`@/assets/img/ft/${w19}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w19 == 'ft_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w19}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w19 == 'ft_web_stitch_vertical02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w19}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w19 == 'ft_web_stitch_vertical01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w19}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w19 == 'ft_w-19_back-lace'"
                  id=""
                  :src="require(`@/assets/img/ft/${w19}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w19 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w19}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w19 == 'ft_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w19}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w19 == 'ft_w-19_base'"
                  id=""
                  :src="require(`@/assets/img/ft/${w19}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w19 == 'ft_web_frame_base-vertical01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w19}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${w19}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-22'">
              <template v-for="w22 in ft_w_22" :key="w22">
                <img
                  v-if="w22 == 'ft_web_stitch_base02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w22}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w22 == 'ft_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w22}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w22 == 'ft_web_stitch_vertical01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w22}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w22 == 'ft_web_lace_base02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w22}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w22 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w22}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w22 == 'ft_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w22}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w22 == 'ft_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w22}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w22 == 'ft_web_frame_base-vertical01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w22}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${w22}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-23'">
              <template v-for="w23 in ft_w_23" :key="w23">
                <img
                  v-if="w23 == 'ft_web_stitch_base02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w23}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w23 == 'ft_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w23}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w23 == 'ft_w-23_stitch'"
                  id=""
                  :src="require(`@/assets/img/ft/${w23}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w23 == 'ft_web_lace_base02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w23}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w23 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w23}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w23 == 'ft_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w23}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w23 == 'ft_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w23}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w23 == 'ft_w-23_base'"
                  id=""
                  :src="require(`@/assets/img/ft/${w23}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w23 == 'ft_w-23_base-vertical'"
                  id=""
                  :src="require(`@/assets/img/ft/${w23}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${w23}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-24'">
              <template v-for="w24 in ft_w_24" :key="w24">
                <img
                  v-if="w24 == 'ft_w-24_stitch'"
                  id=""
                  :src="require(`@/assets/img/ft/${w24}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w24 == 'ft_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w24}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w24 == 'ft_web_lace_base04'"
                  id=""
                  :src="require(`@/assets/img/ft/${w24}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w24 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w24}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w24 == 'ft_w-24_base'"
                  id=""
                  :src="require(`@/assets/img/ft/${w24}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${w24}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-27'">
              <template v-for="w27 in ft_w_27" :key="w27">
                <img
                  v-if="w27 == 'ft_web_stitch_base03'"
                  id=""
                  :src="require(`@/assets/img/ft/${w27}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w27 == 'ft_web_stitch_top03'"
                  id=""
                  :src="require(`@/assets/img/ft/${w27}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w27 == 'ft_w-27_stitch'"
                  id=""
                  :src="require(`@/assets/img/ft/${w27}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w27 == 'ft_web_stitch_vertical03'"
                  id=""
                  :src="require(`@/assets/img/ft/${w27}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w27 == 'ft_web_lace_base03'"
                  id=""
                  :src="require(`@/assets/img/ft/${w27}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w27 == 'ft_web_lace_base04'"
                  id=""
                  :src="require(`@/assets/img/ft/${w27}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w27 == 'ft_web_lace_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w27}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w27 == 'ft_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w27}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w27 == 'ft_web_frame_top03'"
                  id=""
                  :src="require(`@/assets/img/ft/${w27}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w27 == 'ft_web_frame_base03'"
                  id=""
                  :src="require(`@/assets/img/ft/${w27}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w27 == 'ft_web_frame_base-vertical03'"
                  id=""
                  :src="require(`@/assets/img/ft/${w27}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${w27}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-28'">
              <template v-for="w28 in ft_w_28" :key="w28">
                <img
                  v-if="w28 == 'ft_web_stitch_top03'"
                  id=""
                  :src="require(`@/assets/img/ft/${w28}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w28 == 'ft_w-28_stitch'"
                  id=""
                  :src="require(`@/assets/img/ft/${w28}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w28 == 'ft_web_stitch_vertical01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w28}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w28 == 'ft_web_stitch_base03'"
                  id=""
                  :src="require(`@/assets/img/ft/${w28}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w28 == 'ft_web_lace_base03'"
                  id=""
                  :src="require(`@/assets/img/ft/${w28}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w28 == 'ft_web_lace_base04'"
                  id=""
                  :src="require(`@/assets/img/ft/${w28}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w28 == 'ft_web_lace_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w28}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w28 == 'ft_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w28}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w28 == 'ft_web_frame_top03'"
                  id=""
                  :src="require(`@/assets/img/ft/${w28}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w28 == 'ft_web_frame_base03'"
                  id=""
                  :src="require(`@/assets/img/ft/${w28}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w28 == 'ft_web_frame_base-vertical01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w28}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${w28}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-29'">
              <template v-for="w29 in ft_w_29" :key="w29">
                <img
                  v-if="w29 == 'ft_web_stitch_base02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w29}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w29 == 'ft_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w29}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w29 == 'ft_web_stitch_vertical01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w29}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w29 == 'ft_web_lace_base02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w29}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w29 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w29}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w29 == 'ft_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w29}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w29 == 'ft_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w29}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w29 == 'ft_web_frame_base-vertical01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w29}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${w29}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-30'">
              <template v-for="w30 in ft_w_30" :key="w30">
                <img
                  v-if="w30 == 'ft_web_stitch_base02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w30}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w30 == 'ft_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w30}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w30 == 'ft_w-30_stitch'"
                  id=""
                  :src="require(`@/assets/img/ft/${w30}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="w30 == 'ft_web_lace_base02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w30}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w30 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w30}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w30 == 'ft_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${w30}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w30 == 'ft_web_frame_base02'"
                  id=""
                  :src="require(`@/assets/img/ft/${w30}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="w30 == 'ft_w-30_base'"
                  id=""
                  :src="require(`@/assets/img/ft/${w30}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${w30}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <!-- <template v-if="selected['web'] == 'W-T1'">
              <template v-for="t1 in ft_t_1" :key="t1">
                <img
                  v-if="t1 == 'ft_web_stitch_base01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t1}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t1 == 'ft_t-1_stitch'"
                  id=""
                  :src="require(`@/assets/img/ft/${t1}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t1 == 'ft_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t1}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t1 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t1}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t1 == 'ft_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t1}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${t1}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template> -->
            <template v-if="selected['web'] == 'W-T1'">
                <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_web_stitch_base01_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_web_stitch_top01_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_web_frame_base01_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_web_lace_top01_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${t1}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
                <template v-if="selected['gloveHand'] == '右投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_t-1_stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
                </template>
                <template v-if="selected['gloveHand'] == '左投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_t-1_reflect-stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
                </template>
            </template>
            <!-- <template v-if="selected['web'] == 'W-T2'">
              <template v-for="t2 in ft_t_2" :key="t2">
                <img
                  v-if="t2 == 'ft_t-2_stitch'"
                  id=""
                  :src="require(`@/assets/img/ft/${t2}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t2 == 'ft_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t2}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t2 == 'ft_t-2_back-lace'"
                  id=""
                  :src="require(`@/assets/img/ft/${t2}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t2 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t2}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t2 == 'ft_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t2}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${t2}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template> -->
            <template v-if="selected['web'] == 'W-T2'">
              <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_web_stitch_base01_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_web_stitch_top01_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_web_frame_base01_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_web_lace_top01_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${t1}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
                <template v-if="selected['gloveHand'] == '右投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_t-2_stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_t-2_back-lace_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                />
                </template>
                <template v-if="selected['gloveHand'] == '左投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_t-2_reflect-stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_t-2_reflect-back-lace_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                />
                </template>
            </template>
            <!-- <template v-if="selected['web'] == 'W-T3'">
              <template v-for="t3 in ft_t_3" :key="t3">
                <img
                  v-if="t3 == 'ft_web_stitch_base01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t3}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t3 == 'ft_t-3_stitch'"
                  id=""
                  :src="require(`@/assets/img/ft/${t3}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t3 == 'ft_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t3}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t3 == 'ft_t-3_back-lace'"
                  id=""
                  :src="require(`@/assets/img/ft/${t3}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t3 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t3}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t3 == 'ft_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t3}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${t3}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template> -->
            <template v-if="selected['web'] == 'W-T3'">
              <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_web_stitch_base01_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_web_stitch_top01_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_web_frame_base01_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_web_lace_top01_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${t1}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
                <template v-if="selected['gloveHand'] == '右投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_t-3_stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_t-3_back-lace_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                />
                </template>
                <template v-if="selected['gloveHand'] == '左投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_t-3_reflect-stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_t-3_reflect-back-lace_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                />
                </template>
            </template>
            <!-- <template v-if="selected['web'] == 'W-T4'">
              <template v-for="t4 in ft_t_4" :key="t4">
                <img
                  v-if="t4 == 'ft_t-4_stitch'"
                  id=""
                  :src="require(`@/assets/img/ft/${t4}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t4 == 'ft_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t4}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t4 == 'ft_t-4_back-lace'"
                  id=""
                  :src="require(`@/assets/img/ft/${t4}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t4 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t4}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t4 == 'ft_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t4}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${t4}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
              </template>
            </template> -->
            <template v-if="selected['web'] == 'W-T4'">
              <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_web_stitch_base01_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_web_stitch_top01_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_web_frame_base01_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_web_lace_top01_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${t1}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
                <template v-if="selected['gloveHand'] == '右投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_t-4_stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_t-4_back-lace_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                />
                </template>
                <template v-if="selected['gloveHand'] == '左投げ'">
                  <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_t-4_reflect-stitch_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass]"
                />
                <img
                  id=""
                  :src="require(`@/assets/img/ft/ft_t-4_reflect-back-lace_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                />
                </template>
            </template>
            <template v-if="selected['web'] == 'W-T5'">
              <template v-for="t5 in ft_t_5" :key="t5">
                <img
                  v-if="t5 == 'ft_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${t5}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t5 == 'ft_t-5_stitch'"
                  id=""
                  :src="require(`@/assets/img/ft/${t5}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t5 == 'ft_web_stitch_vertical03'"
                  id=""
                  :src="require(`@/assets/img/ft/${t5}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t5 == 'ft_web_stitch_base03'"
                  id=""
                  :src="require(`@/assets/img/ft/${t5}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t5 == 'ft_web_lace_base03'"
                  id=""
                  :src="require(`@/assets/img/ft/${t5}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t5 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t5}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t5 == 'ft_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t5}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t5 == 'ft_t-5_base'"
                  id=""
                  :src="require(`@/assets/img/ft/${t5}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t5 == 'ft_web_frame_base03'"
                  id=""
                  :src="require(`@/assets/img/ft/${t5}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t5 == 'ft_web_frame_base-vertical03'"
                  id=""
                  :src="require(`@/assets/img/ft/${t5}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${t5}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-T6'">
              <template v-for="t6 in ft_t_6" :key="t6">
                <img
                  v-if="t6 == 'ft_t-6_stitch'"
                  id=""
                  :src="require(`@/assets/img/ft/${t6}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t6 == 'ft_web_stitch_top03'"
                  id=""
                  :src="require(`@/assets/img/ft/${t6}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t6 == 'ft_web_lace_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${t6}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t6 == 'ft_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${t6}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t6 == 'ft_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t6}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t6 == 'ft_t-6_lining'"
                  id=""
                  :src="require(`@/assets/img/ft/${t6}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${t6}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-T7'">
              <template v-for="t7 in ft_t_7" :key="t7">
                <img
                  v-if="t7 == 'ft_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t7}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t7 == 'ft_t-7_stitch'"
                  id=""
                  :src="require(`@/assets/img/ft/${t7}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t7 == 'ft_web_stitch_base01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t7}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t7 == 'ft_t-7_back-lace'"
                  id=""
                  :src="require(`@/assets/img/ft/${t7}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t7 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t7}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t7 == 'ft_web_frame_base01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t7}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t7 == 'ft_w-3_w-7_lining'"
                  id=""
                  :src="require(`@/assets/img/ft/${t7}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${t7}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-T8'">
              <template v-for="t8 in ft_t_8" :key="t8">
                <img
                  v-if="t8 == 'ft_web_stitch_top03'"
                  id=""
                  :src="require(`@/assets/img/ft/${t8}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t8 == 'ft_t-8_stitch'"
                  id=""
                  :src="require(`@/assets/img/ft/${t8}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t8 == 'ft_web_stitch_vertical02'"
                  id=""
                  :src="require(`@/assets/img/ft/${t8}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t8 == 'ft_t-8_back-lace'"
                  id=""
                  :src="require(`@/assets/img/ft/${t8}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t8 == 'ft_t-8_back-lace02'"
                  id=""
                  :src="require(`@/assets/img/ft/${t8}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t8 == 'ft_web_lace_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${t8}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t8 == 'ft_web_frame_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${t8}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t8 == 'ft_web_frame_top03'"
                  id=""
                  :src="require(`@/assets/img/ft/${t8}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t8 == 'ft_web_frame_base-vertical02'"
                  id=""
                  :src="require(`@/assets/img/ft/${t8}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${t8}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-T9'">
              <template v-for="t9 in ft_t_9" :key="t9">
                <img
                  v-if="t9 == 'ft_web_stitch_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t9}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t9 == 'ft_t-9_stitch'"
                  id=""
                  :src="require(`@/assets/img/ft/${t9}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t9 == 'ft_t-9_back-lace'"
                  id=""
                  :src="require(`@/assets/img/ft/${t9}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t9 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t9}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t9 == 'ft_t-9_base'"
                  id=""
                  :src="require(`@/assets/img/ft/${t9}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${t9}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>
            <template v-if="selected['web'] == 'W-T12' || selected['web'] == null ">
              <template v-for="t12 in ft_t_12" :key="t12">
                <img
                  v-if="t12 == 'ft_web_stitch_top02'"
                  id=""
                  :src="require(`@/assets/img/ft/${t12}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t12 == 'ft_t-12_stitch'"
                  id=""
                  :src="require(`@/assets/img/ft/${t12}_${selectedColorCon('stitchColor')}.png`)"
                  :class="['order-center-image', 'position-all', stitchShadowClass, selected['gloveHand'] == '左投げ' ? 'reverse-flip' : '']"
                />
                <img
                  v-else-if="t12 == 'ft_t-12_back-lace'"
                  id=""
                  :src="require(`@/assets/img/ft/${t12}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t12 == 'ft_web_lace_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t12}_${selectedColorCon('laceColor')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t12 == 'ft_web_frame_top01'"
                  id=""
                  :src="require(`@/assets/img/ft/${t12}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t12 == 'ft_web_frame_base-vertical02'"
                  id=""
                  :src="require(`@/assets/img/ft/${t12}_${selectedColorCon('webBack')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <img
                  v-else-if="t12 == 'ft_t-12_lining'"
                  id=""
                  :src="require(`@/assets/img/ft/${t12}_${selectedColorCon('webEdge')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                />
                <!-- <img
                  v-else
                  id=""
                  :src="require(`@/assets/img/ft/${t12}_${selectedColorCon('webCatch')}.png`)"
                  class="order-center-image position-all"
                  :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
                /> -->
              </template>
            </template>

            <!-- 背面カラー -->
            <!-- 小指かけ -->
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_shere-pinky-hanger_${selectedColorCon('littleFingerHanger')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <!-- 小指レース -->
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_lace-share-pinky_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <!-- ハミダシ -->
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-welting_${selectedColorCon('additional')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <!-- 小指外側 -->
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_pinky-out_${selectedColorCon('littleFingerOut')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <!-- 親指かけ -->
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-thumb-hanger_${selectedColorCon('thumbHanger')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <!-- 親指内側 -->
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-thumb-in_${selectedColorCon('catchColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <!-- 親指外側 -->
            <template v-if="selected['backStyle'] == 'ライナーバック' ">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-thumb-out_${selectedColorCon('thumbOut')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            </template>
            <template v-else-if="selected['backStyle'] == '王冠' || selected['backStyle'] == 'レギュラー'">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-thumb-out_${selectedColorCon('thumbOut')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            </template>
            <!-- 人差し指内側 -->
            <template v-if="selected['backStyle'] == 'ライナーバック' ">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-index-in_${selectedColorCon('thumbIndexAndMiddleFinger')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
          <template v-else-if="selected['backStyle'] == '王冠'">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-index-in_${selectedColorCon('indexFingerIn')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
          <template v-else-if="selected['backStyle'] == 'レギュラー'">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-index-in_${selectedColorCon('indexFingerIn')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
            <!-- 人差し指外側 -->
            <template v-if="selected['backStyle'] == 'ライナーバック' ">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-index-out_${selectedColorCon('thumbIndexAndMiddleFinger')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
          <template v-else-if="selected['backStyle'] == '王冠' ">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-index-out_${selectedColorCon('indexAndMiddleFinger')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
          <template v-else-if="selected['backStyle'] == 'レギュラー' ">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-index-out_${selectedColorCon('indexFingerOut')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
            <!-- 中指外側 -->
            <template v-if="selected['backStyle'] == 'ライナーバック' || selected['backStyle'] == '王冠' ">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-middle-out_${selectedColorCon('middleAndThirdFinger')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
          <template v-if="selected['backStyle'] == 'レギュラー' ">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-middle-out_${selectedColorCon('middleFingerOut')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
            <!-- 中指内側 -->
            <template v-if="selected['backStyle'] == 'ライナーバック' || selected['backStyle'] == '王冠' ">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-middle-in_${selectedColorCon('indexAndMiddleFinger')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
          <template v-else-if="selected['backStyle'] == 'レギュラー' ">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-middle-in_${selectedColorCon('middleFingerIn')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
            <!-- 捕球面 -->
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-in_${selectedColorCon('catchColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <!-- 薬指外側 -->
            <template v-if="selected['backStyle'] == 'ライナーバック' || selected['backStyle'] == '王冠' ">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-third-out_${selectedColorCon('thirdAndLittleFinger')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
          <template v-else-if="selected['backStyle'] == 'レギュラー' ">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-third-out_${selectedColorCon('thirdFingerOut')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
            <!-- 薬指内側 -->
            <template v-if="selected['backStyle'] == 'ライナーバック' || selected['backStyle'] == '王冠' ">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-third-in_${selectedColorCon('middleAndThirdFinger')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
          <template v-else-if="selected['backStyle'] == 'レギュラー' ">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-third-in_${selectedColorCon('thirdFingerIn')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
            <!-- 小指内側 -->
            <template v-if="selected['backStyle'] == 'ライナーバック' || selected['backStyle'] == '王冠' ">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_pinky-in_${selectedColorCon('thirdAndLittleFinger')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
          <template v-if="selected['backStyle'] == 'レギュラー' ">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_pinky-in_${selectedColorCon('littleFingerIn')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
            <img
              v-if="selected['gloveHand'] == '右投げ'"
              id=""
              :src="require(`@/assets/img/ft/ft_carved-seal.png`)"
              class="order-center-image position-all"
            />
            <img
              v-if="selected['gloveHand'] == '左投げ'"
              id=""
              :src="require(`@/assets/img/ft/ft_carved-seal_reflect.png`)"
              class="order-center-image position-all"
            />

            <!-- トジ部 -->
             <!-- 共通 -->
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-lacing_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <!-- タテトジ -->
            <template v-if="selected['lacePortion'] == 'タテトジ'">
              <img
                id=""
                :src="require(`@/assets/img/ft/ft_vertical_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
            </template>
            <!-- ヨコトジ -->
            <template v-else-if="selected['lacePortion'] == 'ヨコトジ'">
              <img
                id=""
                :src="require(`@/assets/img/ft/ft_horizontal_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <!-- KZN -->
              <img
                v-if="selected['typeName'] == 'KZN'"
                id=""
                :src="require(`@/assets/img/ft/ft_kzn_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
            </template>
            <!-- ヨコトジダブル -->
            <template v-else-if="selected['lacePortion'] == 'ヨコトジダブル'">
              <img
                id=""
                :src="require(`@/assets/img/ft/ft_horizontal_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                id=""
                :src="require(`@/assets/img/ft/ft_horizontal-w_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <!-- KZN -->
              <img
                v-if="selected['typeName'] == 'KZN'"
                id=""
                :src="require(`@/assets/img/ft/ft_kzn_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
            </template>
            <!-- ヨコトジダブルひも抜き -->
            <template v-else-if="selected['lacePortion'] == 'ヨコトジダブルひも抜き'">
              <img
                id=""
                :src="require(`@/assets/img/ft/ft_horizontal_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                id=""
                :src="require(`@/assets/img/ft/ft_horizontal-w-none.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                id=""
                :src="require(`@/assets/img/ft/ft_horizontal_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <!-- KZN -->
              <img
                v-if="selected['typeName'] == 'KZN'"
                id=""
                :src="require(`@/assets/img/ft/ft_kzn_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
            </template>
            <!-- スペースヒンジ -->
            <template v-else-if="selected['lacePortion'] == 'スペースヒンジ（+5,500円）'">
              <img
                id=""
                :src="require(`@/assets/img/ft/ft_space-hinge_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
            </template>
            <!-- スペースヒンジダブル -->
            <template v-else-if="selected['lacePortion'] == 'スペースヒンジダブル（+5,500円）'">
              <img
                id=""
                :src="require(`@/assets/img/ft/ft_space-hinge_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                id=""
                :src="require(`@/assets/img/ft/ft_space-hinge-w_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
            </template>
            <!-- スペースヒンジダブルヒモ抜き -->
            <template v-else-if="selected['lacePortion'] == 'スペースヒンジダブルひも抜き（+5,500円）'">
              <img
                id=""
                :src="require(`@/assets/img/ft/ft_space-hinge_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
              <img
                id=""
                :src="require(`@/assets/img/ft/ft_space-hinge-w-none.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
            </template>
            <!-- ヘリ革 -->
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-edge_${selectedColorCon('hemLeather')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_lace-share_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />

            <!-- ヒモ通し -->
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-lacing_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <template v-if="selected['laceStrand'] == 'レギュラー巻き'">
              <img
                id=""
                :src="require(`@/assets/img/ft/ft_lacing-reg_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
            </template>
            <template v-else-if="selected['laceStrand'] == '逆巻き'">
              <img
                id=""
                :src="require(`@/assets/img/ft/ft_lacing-rvs_${selectedColorCon('laceColor')}.png`)"
                class="order-center-image position-all"
                :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
              />
            </template>
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_share-thumb-hanger_${selectedColorCon('thumbHanger')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <!-- webレース -->
             <!-- ft_web_lace_finger01 -->
            <template v-if="selected['web'] == 'W-3' || selected['web'] == 'W-5' || selected['web'] == 'W-12' || selected['web'] == 'W-13' || selected['web'] == 'W-19' || selected['web'] == 'W-T1' || selected['web'] == 'W-T2' || selected['web'] == 'W-T3' || selected['web'] == 'W-T4' || selected['web'] == 'W-T6' || selected['web'] == 'W-T9'">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_web_lace_finger01_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <!-- "ft_web_lace_bottom01" -->
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_web_lace_bottom01_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            </template>
            <!-- ft_web_lace_finger02 -->
            <template v-if="selected['web'] == 'W-6' || selected['web'] == 'W-8' || selected['web'] == 'W-10' || selected['web'] == 'W-11' || selected['web'] == 'W-22' || selected['web'] == 'W-23' || selected['web'] == 'W-24' || selected['web'] == 'W-29' || selected['web'] == 'W-30'">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_web_lace_finger02_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <!-- "ft_web_lace_bottom02" -->
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_web_lace_bottom02_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            </template>
            <!-- ft_web_lace_finger03 -->
            <template v-if="selected['web'] == 'W-T5'">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_web_lace_finger03_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <!-- "ft_web_lace_bottom02" -->
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_web_lace_bottom02_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            </template>
            <!-- ft_web_lace_finger04 -->
            <template v-if="selected['web'] == 'W-14' || selected['web'] == 'W-17'">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_web_lace_finger04_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <!-- "ft_web_lace_bottom02" -->
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_web_lace_bottom02_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            </template>
            <!-- ft_web_lace_finger05 -->
            <template v-if="selected['web'] == 'W-27' || selected['web'] == 'W-28'">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_web_lace_finger05_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <!-- "ft_web_lace_bottom02" -->
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_web_lace_bottom02_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            </template>
            <!-- ft_web_lace_finger_w-15 -->
            <template v-if="selected['web'] == 'W-15'">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_web_lace_finger_w-15_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <!-- "ft_web_lace_bottom03" -->
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_web_lace_bottom03_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            </template>
            <!-- ft_web_lace_finger_w-16 -->
            <template v-if="selected['web'] == 'W-16'">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_web_lace_finger_w-16_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <!-- "ft_web_lace_bottom02" -->
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_web_lace_bottom02_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
          <!-- ft_web_lace_finger_t-7 -->
          <template v-if="selected['web'] == 'W-T7'">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_web_lace_finger_t-7_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <!-- "ft_web_lace_bottom01" -->
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_web_lace_bottom01_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
          <!-- ft_web_lace_finger_t-8 -->
          <template v-if="selected['web'] == 'W-T8'">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_web_lace_finger_t-8_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <!-- "ft_web_lace_bottom03" -->
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_web_lace_bottom03_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
          <!-- ft_web_lace_finger_t-12 -->
          <template v-if="selected['web'] == 'W-T12'">
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_web_lace_finger_t-12_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
            <!-- "ft_web_lace_bottom02" -->
            <img
              id=""
              :src="require(`@/assets/img/ft/ft_web_lace_bottom03_${selectedColorCon('laceColor')}.png`)"
              class="order-center-image position-all"
              :class="selected['gloveHand'] == '左投げ' ? 'reverse-flip': ''"
            />
          </template>
          </div>
          <!-- 捕球面ここまで -->
        </div>

          <LoadingSpinner v-if="!allImagesLoaded" />
        </div><!-- order-background -->
        <div class="order-button-container desktop-only">
          <button
            class="order-image-button"
            :class="{ active: isGlobeDirection === '捕球面' }"
            @click="changeDirection('捕球面')"
          >
            捕球面
          </button>
          <button
            class="order-image-button"
            :class="{ active: isGlobeDirection === '背面' }"
            @click="changeDirection('背面')"
          >
            背&nbsp;&nbsp;&nbsp;面
          </button>
          <button
            class="order-image-button"
            :class="{ active: isGlobeDirection === '親指側' }"
            @click="changeDirection('親指側')"
          >
            親指側
          </button>
          <button
            class="order-image-button"
            :class="{ active: isGlobeDirection === '小指側' }"
            @click="changeDirection('小指側')"
            data-tooltip=""
          >
            小指側
          </button>
        </div>
      </div>
    </div>
    <div class="bottom-space bottom-bar-mobile-only">
      <button id="myButton" class="right-button" @click="saveSelections">
        一時保存⤓
      </button>
      <span class="total-amount"> 合計 {{ totalPrice }}円(税込)</span>

      <!-- 確認ボタン -->
      <button class="right-button" @click="openModal">確認画面</button>
    </div>


    <!-- カスタムアラート -->
    <div v-if="showAlert" class="custom-alert" v-html="alertMessage"></div>
    <!-- DetailModal -->
    <DetailModal
      :isVisible="isModalVisible"
      :selected="selected"
      @close="isModalVisible = false"
      :totalPrice="totalPrice"
      :savedSelections="savedSelections"
      @missing-fields-updated="handleMissingFields"
    />
  </div>
</template>

<script>
/* global $ */
import {
  //パーツ選択肢
  modelChoiceOptions,
  positionOptions,
  typeNameOptionsByPosition,
  gloveHandOptions,
  backStyleOptions,
  labelPositionOptions,
  beltTypeOptions,
  fingerSizeOptions,
  backStrandOptions,
  hamidashiChoiceOptions,
  lacePortionOptions,
  laceStrandOptions,
  webOptionsByPosition,
  fingerOptions,
} from "@/utils/PartsChoices";

import {
  //カラー選択肢
  mainColors,
  mainColorOptions,
  thumbOutOptions,
  thumbInOptions,
  indexFingerOutOptions,
  indexFingerInOptions,
  middleFingerOutOptions,
  middleFingerInOptions,
  thirdFingerOutOptions,
  thirdFingerInOptions,
  littleFingerOutOptions,
  littleFingerInOptions,
  bandColorOptions,
  catchColorOptions,
  thumbHangerOptions,
  littleFingerHangerOptions,
  hemLeatherOptions,
  webBackOptions,
  webCatchOptions,
  webEdgeOptions,
  hirauraOptions,
  treasureBeltOptions,
  fingerCoverColorOptions,
  linerBackBeltColorOptions,
  hamidashiAdditionalOptions,
  laceColorOptions,
  stitchColorOptions,
  treasureLabelOptions,
  optionMainColorOptions,
  optionShadowColorOptions,
  optionStandColorOptions,
    // 王冠用
    indexAndMiddleFingerOptions,
    middleAndThirdFingerOptions,
    thirdAndLittleFingerOptions,
    // ライナーバック用
    thumbIndexAndMiddleFingerOptions,
} from "@/utils/ColorChoices";

import {
  //刺繍選択肢
  embroideryPositionOptions,
  fontOptions,
  fontColorOptions,
  shadowEdgeOptions,
  shadowColorOptions,
  edgeColorOptions,
} from "@/utils/EmbroideryChoices";
import CustomDropdown from "@/components/CustomDropdown.vue";
import DetailModal from "@/components/DetailModal.vue";
import { Tab } from "bootstrap"; // BootstrapのTabモジュールをインポート
import { v4 as uuidv4 } from "uuid"; // ID生成用
import ColorPalette from "@/components/ColorPalette.vue";
import LoadingSpinner from '@/components/LoadingSpinner.vue';

export default {
  components: { CustomDropdown, DetailModal, ColorPalette, LoadingSpinner },
  data() {
    return {
      selected: {
        //パーツ
        modelChoice: "硬式用(77,000円)",
        position: "投手",
        typeName: "TLN",
        gloveHand: "右投げ",
        backStyle: "レギュラー",
        labelPosition: "親指側",
        beltType: "Tベルト",
        fingerSize: null,
        backStrand: "クロス×ストレート",
        hamidashiChoice: "玉はみ", // ハミダシの選択値
        lacePortion: "ヨコトジダブル",
        laceStrand: "逆巻き",
        web: "W-T7",
        finger: "なし",

        //カラー
        mainColor: "ネイビー",
        thumbOut: "ネイビー",
        thumbIn: "ネイビー",
        indexFingerOut: "ネイビー",
        indexFingerIn: "ネイビー",
        middleFingerOut: "ネイビー",
        middleFingerIn: "ネイビー",
        thirdFingerOut: "ネイビー",
        thirdFingerIn: "ネイビー",
        littleFingerOut: "ネイビー",
        littleFingerIn: "ネイビー",
        bandColor: "ネイビー",
        catchColor: "ネイビー",
        thumbHanger: "ネイビー",
        littleFingerHanger: "ネイビー",
        hemLeather: "サックス",
        webBack: "ネイビー",
        webCatch: "ネイビー",
        webEdge: "ネイビー",
        hiraura: "Dオレンジ",
        treasureBelt: "ネイビー",
        fingerCoverColor: "ネイビー",
        linerBackBeltColor: "ネイビー",
        additional: "サックス", // 追加ドロップダウンの選択値
        laceColor: "ミズイロ",
        stitchColor: "ネイビー",
        treasureLabelChoice: "標準2(ゴールド×ブラック×Lゴールド)",
        optionMainColor: "金糸",
        optionShadowColor: "ブラック",
        optionStandColor: "Lゴールド",
          // 王冠用
          indexAndMiddleFinger: "Dオレンジ",
          middleAndThirdFinger: "Dオレンジ",
          thirdAndLittleFinger: "Dオレンジ",
          // ライナーバック用
          thumbIndexAndMiddleFinger: "Dオレンジ",

        //刺繍
        embroideryPosition: null,
        font: null,
        fontColor: null,
        shadowEdge: null,
        shadowColor: null,
        edgeColor: null,
        embroideryContent: "",

        isFontColorOpen: false,
        isShadowColorOpen: false,
        isEdgeColorOpen: false,
      },

      selection: {
        embroideryPosition: null,
        font: null,
        fontColor: null,
        shadowEdge: null,
        shadowColor: null,
        edgeColor: null,
        embroideryContent: null,
      },

      //パーツ
      modelChoiceOptions,
      positionOptions,
      gloveHandOptions,
      fingerSizeOptions,
      backStrandOptions,
      labelPositionOptions,
      hamidashiChoiceOptions,
      lacePortionOptions,
      laceStrandOptions,
      webOptionsByPosition, // インポートした選択肢
      fingerOptions, // インポートした選択
      //パーツ動き関係
      showBeltWarning: false, // ベルト型の警告メッセージ表示状態
      showFingerWarning: false, // 指カバーの警告メッセージ表示状態

      //カラー
      mainColors: mainColors,
      mainColorOptions,
      thumbOutOptions,
      thumbInOptions,
      indexFingerOutOptions,
      indexFingerInOptions,
      middleFingerOutOptions,
      middleFingerInOptions,
      thirdFingerOutOptions,
      thirdFingerInOptions,
      littleFingerOutOptions,
      littleFingerInOptions,
      bandColorOptions,
      catchColorOptions,
      thumbHangerOptions,
      littleFingerHangerOptions,
      hemLeatherOptions,
      webBackOptions,
      webCatchOptions,
      webEdgeOptions,
      hirauraOptions,
      treasureBeltOptions,
      fingerCoverColorOptions,
        // 王冠用
        indexAndMiddleFingerOptions,
        middleAndThirdFingerOptions,
        thirdAndLittleFingerOptions,
        // ライナーバック用
        thumbIndexAndMiddleFingerOptions,
      linerBackBeltColorOptions,

      additionalOptions: [], // 動的に生成される選択肢
      laceColorOptions,
      stitchColorOptions,
      treasureLabelOptions, // トレジャーラベルの選択肢
      optionMainColorOptions,
      optionShadowColorOptions,
      optionStandColorOptions,

      isMainColorOpen: false,
      isThumbOutOpen: false,

      isThumbInOpen: false,
      isIndexFingerOutOpen: false,
      isIndexFingerInOpen: false,
      isMiddleFingerOutOpen: false,
      isMiddleFingerInOpen: false,
      isThirdFingerOutOpen: false,
      isThirdFingerInOpen: false,
      isLittleFingerOutOpen: false,
      isLittleFingerInOpen: false,
      isBandColorOpen: false,
      isCatchColorOpen: false,
      isThumbHangerOpen: false,
      isLittleFingerHangerOpen: false,
      isHemLeatherOpen: false,
      isWebBackOpen: false,
      isWebCatchOpen: false,
      isWebEdgeOpen: false,
      isHirauraOpen: false,
      isTreasureBeltOpen: false,
      isFingerCoverColorOpen: false,
        // 王冠用
        isIndexAndMiddleFingerOpen: false,
        isMiddleAndThirdFingerOpen: false,
        isThirdAndLittleFingerOpen: false,
        // ライナーバック用
        isThumbIndexAndMiddleFingerOpen: false,
      isLinerBackBeltColorOpen: false,

      isAdditionalPaletteOpen: false,
      isLaceColorOpen: false,
      isStitchColorOpen: false,

      isOptionMainColorOpen: false,
      isOptionShadowColorOpen: false,
      isOptionStandColorOpen: false,

      //刺繍
      savedSelections: [],
      // 使用済みの刺繍位置を格納する配列
      usedEmbroideryPositions: [],
      // 全ての刺繍位置
      embroideryPositionOptions,
      fontOptions,
      fontColorOptions,
      shadowEdgeOptions,
      shadowColorOptions,
      edgeColorOptions,

      isFontColorOpen: false,
      isShadowColorOpen: false,
      isEdgeColorOpen: false,
      // 現在の選択内容
      currentSelection: {
        embroideryPosition: null,
        font: null,
        fontColor: null,
        shadowEdge: null,
        shadowColor: null,
        edgeColor: null,
        embroideryContent: "",
      },
      isMobile: false,
      activeTab: "刺繍",
      newSelectionCache: null,
      activeTabIndex: null,
      showError: false, // 刺繍内容が未入力の場合のエラーメッセージ表示フラグ
      isShadowColorEnabled: false, // カゲカラーの有効状態
      isEdgeColorEnabled: false, // フチカラーの有効状態

      //その他読み込み
      isDropdownOpen: false,
      activeOptions: [], // 現在表示している選択肢
      isModalVisible: false, // モーダルの表示状態
      totalPrice: 0,
      inputId: "", // 入力用ID
      sessionID: "", // セッションID用のデータ
      activePart: "",
      colorOptionsMap: {
        mainColor: mainColorOptions,
      },
      labelMap: {
        mainColor: "本体",
      },
      activeDropdownId: null,
      missingFields: [],
      showAlert: false, // アラートの表示状態
      alertMessage: "", // アラートのメッセージ
      beforeFontChange: null,
      beforeSavedFontChange: {},
      embTextInputError: false,
      embSavedTextInputError0: false,
      embSavedTextInputError1: false,
      embSavedTextInputError2: false,
      embSavedTextInputError3: false,
      embSavedTextInputError4: false,
      displayEmbroideryPreview: true,
      isRestoring: false,
      enableSecondRow: false,
      allImagesLoaded: false,
      mainColorDependentKeys: [
        "thumbOut",
        "thumbIn",
        "indexFingerOut",
        "indexFingerIn",
        "middleFingerOut",
        "middleFingerIn",
        "thirdFingerOut",
        "thirdFingerIn",
        "littleFingerOut",
        "littleFingerIn",
        "bandColor",
        "catchColor",
        "thumbHanger",
        "littleFingerHanger",
        "hemLeather",
        "webBack",
        "webCatch",
        "webEdge",
        "hiraura",
        "treasureBelt",
        "fingerCoverColor",
        "linerBackBeltColor",
        "indexAndMiddleFinger",
        "middleAndThirdFinger",
        "thirdAndLittleFinger",
        "thumbIndexAndMiddleFinger",
      ],
      isDataRestoring: false, //カラー一括変更の動き制限




      // 小指側
      // バックスタイル配列
      pk_bk_reg: ["pk_bk-reg_pinky-in", "pk_bk-reg_pinky-out", "pk_bk-reg_index-in",
                  "pk_bk-reg_index-out", "pk_bk-reg_third-in", "pk_bk-reg_third-out",
                  "pk_bk-reg_middle-in", "pk_bk-reg_middle-out"],
      pk_bk_crwn: ["pk_bk-crwn_pinky", "pk_bk-crwn_index", "pk_bk-crwn_index-middle",
                   "pk_bk-crwn_middle-third", "pk_bk-crwn_third-pinky"],
      pk_bk_linr: ["pk_bk-linr_thumb-index", "pk_bk-linr_middle-third",
                   "pk_bk-linr_pinky","pk_bk-linr_third-pinky", "pk_bk-linr_stitch","pk_bk-linr_palm-lining", "pk_bk-linr_palm-lining-lace",
                   "pk_bk-linr_welting", "pk_bk-linr_blt", "pk_bk-linr_edge"],

      // ベルト配列
      // pk_blt_tbelt: ["pk_blt-tbelt_crotch", "pk_blt-tbelt_mark", "pk_blt-tbelt_stitch", "pk_blt-tbelt_lbl-base",
      //                 "pk_blt-tbelt_lbl-shadow", "pk_blt-tbelt_lbl-main", "pk_blt-tbelt_thumb-knot",
      //                 "pk_blt-tbelt_edge"],
      pk_blt_sep: ["pk_blt-sep_stitch", "pk_blt-sep_edge", "pk_blt-sep_palm-lining", "pk_blt-sep_edge-lace"],
      pk_blt_reg: ["pk_blt-reg_palm-lining", "pk_blt-reg_web_crotch-none", "pk_blt-reg_thumb-knot", "pk_blt-reg_stitch", "pk_blt-reg_edge"],
      pk_blt_tmb_lbl: ["pk_blt-tmb_stitch"],

      // 指アテ
      pk_finger_pad_index: ["pk_finger-pad_index", "pk_finger-pad_index_stitch"],
      pk_finger_pad_none_index: ["pk_finger-pad-none_index", "pk_finger-pad-none_index_stitch"],
      pk_finger_pad_middle: ["pk_finger-pad_middle", "pk_finger-pad_middle_stitch"],
      pk_finger_pad_none_middle: ["pk_finger-pad-none_middle", "pk_finger-pad-none_middle_stitch"],
      pk_finger_cov_index: ["pk_finger-cov_index", "pk_finger-cov_index_stitch"],
      pk_finger_cov_middle: ["pk_finger-cov_middle", "pk_finger-cov_middle_stitch"],
      pk_finger_opn_cov_between: ["pk_finger-opn-cov_between", "pk_finger-opn-cov_between_stitch"],
      pk_finger_opn_cov_index: ["pk_finger-opn-cov_index", "pk_finger-opn-cov_index_stitch"],
      pk_finger_opn_cov_middle: ["pk_finger-opn-cov_middle", "pk_finger-opn-cov_middle_stitch"],


      // 親指側
      // バックスタイル配列
      tb_bk_reg: ["tb_bk-reg_pinky-in", "tb_bk-reg_pinky-out", "tb_bk-reg_thumb-out", "tb_bk-reg_index-in",
                  "tb_bk-reg_index-out", "tb_bk-reg_third-in", "tb_bk-reg_third-out", "tb_bk-reg_ft",
                  "tb_bk-reg_middle-in", "tb_bk-reg_middle-out"],
      tb_bk_crwn: ["tb_bk-crwn_pinky", "tb_bk-crwn_thumb-out", "tb_bk-crwn_index", "tb_bk-crwn_index-middle",
                   "tb_bk-crwn_middle-third", "tb_bk-crwn_ft", "tb_bk-crwn_third-pinky"],
      tb_bk_linr: ["tb_bk-linr_thumb-index", "tb_bk-linr_thumb-in", "tb_share-welting", "tb_bk-linr_stitch", "tb_bk-linr_edge", "tb_bk-linr_blt", "tb_bk-linr_thumb-knot"],

      // ベルト配列
      tb_blt_tbelt: [ "tb_blt-tbelt_mark", "tb_blt-tbelt_stitch", "tb_blt-tbelt_lbl-base", "tb_blt-tbelt_thumb-knot", "tb_blt-reg_edge"],
      tb_blt_sep: ["tb_blt-sep_web", "tb_blt-sep_thumb-out", "tb_blt-sep_band", "tb_blt-sep_stitch", "tb_blt-sep_edge", "tb_blt-sep_edge-lace"],
      tb_blt_reg: ["tb_blt-reg_band", "tb_blt-reg_thumb-knot", "tb_blt-reg_stitch", "tb_blt-reg_edge"],
      tb_blt_tmb_lbl: ["tb_blt-tmb_thumb-knot", "tb_blt-tmb_stitch", "tb_blt-tmb_edge"],

      // 指アテ
      tb_finger_pad_index: ["tb_finger-pad_index_base", "tb_finger-pad_index_stitch"],
      tb_finger_pad_none_index: ["tb_finger-pad-none_index_base", "tb_finger-pad-none_index_stitch"],
      tb_finger_pad_middle: ["tb_finger-pad_middle_base", "tb_finger-pad_middle_stitch"],
      tb_finger_pad_none_middle: ["tb_finger-pad-none_middle_base", "tb_finger-pad-none_middle_stitch"],
      tb_finger_cov_index: ["tb_finger-cov_index_base", "tb_finger-cov_index_stitch"],
      tb_finger_cov_middle: ["tb_finger-cov_middle_base", "tb_finger-cov_middle_stitch"],
      tb_finger_opn_cov_between: ["tb_finger-opn-cov_between_base", "tb_finger-opn-cov_between_stitch"],
      tb_finger_opn_cov_index: ["tb_finger-opn-cov_index_base", "tb_finger-opn-cov_index_stitch"],
      tb_finger_opn_cov_middle: ["tb_finger-opn-cov_middle_base", "tb_finger-opn-cov_middle_stitch"],


      // 背面
      // バックスタイル配列
      bs_bk_reg: ["bs_bk-reg_pinky-in", "bs_bk-reg_pinky-out", "bs_bk-reg_thumb-out", "bs_bk-reg_index-in",
                  "bs_bk-reg_index-out", "bs_bk-reg_third-in", "bs_bk-reg_third-out", "bs_bk-reg_ft",
                  "bs_bk-reg_middle-in", "bs_bk-reg_middle-out"],
      bs_bk_crwn: ["bs_bk-crwn_pinky", "bs_bk-crwn_thumb-out", "bs_bk-crwn_index", "bs_bk-crwn_index-middle",
                   "bs_bk-crwn_middle-third", "bs_bk-crwn_ft", "bs_bk-crwn_third-pinky"],
      // bs_bk_linr: ["bs_bk-linr_pinky-all", "bs_bk-linr_thumb-index", "bs_bk-linr_middle-third", "bs_bk-linr_ft",
      //              "bs_bk-linr_third-pinky", "bs_bk-linr_stitch", "bs_bk-linr_edge", "bs_bk-linr_blt", "bs_bk-linr_pinky_lbl-shadow",
      //              "bs_bk-linr_pinky_lbl-main", "bs_bk-linr_pinky_lbl-base", "bs_bk-linr_thumb_lbl-shadow", "bs_bk-linr_thumb_lbl-main",
      //              "bs_bk-linr_thumb_lbl-base", "bs_bk-linr_thumb-knot", "bs_bk-linr_palm-lining", "bs_bk-linr_palm-lining-lace"],
      bs_bk_linr: ["bs_bk-linr_pinky-all", "bs_bk-linr_thumb-index", "bs_bk-linr_middle-third", "bs_bk-linr_ft",
                   "bs_bk-linr_third-pinky", "bs_bk-linr_stitch", "bs_bk-linr_edge", "bs_bk-linr_welting", "bs_bk-linr_blt",
                   "bs_bk-linr_thumb-knot", "bs_bk-linr_palm-lining", "bs_bk-linr_palm-lining-lace", "bs_bk-linr_thumb_lbl-base", "bs_bk-linr_thumb_lbl-shadow", "bs_bk-linr_thumb_lbl-main"],

      // ベルト配列
      bs_blt_tbelt: ["bs_blt-tbelt_palm-lining", "bs_blt-tbelt_crotch-none", "bs_blt-tbelt_mark", "bs_blt-tbelt_stitch", "bs_blt-tbelt_thumb-knot", "bs_blt-tbelt_edge"],
      bs_blt_sep: ["bs_blt-sep_palm-lining", "bs_blt-sep_web_crotch-none", "bs_blt-sep_band", "bs_blt-sep_stitch", "bs_blt-sep_edge", "bs_blt-sep_edge-lace"],
      bs_blt_reg: ["bs_blt-reg_palm-lining", "bs_blt-reg_web_crotch-none", "bs_blt-reg_band","bs_blt-reg_thumb-knot", "bs_blt-reg_stitch", "bs_blt-reg_edge"],
      bs_blt_tmb_lbl: ["bs_blt-tmb_palm-lining", "bs_blt-reg_web_crotch-none", "bs_blt-tmb_stitch", "bs_blt-tmb_edge"],

      // 指アテ
      bs_finger_pad_index: ["bs_finger-pad_index_base", "bs_finger-pad_index_stitch"],
      bs_finger_pad_none_index: ["bs_finger-pad-none_index_base", "bs_finger-pad-none_index_stitch",],
      bs_finger_pad_middle: ["bs_finger-pad_middle_base", "bs_finger-pad_middle_stitch"],
      bs_finger_pad_none_middle: ["bs_finger-pad-none_middle_base", "bs_finger-pad-none_middle_stitch","bs_finger-pad-none_middle-tbelt_stitch","bs_finger-pad-none_middle-sep_stitch"],
      bs_finger_cov_index: ["bs_finger-cov_index_base", "bs_finger-cov_index_stitch"],
      bs_finger_cov_middle: ["bs_finger-cov_middle_base", "bs_finger-cov_middle_stitch"],
      bs_finger_opn_cov_between: ["bs_finger-opn-cov_between_base", "bs_finger-opn-cov_between_stitch"],
      bs_finger_opn_cov_index: ["bs_finger-opn-cov_index_base", "bs_finger-opn-cov_index_stitch"],
      bs_finger_opn_cov_middle: ["bs_finger-opn-cov_middle_base", "bs_finger-opn-cov_middle_stitch"],
      bs_finger_pad_index_tbelt: ["bs_finger-pad_index-tbelt_base", "bs_finger-pad_index-tbelt_stitch"],
      bs_finger_pad_middle_tbelt: ["bs_finger-pad_middle-tbelt_base", "bs_finger-pad_middle-tbelt_stitch"],
      bs_finger_pad_index_sep: ["bs_finger-pad_index-sep_base", "bs_finger-pad_index-sep_stitch"],
      bs_finger_pad_middle_sep: ["bs_finger-pad_middle-sep_base", "bs_finger-pad_middle-sep_stitch"],

      // グローブ表示方向の制御
      isGlobeDirection: "背面",

      // ウェブ親指面
      tb_w_3: ["tb_web_frame_base01", "tb_web_frame_base02", "tb_w-3_w-6_w-7_lining", "tb_web_frame_top01", "tb_w-3_w-6_stitch", "tb_web_lace_top02", "tb_web_stitch_top01", "tb_web_lace_top01", "tb_web_lace_base01"],

      tb_w_5: ["tb_web_frame_base02", "tb_web_frame_top01", "tb_web_frame_base01", "tb_web_stitch_base01", "tb_web_lace_top02", "tb_web_stitch_top01", "tb_web_lace_top01", "tb_web_lace_base01"],

      tb_w_6: ["tb_web_frame_top02", "tb_web_lace_base03", "tb_web_lace_top03", "tb_web_lace_top02", "tb_web_stitch_top02", "tb_web_frame_base03", "tb_web_stitch_base02", "tb_web_lace_top01", "tb_web_frame_base-vertical02", "tb_web_stitch_vertical01", "tb_web_front-lace_middle01", "tb_web_front-lace_bottom01"],

      tb_w_8: ["tb_web_lace_base03", "tb_web_lace_top03", "tb_web_frame_top02", "tb_web_stitch_top02", "tb_web_frame_base03", "tb_web_stitch_base02", "tb_web_lace_top01", "tb_web_frame_base-vertical02", "tb_web_stitch_vertical02", "tb_web_lace_vertical","tb_w-8_front-lace"],

      tb_w_10: ["tb_web_lace_base03", "tb_web_lace_top03", "tb_web_frame_top02", "tb_web_stitch_top02", "tb_web_frame_base03", "tb_web_stitch_base02", "tb_web_lace_top01", "tb_web_frame_base-vertical02", "tb_web_stitch_vertical02", "tb_web_lace_vertical", "tb_web_front-lace_bottom05", "tb_web_front-lace_bottom01"],

      tb_w_11: ["tb_web_frame_base04", "tb_web_stitch_base03", "tb_web_lace_top03", "tb_web_lace_base04", "tb_web_frame_top02", "tb_web_stitch_top02", "tb_web_lace_top01", "tb_w-11_base-vertical", "tb_w-11_stitch", "tb_web_lace_base02", "tb_w-11_t-5_front-lace"],

      tb_w_12: ["tb_web_frame_base02", "tb_w-12_base", "tb_w-12_stitch", "tb_w-12_back-lace", "tb_web_frame_top01", "tb_web_lace_top02", "tb_web_stitch_top01", "tb_web_lace_top01", "tb_web_front-lace_top02", "tb_web_lace_base01"],

      tb_w_13: ["tb_web_frame_base02", "tb_w-13_base", "tb_w-13_stitch", "tb_w-13_back-lace", "tb_web_frame_top01", "tb_web_lace_top02", "tb_web_stitch_top01", "tb_web_lace_top01", "tb_web_front-lace_top02", "tb_web_lace_base01", "tb_w-13_front-lace"],

      tb_w_14: ["tb_web_lace_top03", "tb_web_frame_top02", "tb_web_stitch_top02", "tb_web_lace_top01", "tb_web_frame_base-vertical01", "tb_web_stitch_vertical03", "tb_web_front-lace_top01", "tb_w-14_front-lace"],

      tb_w_15: ["tb_web_lace_top03", "tb_web_frame_top02", "tb_web_stitch_top02", "tb_web_lace_top01", "tb_web_frame_base-vertical01", "tb_web_stitch_vertical03", "tb_web_front-lace_bottom06", "tb_w-15_front-lace"],

      tb_w_16: ["tb_w-16_base", "tb_w-16_edge", "tb_w-16_stitch",  "tb_w-16_front-lace", "tb_web_front-lace_bottom06"],
      
      tb_w_17: ["tb_web_lace_top03", "tb_web_frame_top02", "tb_web_stitch_top02", "tb_web_lace_top01", "tb_web_frame_base-vertical01", "tb_web_stitch_vertical03", "tb_web_front-lace_top01", "tb_w-17_front-lace", "tb_web_front-lace_bottom06"],

      tb_w_19: ["tb_w-19_back-lace", "tb_w-19_base", "tb_web_lace_top03", "tb_w-19_stitch", "tb_web_frame_top02", "tb_web_stitch_top02", "tb_web_lace_top01", "tb_web_frame_base-vertical02", "tb_web_stitch_vertical02", "tb_web_lace_vertical", "tb_web_front-lace_bottom01", "tb_web_front-lace_bottom03"],

      tb_w_22: ["tb_web_lace_base03", "tb_web_lace_top03", "tb_web_frame_top02", "tb_web_frame_base03", "tb_web_stitch_base02", "tb_web_stitch_top02", "tb_web_lace_top01", "tb_web_frame_base-vertical02", "tb_web_stitch_vertical01", "tb_web_front-lace_bottom01"],

      tb_w_23: ["tb_web_lace_base03", "tb_web_lace_top03", "tb_web_frame_top02", "tb_web_stitch_top02", "tb_web_frame_base03", "tb_web_stitch_base02", "tb_web_lace_top01", "tb_w-23_base", "tb_w-23_base-vertical", "tb_w-23_stitch", "tb_w-23_front-lace"],

      tb_w_24: ["tb_web_lace_top03", "tb_w-24_base", "tb_w-24_top", "tb_w-24_stitch", "tb_web_lace_base02", "tb_web_lace_top01", "tb_w-24_front-lace"],

      tb_w_27: ["tb_web_frame_base04", "tb_web_stitch_base03", "tb_web_lace_base04", "tb_web_frame_top04", "tb_web_frame_top03", "tb_web_stitch_top03", "tb_web_lace_top04", "tb_w-27_base-vertical", "tb_w-27_stitch", "tb_web_lace_base02", "tb_w-27_front-lace"],

      tb_w_28: ["tb_web_lace_base03", "tb_web_frame_top04", "tb_web_frame_top03", "tb_web_stitch_top03", "tb_web_lace_top04", "tb_web_frame_base03", "tb_web_stitch_base02", "tb_w-28_base", "tb_w-28_stitch", "tb_w-28_back-lace", "tb_web_front-lace_bottom01", "tb_web_front-lace_bottom03"],

      tb_w_29: ["tb_web_lace_base03", "tb_web_lace_top03", "tb_web_frame_top02", "tb_web_frame_base03", "tb_web_stitch_base02", "tb_web_stitch_top02", "tb_web_lace_top01", "tb_web_frame_base-vertical02", "tb_web_stitch_vertical01", "tb_web_front-lace_middle01", "tb_web_front-lace_bottom05"],

      tb_w_30: ["tb_web_lace_base03",  "tb_web_lace_top03", "tb_web_frame_top02", "tb_web_stitch_top02", "tb_web_frame_base03","tb_web_stitch_base02", "tb_web_lace_top01", "tb_w-30_base-vertical", "tb_w-30_stitch", "tb_web_front-lace_bottom01"],


      // tb_t_1: ["tb_web_frame_base02", "tb_web_frame_top01", "tb_web_frame_base01", "tb_t-1_lining", "tb_web_stitch_base01", "tb_t-1_stitch", "tb_web_lace_top02", "tb_web_stitch_top01", "tb_web_lace_top01", "tb_web_lace_base01"],

      // tb_t_2: ["tb_web_frame_base02", "tb_web_frame_top01", "tb_web_frame_base01", "tb_t-2_lining", "tb_t-2_stitch", "tb_web_lace_top02", "tb_web_stitch_top01", "tb_web_lace_top01", "tb_web_lace_base01", "tb_t-2_front-lace"],

      // tb_t_3: ["tb_web_frame_base02", "tb_web_frame_top01", "tb_web_frame_base01", "tb_t-3_stitch", "tb_web_stitch_base01", "tb_web_lace_top02", "tb_web_stitch_top01", "tb_web_lace_top01", "tb_t-3_lining", "tb_web_lace_base01"],

      // tb_t_4: ["tb_web_frame_base02", "tb_web_frame_base01", "tb_t-4_stitch", "tb_web_frame_top01", "tb_web_lace_top02", "tb_web_stitch_top01", "tb_web_lace_base01", "tb_web_lace_top01", "tb_t-4_front-lace", "tb_t-4_lining"],

      tb_t_5: ["tb_web_frame_base04", "tb_web_stitch_base03", "tb_web_lace_top03", "tb_web_lace_base04", "tb_web_frame_top02", "tb_web_stitch_top02", "tb_web_lace_top01", "tb_t-5_base", "tb_t-5_base-vertical", "tb_t-5_stitch", "tb_web_front-lace_bottom01", "tb_w-11_t-5_front-lace"],

      tb_t_6: ["tb_web_frame_base02", "tb_web_frame_base01", "tb_w-3_w-6_stitch", "tb_w-3_w-6_w-7_lining", "tb_web_stitch_base01", "tb_web_frame_top04", "tb_web_frame_top03", "tb_web_lace_top04", "tb_web_stitch_top03", "tb_web_lace_base01"],

      tb_t_7: ["tb_t-7_base", "tb_web_frame_top01", "tb_web_frame_base01", "tb_web_lace_top02", "tb_web_stitch_top01", "tb_web_lace_top01", "tb_w-3_w-6_w-7_lining", "tb_t-7_stitch", "tb_t-7_front-lace"],

      tb_t_8: ["tb_web_frame_top04", "tb_web_frame_top03", "tb_t-8_base", "tb_web_lace_top04", "tb_t-8_stitch", "tb_web_stitch_top03", "tb_web_front-lace_bottom06", "tb_t-8_front-lace"],

      tb_t_9: ["tb_t-9_base02", "tb_t-9_base", "tb_web_frame_top01", "tb_web_lace_top02", "tb_t-9_stitch", "tb_web_stitch_top01", "tb_web_lace_top01", "tb_t-9_front-lace"],

      tb_t_12: ["tb_web_lace_top03", "tb_web_frame_top02", "tb_web_stitch_top02", "tb_web_lace_top01", "tb_t-12_base", "tb_t-12_stitch", "tb_t-12_front-lace", "tb_t-12_lining", "tb_web_front-lace_top01", "tb_web_front-lace_bottom06"],




      //ウェブ背面
      bs_w_3: ["bs_web_frame_base02", "bs_web_frame_base01", "bs_web_stitch_base01", "bs_web_frame_top01", "bs_web_lace_top01", "bs_web_lace_top02", "bs_web_stitch_top01", "bs_w-3_stitch", "bs_w-3_w-7_lining", "bs_web_lace_base01"],

      bs_w_5: ["bs_web_frame_base02", "bs_web_frame_base01", "bs_web_stitch_base01", "bs_web_frame_top01", "bs_web_lace_top01", "bs_web_lace_top02", "bs_web_stitch_top01", "bs_web_lace_base01"],

      bs_w_6: ["bs_web_lace_base03", "bs_web_frame_base03", "bs_web_stitch_base02", "bs_web_lace_top03", "bs_web_frame_top02", "bs_web_stitch_top02", "bs_web_lace_top01", "bs_web_frame_base-vertical02", "bs_web_stitch_vertical01", "bs_web_front-lace_middle01", "bs_web_front-lace_bottom02", "bs_web_front-lace_bottom01"],

      bs_w_8: ["bs_web_lace_base03", "bs_web_frame_base03", "bs_web_stitch_base02", "bs_web_lace_top03", "bs_web_frame_top02", "bs_web_stitch_top02", "bs_web_lace_top01", "bs_web_frame_base-vertical02", "bs_web_stitch_vertical02", "bs_web_lace_vertical", "bs_w-8_front-lace"],

      bs_w_10: ["bs_web_lace_base03", "bs_web_frame_base03", "bs_web_stitch_base02", "bs_web_lace_top03", "bs_web_frame_top02", "bs_web_stitch_top02", "bs_web_lace_top01", "bs_web_frame_base-vertical02", "bs_web_stitch_vertical02", "bs_web_lace_vertical", "bs_web_front-lace_bottom05", "bs_web_front-lace_bottom01"],

      bs_w_11: ["bs_web_frame_base04", "bs_web_lace_base04", "bs_web_lace_top03", "bs_web_frame_top02", "bs_web_stitch_top02", "bs_web_lace_top01", "bs_web_stitch_base03", "bs_w-11_base-vertical", "bs_web_lace_base02", "bs_w-11_stitch", "bs_w-11_front-lace"],

      bs_w_12: ["bs_web_frame_base02", "bs_w-12_base", "bs_w-12_stitch", "bs_w-12_back-lace", "bs_web_frame_top01", "bs_web_lace_top01", "bs_web_lace_top02", "bs_web_stitch_top01", "bs_web_front-lace_top02", "bs_web_lace_base01"],

      bs_w_13: ["bs_web_frame_base02", "bs_w-13_base", "bs_w-13_back-lace", "bs_w-13_stitch", "bs_web_frame_top01", "bs_w-13_front-lace", "bs_web_lace_base01", "bs_web_stitch_top01", "bs_web_lace_top01", "bs_web_lace_top02", "bs_web_front-lace_top02"],

      bs_w_14: ["bs_web_lace_top03", "bs_web_frame_top02", "bs_web_stitch_top02", "bs_web_lace_top01", "bs_web_frame_base-vertical01", "bs_web_stitch_vertical03", "bs_w-14_front-lace", "bs_web_front-lace_top01"],

      bs_w_15: ["bs_web_lace_top03", "bs_web_frame_top02", "bs_web_stitch_top02", "bs_web_lace_top01", "bs_web_frame_base-vertical01", "bs_web_stitch_vertical03", "bs_w-15_front-lace", "bs_web_front-lace_bottom06"],

      bs_w_16: ["bs_w-16_base", "bs_w-16_edge", "bs_w-16_stitch", "bs_w-16_front-lace", "bs_web_front-lace_bottom06"],

      bs_w_17: ["bs_web_lace_top03",  "bs_web_frame_top02", "bs_web_stitch_top02", "bs_web_lace_top01", "bs_web_frame_base-vertical01", "bs_web_stitch_vertical03", "bs_w-17_front-lace", "bs_web_front-lace_top01", "bs_web_front-lace_bottom06"],

      bs_w_19: ["bs_w-19_back-lace", "bs_w-19_base", "bs_w-19_stitch", "bs_web_lace_top03", "bs_web_frame_top02", "bs_web_stitch_top02", "bs_web_lace_top01", "bs_web_frame_base-vertical02", "bs_web_stitch_vertical02", "bs_web_lace_vertical", "bs_web_front-lace_bottom04", "bs_web_front-lace_bottom02", "bs_web_front-lace_bottom01", "bs_web_front-lace_bottom03"],

      bs_w_22: ["bs_web_frame_base03", "bs_web_stitch_base02", "bs_web_lace_top03", "bs_web_lace_base03", "bs_web_frame_top02", "bs_web_stitch_top02", "bs_web_lace_top01", "bs_web_frame_base-vertical02", "bs_web_stitch_vertical01", "bs_web_front-lace_bottom02", "bs_web_front-lace_bottom01"],

      bs_w_23: ["bs_web_lace_base03", "bs_web_frame_base03", "bs_web_stitch_base02", "bs_web_lace_top03", "bs_web_frame_top02", "bs_web_stitch_top02", "bs_web_lace_top01", "bs_w-23_back-lace", "bs_w-23_base", "bs_w-23_base-vertical", "bs_w-23_stitch", "bs_w-23_front-lace"],

      bs_w_24: ["bs_w-24_base", "bs_w-24_top", "bs_w-24_stitch", "bs_web_lace_top01", "bs_w-24_back-lace", "bs_web_lace_base02", "bs_w-24_front-lace"],

      bs_w_27: ["bs_web_lace_base04", "bs_web_frame_top04", "bs_web_frame_base04", "bs_web_frame_top03", "bs_web_stitch_top03", "bs_web_stitch_base03", "bs_web_lace_top04", "bs_w-27_base-vertical", "bs_w-27_stitch", "bs_web_lace_base02", "bs_w-27_front-lace"],

      bs_w_28: ["bs_web_frame_top04", "bs_web_frame_top03", "bs_web_stitch_top03", "bs_web_lace_top04", "bs_w-28_base-horizontal", "bs_w-28_base-vertical", "bs_w-28_stitch", "bs_w-28_back-lace", "bs_web_front-lace_bottom04", "bs_w-28_front-lace", "bs_web_front-lace_bottom02", "bs_web_front-lace_bottom01", "bs_web_front-lace_bottom03"],

      bs_w_29: ["bs_web_lace_base03", "bs_web_frame_base03", "bs_web_stitch_base02", "bs_web_lace_top03", "bs_web_frame_top02", "bs_web_stitch_top02", "bs_web_lace_top01", "bs_web_frame_base-vertical02", "bs_web_stitch_vertical01", "bs_web_front-lace_middle01", "bs_web_front-lace_bottom05"],

      bs_w_30: ["bs_web_lace_base03", "bs_web_frame_base03", "bs_web_stitch_base02", "bs_web_lace_top03", "bs_web_frame_top02", "bs_web_stitch_top02", "bs_web_lace_top01", "bs_w-30_base-vertical", "bs_w-30_stitch", "bs_web_front-lace_bottom02", "bs_web_front-lace_bottom01"],


      // bs_t_1: ["bs_web_frame_base02", "bs_web_frame_base01", "bs_t-1_lining", "bs_web_stitch_base01", "bs_web_frame_top01", "bs_t-1_stitch", "bs_web_lace_top01", "bs_web_lace_top02", "bs_web_stitch_top01", "bs_web_lace_base01"],

      // bs_t_2: ["bs_web_frame_base02", "bs_web_frame_base01", "bs_t-2_lining", "bs_t-2_stitch", "bs_web_frame_top01", "bs_web_lace_top01", "bs_web_lace_top02", "bs_web_stitch_top01", "bs_web_lace_base01", "bs_t-2_front-lace"],

      // bs_t_3: ["bs_web_frame_base02", "bs_web_frame_base01", "bs_web_stitch_base01", "bs_web_frame_top01", "bs_t-3_stitch", "bs_web_lace_top01", "bs_web_lace_top02", "bs_web_stitch_top01", "bs_web_lace_base01", "bs_t-3_lining"],

      // bs_t_4: ["bs_web_frame_base02", "bs_web_frame_base01", "bs_t-4_lining", "bs_t-4_stitch", "bs_web_frame_top01", "bs_web_lace_top01", "bs_web_lace_top02", "bs_web_stitch_top01", "bs_web_lace_base01", "bs_t-4_front-lace"],

      bs_t_5: ["bs_web_lace_top03", "bs_web_frame_top02", "bs_web_stitch_top02", "bs_web_lace_top01", "bs_t-5_base-horizontal", "bs_t-5_base-vertical", "bs_t-5_base", "bs_t-5_stitch", "bs_t-5_front-lace"],

      bs_t_6: ["bs_web_frame_base02", "bs_web_frame_base01", "bs_t-6_lining", "bs_t-6_stitch", "bs_web_frame_top04", "bs_web_frame_top03", "bs_web_stitch_top03", "bs_web_lace_top04", "bs_web_lace_base01"],

      bs_t_7: ["bs_web_frame_base01", "bs_web_frame_top01", "bs_web_lace_top01", "bs_web_lace_top02", "bs_t-7_base", "bs_web_stitch_top01", "bs_t-7_stitch", "bs_w-3_w-7_lining", "bs_t-7_front-lace"],

      bs_t_8: ["bs_web_frame_top05", "bs_web_frame_top03", "bs_web_stitch_top03", "bs_web_lace_top04", "bs_t-8_base", "bs_t-8_stitch", "bs_t-8_front-lace", "bs_web_front-lace_bottom06"],

      bs_t_9: ["bs_t-9_base02", "bs_t-9_base", "bs_web_frame_top01", "bs_web_lace_top01", "bs_web_lace_top02", "bs_web_stitch_top01", "bs_t-9_stitch", "bs_t-9_front-lace"],

      bs_t_12: ["bs_web_lace_top03", "bs_web_frame_top02", "bs_web_lace_top01", "bs_t-12_base", "bs_t-12_stitch", "bs_t-12_lining", "bs_t-12_front-lace", "bs_web_front-lace_top01", "bs_web_front-lace_bottom06"],



      // ウェブ補給面
      ft_w_3: ["ft_web_frame_base01", "ft_web_stitch_base01", "ft_web_stitch_top01",  "ft_w-3_stitch", "ft_w-3_w-7_lining", "ft_web_lace_top01"],

      ft_w_5: ["ft_web_frame_base01", "ft_web_stitch_base01", "ft_web_stitch_top01", "ft_web_lace_top01"],
      
      ft_w_6: ["ft_web_frame_base-vertical01", "ft_web_stitch_vertical01", "ft_web_lace_base02", "ft_web_frame_base02", "ft_web_stitch_base02", "ft_web_frame_top01", "ft_web_stitch_top02", "ft_web_lace_top01"],

      ft_w_8: ["ft_web_frame_base-vertical01", "ft_web_stitch_vertical01", "ft_web_lace_base02", "ft_web_frame_base02", "ft_web_stitch_base02", "ft_web_frame_top01", "ft_web_stitch_top02", "ft_web_lace_top01"],

      ft_w_10: ["ft_web_frame_base-vertical01", "ft_web_stitch_vertical01", "ft_web_lace_base02", "ft_web_frame_base02", "ft_web_stitch_base02", "ft_web_frame_top01", "ft_web_stitch_top02", "ft_web_lace_top01"],

      ft_w_11: ["ft_web_lace_base03", "ft_web_lace_base04", "ft_w-11_base", "ft_w-11_stitch", "ft_web_frame_base03", "ft_web_stitch_base03", "ft_web_frame_top01", "ft_web_stitch_top02", "ft_web_lace_top01"],

      ft_w_12: ["ft_w-12_base", "ft_w-12_stitch", "ft_w-12_back-lace", "ft_web_frame_top01", "ft_web_stitch_top02", "ft_web_lace_top01"],

      ft_w_13: ["ft_w-13_base", "ft_w-13_stitch", "ft_w-13_back-lace", "ft_web_frame_top01", "ft_web_stitch_top02", "ft_web_lace_top01"],

      ft_w_14: ["ft_web_frame_base-vertical02", "ft_web_stitch_vertical02", "ft_w-14_back-lace", "ft_web_frame_top01", "ft_web_stitch_top02", "ft_web_lace_top01"],

      ft_w_15: ["ft_web_frame_base-vertical02", "ft_web_stitch_vertical02", "ft_w-15_back-lace", "ft_web_frame_top01", "ft_web_stitch_top02", "ft_web_lace_top01"],

      ft_w_16: ["ft_w-16_base", "ft_w-16_edge", "ft_w-16_stitch", "ft_w-16_back-lace"],

      ft_w_17: ["ft_web_frame_base-vertical02", "ft_web_stitch_vertical02", "ft_w-17_back-lace", "ft_web_frame_top01", "ft_web_stitch_top02", "ft_web_lace_top01"],

      ft_w_19: ["ft_web_frame_base-vertical01", "ft_web_stitch_vertical01", "ft_w-19_base", "ft_w-19_stitch", "ft_w-19_back-lace", "ft_web_frame_top01", "ft_web_stitch_top02", "ft_web_lace_top01"],

      ft_w_22: ["ft_web_frame_base-vertical01", "ft_web_stitch_vertical01", "ft_web_lace_base02", "ft_web_frame_base02", "ft_web_stitch_base02", "ft_web_frame_top01", "ft_web_stitch_top02", "ft_web_lace_top01"],

      ft_w_23: ["ft_web_lace_base02", "ft_w-23_base-vertical", "ft_w-23_base", "ft_w-23_stitch", "ft_web_frame_base02", "ft_web_stitch_base02", "ft_web_frame_top01", "ft_web_stitch_top02", "ft_web_lace_top01"],

      ft_w_24: ["ft_web_lace_base04", "ft_w-24_base", "ft_w-24_stitch", "ft_web_stitch_top01", "ft_web_lace_top01"],

      ft_w_27: ["ft_web_frame_base-vertical03", "ft_web_stitch_vertical03", "ft_web_lace_base03", "ft_web_lace_base04", "ft_web_frame_base03", "ft_web_stitch_base03", "ft_web_frame_top03", "ft_web_frame_top02", "ft_web_stitch_top03", "ft_web_lace_top02"],

      ft_w_28: ["ft_web_frame_base-vertical01", "ft_web_stitch_vertical01", "ft_web_lace_base03", "ft_web_frame_base03", "ft_web_stitch_base03", "ft_web_frame_top03", "ft_web_frame_top02", "ft_web_stitch_top03", "ft_web_lace_top02"],

      ft_w_29: ["ft_web_frame_base-vertical01", "ft_web_stitch_vertical01", "ft_web_lace_base02", "ft_web_frame_base02", "ft_web_stitch_base02", "ft_web_frame_top01", "ft_web_stitch_top02", "ft_web_lace_top01"],

      ft_w_30: ["ft_web_lace_base02", "ft_w-30_base", "ft_w-30_stitch", "ft_web_frame_base02", "ft_web_stitch_base02", "ft_web_frame_top01", "ft_web_stitch_top02", "ft_web_lace_top01"],


      // ft_t_1: ["ft_web_frame_base01", "ft_t-1_stitch", "ft_web_lace_top01"],

      // ft_t_2: ["ft_web_frame_base01", "ft_t-2_stitch", "ft_t-2_back-lace", "ft_web_lace_top01"],

      // ft_t_3: ["ft_web_frame_base01", "ft_t-3_stitch", "ft_t-3_back-lace", "ft_web_lace_top01"],

      // ft_t_4: ["ft_web_frame_base01", "ft_t-4_stitch", "ft_t-4_back-lace", "ft_web_lace_top01"],

      ft_t_5: ["ft_web_frame_base-vertical03", "ft_web_stitch_vertical03", "ft_web_lace_base03", "ft_web_frame_base03", "ft_web_stitch_base03", "ft_t-5_base", "ft_t-5_stitch", "ft_web_frame_top01", "ft_web_stitch_top02", "ft_web_lace_top01"],

      ft_t_6: ["ft_web_frame_base01", "ft_t-6_stitch", "ft_t-6_lining", "ft_web_frame_top02", "ft_web_lace_top02", "ft_web_stitch_top03"],

      ft_t_7: ["ft_web_frame_base01", "ft_web_stitch_base01", "ft_t-7_stitch", "ft_w-3_w-7_lining", "ft_t-7_back-lace", "ft_web_stitch_top01", "ft_web_lace_top01"],

      ft_t_8: ["ft_web_frame_base-vertical02", "ft_web_stitch_vertical02", "ft_t-8_back-lace", "ft_web_frame_top03", "ft_web_frame_top02", "ft_web_stitch_top03", "ft_t-8_back-lace02", "ft_web_lace_top02"],

      ft_t_9: ["ft_t-9_base", "ft_t-9_stitch", "ft_t-9_back-lace", "ft_web_lace_top01"],

      ft_t_12: ["ft_web_frame_base-vertical02", "ft_t-12_stitch", "ft_t-12_lining", "ft_t-12_back-lace", "ft_web_frame_top01", "ft_web_stitch_top02", "ft_web_lace_top01"],


    };
  },

  // created() {
  //   // localStorageから保存済みの selectedData を取得
  //   const selectedData = localStorage.getItem("selectedData");
  //   if (selectedData) {
  //     this.selected = JSON.parse(selectedData);
  //   }

  //   // 必要なら savedSelections も取得
  //   const savedSelectionsStr = localStorage.getItem("savedSelections");
  //   if (savedSelectionsStr) {
  //     this.savedSelections = JSON.parse(savedSelectionsStr);
  //   }

  //   this.calculateTotal();
  // },

  // created() {
  //   // クエリパラメータ restoreData が "true" の場合のみデータを復元
  //   if (this.$route.query.restoreData === "true") {
  //     // localStorageから保存済みの selectedData を取得
  //     const selectedData = localStorage.getItem("selectedData");
  //     if (selectedData) {
  //       this.selected = JSON.parse(selectedData);
  //     }

  //     // 必要なら savedSelections も取得
  //     const savedSelectionsStr = localStorage.getItem("savedSelections");
  //     if (savedSelectionsStr) {
  //       this.savedSelections = JSON.parse(savedSelectionsStr);
  //     }

  //     // データ復元後に金額を再計算
  //     this.calculateTotal();
  //   }
  // },

  created() {
    if (sessionStorage.getItem("restoreData") === "true") {
      this.restoreDataFromLocalStorage();
      sessionStorage.removeItem("restoreData");
    }
  },

  computed: {
    //ステッチの影色
    stitchShadowClass() {
      const mainColor = this.selected.mainColor;
      const stitchColor = this.selected.stitchColor;

      const darkMainColors = ["ブラック", "ネイビー", "ブルー", "チョコ"];
      const lightMainColors = ["レモン", "ホワイト", "キャメル"];
      const darkStitchColors = [ "ブラック", "ネイビー", "ブルー", "パープル", "コルク", "グリーン"];
      const lightStitchColors = ["イエロー", "ホワイト", "キャメル"];

      const isDarkMain = darkMainColors.includes(mainColor);
      const isLightMain = lightMainColors.includes(mainColor);
      const isDarkStitch = darkStitchColors.includes(stitchColor);
      const isLightStitch = lightStitchColors.includes(stitchColor);

      if (isDarkMain && isDarkStitch) {
        return "stitch-shadow-white";
      } else if (isLightMain && isLightStitch) {
        return "stitch-shadow-black";
      }

      // 本体色×ステッチ色の組み合わせ別の影色指定
      const whiteShadowCombinations = {
        サックス: ["Lゴールド"],
        オレンジ: ["Lシルバー", "Lゴールド"],
        Dオレンジ: ["Lシルバー", "Lゴールド"],
        レッド: ["Lシルバー", "Lゴールド"],
        ピンク: ["Lシルバー", "Lゴールド"],
        パープル: ["Lシルバー"],
        コルク: ["Lシルバー"],
        チョコ: ["Lシルバー"],
        グリーン: ["サックス", "オレンジ", "レッド", "ピンク", "パープル", "コルク", "グリーン", "Lシルバー", "Lゴールド"],
        Mグリーン: ["サックス", "イエロー", "Lシルバー", "Lゴールド"],
        グレー: ["Lシルバー"],
        シルバー: ["Lシルバー"],
      };
      const blackShadowCombinations = {
        サックス: ["サックス", "Lシルバー"],
        オレンジ: ["オレンジ", "レッド", "ピンク"],
        Dオレンジ: ["オレンジ", "レッド", "ピンク"],
        レッド: ["オレンジ", "レッド", "ピンク"],
        ピンク: ["オレンジ", "レッド", "ピンク"],
        パープル: ["パープル", "コルク"],
        レモン: ["Lゴールド"],
        コルク: ["パープル", "コルク", "グリーン"],
        グリーン: ["ブラック", "ネイビー", "ブルー"],
        Mグリーン: ["グリーン"],
        グレー: ["コルク", "グリーン"],
        キャメル: ["Lゴールド"],
        ゴールド: ["イエロー", "キャメル", "Lゴールド"],
      };

      if (whiteShadowCombinations[mainColor]?.includes(stitchColor)) {
        return "stitch-shadow-white";
      } else if (blackShadowCombinations[mainColor]?.includes(stitchColor)) {
        return "stitch-shadow-black";
      }

      return "";
    },
    //////////////////////////////////////////
    ///////////        パーツ       ///////////
    //////////////////////////////////////////
    filteredBackStyleOptions() {
      if (!this.selected.typeName) {
        return [];
      }

      return this.backStyleOptions.filter((option) =>
        option.allowedTypeNames.includes(this.selected.typeName)
      );
    },
    partsDropdownItems() {
      return [
        // {
        //   key: "modelChoice", // selectedのキー
        //   label: "モデル選択",
        //   label2: "選択してください",
        //   refName: "modelChoiceDropdown",
        //   options: this.modelChoiceOptions,
        //   //middle-sideにhtml要素を表示させる必要があるならIDを設定
        //   dropdownId: "modelChoiceDropdown",

        //   // ドロップダウンが開閉されたときの動作
        //   handleOpen: (isOpen) =>
        //     this.handleDropdownState(isOpen, this.modelChoiceOptions),

        //   // 選択が変わったときの動作
        //   handleChange: (value) => this.updateSelection("modelChoice", value),
        // },

        {
          key: "position",
          label: "ポジション",
          label2: "選択してください",
          refName: "positionDropdown",
          options: this.positionOptions,
          dropdownId: "positionDropdown",
          handleOpen: (isOpen) => {
            // ドロップダウンが開かれたときに、現在のポジションを保存する
            if (isOpen) {
              this.previousPosition = this.selected.position;
            }
            // その後、通常の処理を実行
            this.handleDropdownState(isOpen, this.positionOptions);
          },
          handleChange: (value) => this.updatePosition(value),
        },

        {
          key: "typeName",
          label: "型名",
          label2: "選択してください",
          refName: "typeNameDropdown",
          options: this.filteredTypeNameOptions,
          dropdownId: "typeNameDropdown",
          isDisabled: !this.selected.position,
          handleOpen: (isOpen) =>
            this.handleDropdownState(isOpen, this.filteredTypeNameOptions),
          // 型名変更時の処理の中で、指カバー・指アテのリセットと calculateTotal の呼び出しを追加
          handleChange: (value) => {
            // 型名の変更処理（既存の処理があればここに記述）
            this.updateSelection("typeName", value);
            // 型名変更時に指カバー・指アテをリセット
            this.selected.finger = "";
            // 合計金額を再計算
            this.$nextTick(() => {
              this.calculateTotal();
            });
          },
          // 警告テキストの設定
          warnings: [
            {
              text: "ポジションを選択してください。",
              condition: !this.selected.position,
            },
          ],
        },

        {
          key: "gloveHand",
          label: "グラブの左右",
          label2: "選択してください",
          refName: "gloveHandDropdown",
          options: this.gloveHandOptions,
          dropdownId: "gloveHandDropdown",
          handleOpen: (isOpen) =>
            this.handleDropdownState(isOpen, this.gloveHandOptions),
          handleChange: (value) => this.updateSelection("gloveHand", value),
        },

        {
          key: "backStyle",
          label: "バックスタイル",
          label2: "選択してください",
          refName: "backStyleDropdown",
          options: this.filteredBackStyleOptions,
          dropdownId: "backStyleDropdown",
          handleOpen: (isOpen) =>
            this.handleDropdownState(isOpen, this.backStyleOptions),
          handleChange: (value) => this.handleBackStyleChange(value),
        },

        {
          key: "beltType",
          label: "ベルト型",
          label2: "選択してください",
          refName: "beltTypeDropdown",
          options: this.beltTypeOptions,
          dropdownId: "beltTypeDropdown",
          isDisabled: !this.isBeltOptionAvailable,
          handleOpen: (isOpen) =>
            this.handleDropdownState(isOpen, this.beltTypeOptions),
            handleChange: (value) => {
            this.updateSelection("beltType", value);

            if (['親指一体', 'Tベルト'].includes(value)) {
              this.selected.bandColor = null;
            } else {
              this.selected.bandColor = this.selected.mainColor;
            }

            this.calculateTotal?.();
          },
          warnings: [
            {
              text: "バックスタイルを選択してください。",
              condition: !this.selected.backStyle && !this.showBeltWarning,
            },
            {
              text: "ベルト型はライナーバックでは選択できません。",
              condition: this.showBeltWarning,
            },
          ],
        },

        {
          key: "fingerSize",
          label: "サイズ調整(指の長さ)",
          label2: "選択してください",
          refName: "fingerSizeDropdown",
          options: this.fingerSizeOptions,
          handleOpen: (isOpen) =>
            this.handleDropdownState(isOpen, this.fingerSizeOptions),
          handleChange: (value) => this.updateSelection("fingerSize", value),
        },

        {
          key: "backStrand",
          label: "背面ひも通し",
          label2: "選択してください",
          refName: "backSrtandDropdown",
          options: this.backStrandOptions,
          dropdownId: "backStrandDropdown",
          handleOpen: (isOpen) =>
            this.handleDropdownState(isOpen, this.backStrandOptions),
          handleChange: (value) => this.updateSelection("backStrand", value),
        },

        {
          key: "hamidashiChoice",
          label: "ハミダシ",
          label2: "選択してください",
          refName: "hamidashiChoiceDropdown",
          options: this.hamidashiChoiceOptions,
          dropdownId: "hamidashiChoiceDropdown",
          handleOpen: (isOpen) => {
            // ドロップダウンが開かれたときに、現在のハミダシ選択を保存する
            if (isOpen) {
              this.previousHamidashiChoice = this.selected.hamidashiChoice;
            }
            // その後、通常の処理を実行
            this.handleDropdownState(isOpen, this.hamidashiChoiceOptions);
          },
          handleChange: (value) => this.updateHamidashiChoiceSelection(value),
          // handleChange: (value) => this.updateSelection("hamidashiChoice", value),
        },

        {
          key: "lacePortion",
          label: "トジ部",
          label2: "選択してください",
          refName: "lacePortionDropdown",
          options: this.lacePortionOptions,
          dropdownId: "lacePortionDropdown",
          handleOpen: (isOpen) =>
            this.handleDropdownState(isOpen, this.lacePortionOptions),
          handleChange: (value) => this.updateSelection("lacePortion", value),
        },

        {
          key: "laceStrand",
          label: "トジ部のひも通し",
          label2: "選択してください",
          refName: "laceStrandDropdown",
          options: this.laceStrandOptions,
          dropdownId: "laceStrandDropdown",
          handleOpen: (isOpen) =>
            this.handleDropdownState(isOpen, this.laceStrandOptions),
          handleChange: (value) => this.updateSelection("laceStrand", value),
        },

        {
          key: "web",
          label: "ウェブ",
          label2: "選択してください",
          options: this.filteredwebOptions,
          isDisabled: !this.selected.position,
          refName: "webDropdown",
          dropdownId: "webDropdown",
          handleOpen: (isOpen) =>
            this.handleDropdownState(isOpen, this.filteredwebOptions),
         handleChange: (value) => {
            this.updateSelection("web", value);

            // webEdge対象外に切り替えたらリセット
            const webEdgeTargets = ['W-23', 'W-27', 'W-28', 'W-T5', 'W-T6', 'W-T8', 'W-T12'];
            if (!webEdgeTargets.includes(value)) {
              this.selected.webEdge = "ブラック";
              this.calculateTotal?.();
            }
          },
        },

        {
          key: "finger",
          label: "指カバー・指アテ",
          label2: "選択してください",
          refName: "fingerDropdown",
          options: this.filteredFingerOptions,
          dropdownId: "fingerDropdown",
          // ボタンが無効になる条件
          isDisabled:
            !this.isFingerOptionReady || !this.isFingerOptionAvailable,
          // ドロップダウンの開閉時の処理（fingerOptions が使われているならそのままでOK）
          handleOpen: (isOpen) =>
            this.handleDropdownState(isOpen, this.fingerOptions),
          // 選択変更時の処理
          handleChange: (value) => this.updateSelection("finger", value),
          // 警告文の情報を配列で定義（条件に応じた警告テキストが表示される）
          warnings: [
            {
              text: "ポジションとバックスタイルを選んでください。",
              condition: !this.isFingerOptionReady && !this.showFingerWarning,
            },
            {
              text: "指カバー・指アテは選択できません。",
              condition: this.showFingerWarning,
            },
          ],
        },
      ];
    },

    // 選択されたポジションに応じた型名の選択肢
    filteredTypeNameOptions() {
      return typeNameOptionsByPosition[this.selected.position] || [];
    },
    //以下二つは必要
    backStyleOptions() {
      return backStyleOptions;
    },
    beltTypeOptions() {
      return beltTypeOptions;
    },

    isBeltOptionAvailable() {
      // ベルト型の選択肢が有効かどうか
      return (
        this.selected.backStyle && this.selected.backStyle !== "ライナーバック"
      );
    },
    isFingerOptionAvailable() {
      // 指カバーの選択肢が有効かどうかを判定
      return (
        this.selected.backStyle && this.selected.backStyle !== "ライナーバック"
      );
    },
    isFingerOptionReady() {
      // 指カバー・指アテのドロップダウンを有効にする条件
      return this.selected.position && this.selected.backStyle;
    },
    filteredFingerOptions() {
      // ポジションに応じて指カバーの選択肢を動的にフィルタリング
      if (this.selected.position === "投手") {
        // 投手の場合、既存の選択肢に特定の選択肢を追加
        return fingerOptions.concat([
          { label: "先出し指カバー・人差し指", description: "", cost: 0 },
          {
            label: "先出し指カバー・人差し指中指間（+5,500円）",
            description: "",
            cost: 5000,
          },
          {
            label: "先出し指カバー・中指（+5,500円）",
            description: "",
            cost: 5000,
          },
        ]);
      }
      // 投手以外の場合は初期状態の選択肢

      return fingerOptions;
    },
    filteredwebOptions() {
      return webOptionsByPosition[this.selected.position] || [];
    },

    dropdownOptionsMap() {
      return {
        modelChoiceDropdown: this.modelChoiceOptions,
        positionDropdown: this.positionOptions,
        typeNameDropdown: this.filteredTypeNameOptions,
        gloveHandDropdown: this.gloveHandOptions,
        backStyleDropdown: this.backStyleOptions,
        beltTypeDropdown: this.beltTypeOptions,
        fingerSizeDropdown: this.fingerSizeOptions,
        backStrandDropdown: this.backStrandOptions,
        hamidashiChoiceDropdown: this.hamidashiChoiceOptions,
        lacePortionDropdown: this.lacePortionOptions,
        laceStrandDropdown: this.laceStrandOptions,
        webDropdown: this.filteredwebOptions,
        fingerDropdown: this.fingerOptions,
        treasureLabelDropdown: this.treasureLabelOptions,
      };
    },

    //////////////////////////////////////////
    ///////////        カラー       ///////////
    //////////////////////////////////////////

    colorDropdownRegularItems() {
      return [
        {
          name: "本体",
          key: "mainColor",
          label: "選択してください",
          refName: "mainColorDropdown", // もしリファレンス名が必要なら
          isOpenProp: "isMainColorOpen", // v-if等で使うためのフラグ名
          options: this.mainColorOptions,
          // ドロップダウンが開閉されたときの動作
          handleOpen: (val) => (this.isMainColorOpen = val),
          // 選択されたときの動作
          handleChange: (value) => this.updateSelection("mainColor", value),
        },

        {
          name: "親指 外側",
          key: "thumbOut",
          label: "選択してください",
          refName: "thumbOutDropdown",
          isOpenProp: "isMainColorOpen",
          options: this.thumbOutOptions,
          handleOpen: (val) => (this.isThumbOutOpen = val),
          handleChange: (value) => this.updateSelection("thumbOut", value),
        },

        {
          name: "親指 内側",
          key: "thumbIn",
          label: "選択してください",
          refName: "thumbInDropdown",
          isOpenProp: "isThumbInOpen",
          options: this.thumbInOptions,
          handleOpen: (val) => (this.isThumbInOpen = val),
          handleChange: (value) => this.updateSelection("thumbIn", value),
        },

        {
          name: "人差し指 内側",
          key: "indexFingerIn",
          label: "選択してください",
          refName: "indexFingerInDropdown",
          isOpenProp: "isIndexFingerInOpen",
          options: this.indexFingerInOptions,
          handleOpen: (val) => (this.isIndexFingerInOpen = val),
          handleChange: (value) => this.updateSelection("indexFingerIn", value),
        },

        {
          name: "人差し指 外側",
          key: "indexFingerOut",
          label: "選択してください",
          refName: "indexFingerOutDropdown",
          isOpenProp: "isIndexFingerOutOpen",
          options: this.indexFingerOutOptions,
          handleOpen: (val) => (this.isIndexFingerOutOpen = val),
          handleChange: (value) =>
            this.updateSelection("indexFingerOut", value),
        },

        {
          name: "中指 内側",
          key: "middleFingerIn",
          label: "選択してください",
          refName: "middleFingerInDropdown",
          isOpenProp: "isMiddleFingerInOpen",
          options: this.middleFingerInOptions,
          handleOpen: (val) => (this.isMiddleFingerInOpen = val),
          handleChange: (value) =>
            this.updateSelection("middleFingerIn", value),
        },

        {
          name: "中指 外側",
          key: "middleFingerOut",
          label: "選択してください",
          refName: "middleFingerOutDropdown",
          isOpenProp: "isMiddleFingerOutOpen",
          options: this.middleFingerOutOptions,
          handleOpen: (val) => (this.isMiddleFingerOutOpen = val),
          handleChange: (value) =>
            this.updateSelection("middleFingerOut", value),
        },

        {
          name: "薬指 内側",
          key: "thirdFingerIn",
          label: "選択してください",
          refName: "thirdFingerInDropdown",
          isOpenProp: "isThirdFingerInOpen",
          options: this.thirdFingerInOptions,
          handleOpen: (val) => (this.isThirdFingerInOpen = val),
          handleChange: (value) => this.updateSelection("thirdFingerIn", value),
        },

        {
          name: "薬指 外側",
          key: "thirdFingerOut",
          label: "選択してください",
          refName: "thirdFingerOutDropdown",
          isOpenProp: "isThirdFingerOutOpen",
          options: this.thirdFingerOutOptions,
          handleOpen: (val) => (this.isThirdFingerOutOpen = val),
          handleChange: (value) =>
            this.updateSelection("thirdFingerOut", value),
        },

        {
          name: "小指 内側",
          key: "littleFingerIn",
          label: "選択してください",
          refName: "littleFingerInDropdown",
          isOpenProp: "isLittleFingerInOpen",
          options: this.littleFingerInOptions,
          handleOpen: (val) => (this.isLittleFingerInOpen = val),
          handleChange: (value) =>
            this.updateSelection("littleFingerIn", value),
        },

        {
          name: "小指 外側",
          key: "littleFingerOut",
          label: "選択してください",
          refName: "littleFingerOutDropdown",
          isOpenProp: "isLittleFingerOutOpen",
          options: this.littleFingerOutOptions,
          handleOpen: (val) => (this.isLittleFingerOutOpen = val),
          handleChange: (value) =>
            this.updateSelection("littleFingerOut", value),
        },

        {
          name: "バンド",
          key: "bandColor",
          label: "選択してください",
          refName: "bandColorDropdown",
          isOpenProp: "isBandColorOpen",
          options: this.bandColorOptions,
          handleOpen: (val) => (this.isBandColorOpen = val),
          handleChange: (value) => this.updateSelection("bandColor", value),
        },

        {
          name: "捕球面",
          key: "catchColor",
          label: "選択してください",
          refName: "catchColorDropdown",
          isOpenProp: "isCatchColorOpen",
          options: this.catchColorOptions,
          handleOpen: (val) => (this.isCatchColorOpen = val),
          handleChange: (value) => this.updateSelection("catchColor", value),
        },

        {
          name: "親指掛け",
          key: "thumbHanger",
          label: "選択してください",
          refName: "thumbHangerDropdown",
          isOpenProp: "isThumbHangerOpen",
          options: this.thumbHangerOptions,
          handleOpen: (val) => (this.isThumbHangerOpen = val),
          handleChange: (value) => this.updateSelection("thumbHanger", value),
        },

        {
          name: "小指掛け",
          key: "littleFingerHanger",
          label: "選択してください",
          refName: "littleFingerHangerDropdown",
          isOpenProp: "isLittleFingerHangerOpen",
          options: this.littleFingerHangerOptions,
          handleOpen: (val) => (this.isLittleFingerHangerOpen = val),
          handleChange: (value) =>
            this.updateSelection("littleFingerHanger", value),
        },

        {
          name: "ヘリ革",
          key: "hemLeather",
          label: "選択してください",
          refName: "hemLeatherDropdown",
          isOpenProp: "isHemLeatherOpen",
          options: this.hemLeatherOptions,
          handleOpen: (val) => (this.isHemLeatherOpen = val),
          handleChange: (value) => this.updateSelection("hemLeather", value),
        },

        {
          name: "ウェブ背面側・タテ棒",
          key: "webBack",
          label: "選択してください",
          refName: "webBackDropdown",
          isOpenProp: "isWebBackOpen",
          options: this.webBackOptions,
          handleOpen: (val) => (this.isWebBackOpen = val),
          handleChange: (value) => this.updateSelection("webBack", value),
        },

        {
          name: "ウェブ捕球面側・ヨコ棒",
          key: "webCatch",
          label: "選択してください",
          refName: "webCatchDropdown",
          isOpenProp: "isWebCatchOpen",
          options: this.webCatchOptions,
          handleOpen: (val) => (this.isWebCatchOpen = val),
          handleChange: (value) => this.updateSelection("webCatch", value),
        },

        {
          name: "ウェブエッジ・その他",
          key: "webEdge",
          label: "選択してください",
          refName: "webEdgeDropdown",
          isOpenProp: "isWebEdgeOpen",
          options: this.webEdgeOptions,
          handleOpen: (val) => (this.isWebEdgeOpen = val),
          handleChange: (value) => this.updateSelection("webEdge", value),
        },

        {
          name: "平裏",
          key: "hiraura",
          label: "選択してください",
          refName: "hirauraDropdown",
          isOpenProp: "isHirauraOpen",
          options: this.hirauraOptions,
          handleOpen: (val) => (this.isHirauraOpen = val),
          handleChange: (value) => this.updateSelection("hiraura", value),
        },

        {
          name: "トレジャーベルト",
          key: "treasureBelt",
          label: "選択してください",
          refName: "treasureBeltDropdown",
          isOpenProp: "isTreasureBeltOpen",
          options: this.treasureBeltOptions,
          handleOpen: (val) => (this.isTreasureBeltOpen = val),
          handleChange: (value) => this.updateSelection("treasureBelt", value),
        },

        {
          name: "指カバー・指あて",
          key: "fingerCoverColor",
          label: "選択してください",
          refName: "fingerCoverColorDropdown",
          isOpenProp: "isFingerCoverColorOpen",
          options: this.fingerCoverColorOptions,
          handleOpen: (val) => (this.isFingerCoverColorOpen = val),
          handleChange: (value) =>
            this.updateSelection("fingerCoverColor", value),
        },
      ];
    },
    colorDropdownCrownItems() {
      return [
        {
          name: "本体",
          key: "mainColor",
          label: "選択してください",
          refName: "mainColorDropdown", // もしリファレンス名が必要なら
          isOpenProp: "isMainColorOpen", // v-if等で使うためのフラグ名
          options: this.mainColorOptions,
          // ドロップダウンが開閉されたときの動作
          handleOpen: (val) => (this.isMainColorOpen = val),
          // 選択されたときの動作
          handleChange: (value) => this.updateSelection("mainColor", value),
        },

        {
          name: "親指 外側",
          key: "thumbOut",
          label: "選択してください",
          refName: "thumbOutDropdown",
          isOpenProp: "isMainColorOpen",
          options: this.thumbOutOptions,
          handleOpen: (val) => (this.isThumbOutOpen = val),
          handleChange: (value) => this.updateSelection("thumbOut", value),
        },

        {
          name: "親指 内側",
          key: "thumbIn",
          label: "選択してください",
          refName: "thumbInDropdown",
          isOpenProp: "isThumbInOpen",
          options: this.thumbInOptions,
          handleOpen: (val) => (this.isThumbInOpen = val),
          handleChange: (value) => this.updateSelection("thumbIn", value),
        },

        {
          name: "人差し指 内側",
          key: "indexFingerIn",
          label: "選択してください",
          refName: "indexFingerInDropdown",
          isOpenProp: "isIndexFingerInOpen",
          options: this.indexFingerInOptions,
          handleOpen: (val) => (this.isIndexFingerInOpen = val),
          handleChange: (value) => this.updateSelection("indexFingerIn", value),
        },

        {
          name: "人差し指 外側・中指 内側",
          key: "indexAndMiddleFinger",
          label: "選択してください",
          refName: "indexAndMiddleFingerDropdown",
          isOpenProp: "isIndexAndMiddleFingerOpen",
          options: this.indexAndMiddleFingerOptions,
          handleOpen: (val) => (this.isIndexAndMiddleFingerOpen = val),
          handleChange: (value) =>
            this.updateSelection("indexAndMiddleFinger", value),
        },

        {
          name: "中指 外側・薬指 内側",
          key: "middleAndThirdFinger",
          label: "選択してください",
          refName: "middleAndThirdFingerDropdown",
          isOpenProp: "isMiddleAndThirdFingerOpen",
          options: this.middleAndThirdFingerOptions,
          handleOpen: (val) => (this.isMiddleAndThirdFingerOpen = val),
          handleChange: (value) =>
            this.updateSelection("middleAndThirdFinger", value),
        },

        {
          name: "薬指 外側・小指 内側",
          key: "thirdAndLittleFinger",
          label: "選択してください",
          refName: "thirdAndLittleFingerDropdown",
          isOpenProp: "isThirdAndLittleFingerOpen",
          options: this.thirdAndLittleFingerOptions,
          handleOpen: (val) => (this.isThirdAndLittleFingerOpen = val),
          handleChange: (value) =>
            this.updateSelection("thirdAndLittleFinger", value),
        },

        {
          name: "小指 外側",
          key: "littleFingerOut",
          label: "選択してください",
          refName: "littleFingerOutDropdown",
          isOpenProp: "isLittleFingerOutOpen",
          options: this.littleFingerOutOptions,
          handleOpen: (val) => (this.isLittleFingerOutOpen = val),
          handleChange: (value) =>
            this.updateSelection("littleFingerOut", value),
        },

        {
          name: "バンド",
          key: "bandColor",
          label: "選択してください",
          refName: "bandColorDropdown",
          isOpenProp: "isBandColorOpen",
          options: this.bandColorOptions,
          handleOpen: (val) => (this.isBandColorOpen = val),
          handleChange: (value) => this.updateSelection("bandColor", value),
        },

        {
          name: "捕球面",
          key: "catchColor",
          label: "選択してください",
          refName: "catchColorDropdown",
          isOpenProp: "isCatchColorOpen",
          options: this.catchColorOptions,
          handleOpen: (val) => (this.isCatchColorOpen = val),
          handleChange: (value) => this.updateSelection("catchColor", value),
        },

        {
          name: "親指掛け",
          key: "thumbHanger",
          label: "選択してください",
          refName: "thumbHangerDropdown",
          isOpenProp: "isThumbHangerOpen",
          options: this.thumbHangerOptions,
          handleOpen: (val) => (this.isThumbHangerOpen = val),
          handleChange: (value) => this.updateSelection("thumbHanger", value),
        },

        {
          name: "小指掛け",
          key: "littleFingerHanger",
          label: "選択してください",
          refName: "littleFingerHangerDropdown",
          isOpenProp: "isLittleFingerHangerOpen",
          options: this.littleFingerHangerOptions,
          handleOpen: (val) => (this.isLittleFingerHangerOpen = val),
          handleChange: (value) =>
            this.updateSelection("littleFingerHanger", value),
        },

        {
          name: "ヘリ革",
          key: "hemLeather",
          label: "選択してください",
          refName: "hemLeatherDropdown",
          isOpenProp: "isHemLeatherOpen",
          options: this.hemLeatherOptions,
          handleOpen: (val) => (this.isHemLeatherOpen = val),
          handleChange: (value) => this.updateSelection("hemLeather", value),
        },

        {
          name: "ウェブ背面側・タテ棒",
          key: "webBack",
          label: "選択してください",
          refName: "webBackDropdown",
          isOpenProp: "isWebBackOpen",
          options: this.webBackOptions,
          handleOpen: (val) => (this.isWebBackOpen = val),
          handleChange: (value) => this.updateSelection("webBack", value),
        },

        {
          name: "ウェブ捕球面側・ヨコ棒",
          key: "webCatch",
          label: "選択してください",
          refName: "webCatchDropdown",
          isOpenProp: "isWebCatchOpen",
          options: this.webCatchOptions,
          handleOpen: (val) => (this.isWebCatchOpen = val),
          handleChange: (value) => this.updateSelection("webCatch", value),
        },

        {
          name: "ウェブエッジ・その他",
          key: "webEdge",
          label: "選択してください",
          refName: "webEdgeDropdown",
          isOpenProp: "isWebEdgeOpen",
          options: this.webEdgeOptions,
          handleOpen: (val) => (this.isWebEdgeOpen = val),
          handleChange: (value) => this.updateSelection("webEdge", value),
        },

        {
          name: "平裏",
          key: "hiraura",
          label: "選択してください",
          refName: "hirauraDropdown",
          isOpenProp: "isHirauraOpen",
          options: this.hirauraOptions,
          handleOpen: (val) => (this.isHirauraOpen = val),
          handleChange: (value) => this.updateSelection("hiraura", value),
        },

        {
          name: "トレジャーベルト",
          key: "treasureBelt",
          label: "選択してください",
          refName: "treasureBeltDropdown",
          isOpenProp: "isTreasureBeltOpen",
          options: this.treasureBeltOptions,
          handleOpen: (val) => (this.isTreasureBeltOpen = val),
          handleChange: (value) => this.updateSelection("treasureBelt", value),
        },

        {
          name: "指カバー・指あて",
          key: "fingerCoverColor",
          label: "選択してください",
          refName: "fingerCoverColorDropdown",
          isOpenProp: "isFingerCoverColorOpen",
          options: this.fingerCoverColorOptions,
          handleOpen: (val) => (this.isFingerCoverColorOpen = val),
          handleChange: (value) =>
            this.updateSelection("fingerCoverColor", value),
        },
      ];
    },

    colorDropdownLinrItems() {
      return [
      {
          name: "本体",
          key: "mainColor",
          label: "選択してください",
          refName: "mainColorDropdown", // もしリファレンス名が必要なら
          isOpenProp: "isMainColorOpen", // v-if等で使うためのフラグ名
          options: this.mainColorOptions,
          // ドロップダウンが開閉されたときの動作
          handleOpen: (val) => (this.isMainColorOpen = val),
          // 選択されたときの動作
          handleChange: (value) => this.updateSelection("mainColor", value),
        },

        {
          name: "親指 外側",
          key: "thumbOut",
          label: "選択してください",
          refName: "thumbOutDropdown",
          isOpenProp: "isMainColorOpen",
          options: this.thumbOutOptions,
          handleOpen: (val) => (this.isThumbOutOpen = val),
          handleChange: (value) => this.updateSelection("thumbOut", value),
        },
        {
          name: "親指 内側・人差し指・中指 内側",
          key: "thumbIndexAndMiddleFinger",
          label: "選択してください",
          refName: "thumbIndexAndMiddleFingerDropdown",
          isOpenProp: "isThumbIndexAndMiddleFingerOpen",
          options: this.thumbIndexAndMiddleFingerOptions,
          handleOpen: (val) => (this.isThumbIndexAndMiddleFingerOpen = val),
          handleChange: (value) =>
            this.updateSelection("thumbIndexAndMiddleFinger", value),
        },

        {
          name: "中指 外側・薬指 内側",
          key: "middleAndThirdFinger",
          label: "選択してください",
          refName: "middleAndThirdFingerDropdown",
          isOpenProp: "isMiddleAndThirdFingerOpen",
          options: this.middleAndThirdFingerOptions,
          handleOpen: (val) => (this.isMiddleAndThirdFingerOpen = val),
          handleChange: (value) =>
            this.updateSelection("middleAndThirdFinger", value),
        },

        {
          name: "薬指 外側・小指 内側",
          key: "thirdAndLittleFinger",
          label: "選択してください",
          refName: "thirdAndLittleFingerDropdown",
          isOpenProp: "isThirdAndLittleFingerOpen",
          options: this.thirdAndLittleFingerOptions,
          handleOpen: (val) => (this.isThirdAndLittleFingerOpen = val),
          handleChange: (value) =>
            this.updateSelection("thirdAndLittleFinger", value),
        },

        {
          name: "小指 外側",
          key: "littleFingerOut",
          label: "選択してください",
          refName: "littleFingerOutDropdown",
          isOpenProp: "isLittleFingerOutOpen",
          options: this.littleFingerOutOptions,
          handleOpen: (val) => (this.isLittleFingerOutOpen = val),
          handleChange: (value) =>
            this.updateSelection("littleFingerOut", value),
        },

        {
          name: "バンド",
          key: "bandColor",
          label: "選択してください",
          refName: "bandColorDropdown",
          isOpenProp: "isBandColorOpen",
          options: this.bandColorOptions,
          handleOpen: (val) => (this.isBandColorOpen = val),
          handleChange: (value) => this.updateSelection("bandColor", value),
        },

        {
          name: "捕球面",
          key: "catchColor",
          label: "選択してください",
          refName: "catchColorDropdown",
          isOpenProp: "isCatchColorOpen",
          options: this.catchColorOptions,
          handleOpen: (val) => (this.isCatchColorOpen = val),
          handleChange: (value) => this.updateSelection("catchColor", value),
        },

        {
          name: "親指掛け",
          key: "thumbHanger",
          label: "選択してください",
          refName: "thumbHangerDropdown",
          isOpenProp: "isThumbHangerOpen",
          options: this.thumbHangerOptions,
          handleOpen: (val) => (this.isThumbHangerOpen = val),
          handleChange: (value) => this.updateSelection("thumbHanger", value),
        },

        {
          name: "小指掛け",
          key: "littleFingerHanger",
          label: "選択してください",
          refName: "littleFingerHangerDropdown",
          isOpenProp: "isLittleFingerHangerOpen",
          options: this.littleFingerHangerOptions,
          handleOpen: (val) => (this.isLittleFingerHangerOpen = val),
          handleChange: (value) =>
            this.updateSelection("littleFingerHanger", value),
        },

        {
          name: "ヘリ革",
          key: "hemLeather",
          label: "選択してください",
          refName: "hemLeatherDropdown",
          isOpenProp: "isHemLeatherOpen",
          options: this.hemLeatherOptions,
          handleOpen: (val) => (this.isHemLeatherOpen = val),
          handleChange: (value) => this.updateSelection("hemLeather", value),
        },

        {
          name: "ウェブ背面側・タテ棒",
          key: "webBack",
          label: "選択してください",
          refName: "webBackDropdown",
          isOpenProp: "isWebBackOpen",
          options: this.webBackOptions,
          handleOpen: (val) => (this.isWebBackOpen = val),
          handleChange: (value) => this.updateSelection("webBack", value),
        },

        {
          name: "ウェブ捕球面側・ヨコ棒",
          key: "webCatch",
          label: "選択してください",
          refName: "webCatchDropdown",
          isOpenProp: "isWebCatchOpen",
          options: this.webCatchOptions,
          handleOpen: (val) => (this.isWebCatchOpen = val),
          handleChange: (value) => this.updateSelection("webCatch", value),
        },

        {
          name: "ウェブエッジ・その他",
          key: "webEdge",
          label: "選択してください",
          refName: "webEdgeDropdown",
          isOpenProp: "isWebEdgeOpen",
          options: this.webEdgeOptions,
          handleOpen: (val) => (this.isWebEdgeOpen = val),
          handleChange: (value) => this.updateSelection("webEdge", value),
        },

        {
          name: "平裏",
          key: "hiraura",
          label: "選択してください",
          refName: "hirauraDropdown",
          isOpenProp: "isHirauraOpen",
          options: this.hirauraOptions,
          handleOpen: (val) => (this.isHirauraOpen = val),
          handleChange: (value) => this.updateSelection("hiraura", value),
        },

        {
          name: "ライナーバックベルト",
          key: "linerBackBeltColor",
          label: "選択してください",
          refName: "linerBackBeltColorDropdown",
          isOpenProp: "isLinerBackBeltColorOpen",
          options: this.linerBackBeltColorOptions,
          handleOpen: (val) => (this.isLinerBackBeltColorOpen = val),
          handleChange: (value) =>
            this.updateSelection("linerBackBeltColor", value),
        },

        // {
        //   name: "トレジャーベルト",
        //   key: "treasureBelt",
        //   label: "選択してください",
        //   refName: "treasureBeltDropdown",
        //   isOpenProp: "isTreasureBeltOpen",
        //   options: this.treasureBeltOptions,
        //   handleOpen: (val) => (this.isTreasureBeltOpen = val),
        //   handleChange: (value) => this.updateSelection("treasureBelt", value),
        // },

        // {
        //   name: "指カバー・指あて",
        //   key: "fingerCoverColor",
        //   label: "選択してください",
        //   refName: "fingerCoverColorDropdown",
        //   isOpenProp: "isFingerCoverColorOpen",
        //   options: this.fingerCoverColorOptions,
        //   handleOpen: (val) => (this.isFingerCoverColorOpen = val),
        //   handleChange: (value) =>
        //     this.updateSelection("fingerCoverColor", value),
        // },
      ];
    },



    colorDropdownSecondItems() {
      return [
        {
          name: "レース",
          key: "laceColor",
          label: "選択してください",
          refName: "laceColorDropdown",
          isOpenProp: "isLaceColorOpen",
          options: this.laceColorOptions,
          handleOpen: (val) => (this.isLaceColorOpen = val),
          handleChange: (value) => this.updateSelection("laceColor", value),
        },

        {
          name: "ステッチ",
          key: "stitchColor",
          label: "選択してください",
          refName: "stitchColorDropdown",
          isOpenProp: "isStitchColorOpen",
          options: this.stitchColorOptions,
          handleOpen: (val) => (this.isStitchColorOpen = val),
          handleChange: (value) => this.updateSelection("stitchColor", value),
        },
      ];
    },

    //ポジションで投手選択時、オリジナルのトレジャーラベルから「ホワイト」「Lシルバー」を非表示
    filteredOptionMainColorOptions() {
      return this.filterColors(this.optionMainColorOptions);
    },
    filteredOptionShadowColorOptions() {
      return this.filterColors(this.optionShadowColorOptions);
    },
    filteredOptionStandColorOptions() {
      return this.filterColors(this.optionStandColorOptions);
    },

    colorPaletteItems() {
      return [
        {
          title: "本体",
          isOpenProp: "isMainColorOpen",
          options: this.mainColorOptions,
          colorKey: "mainColor",
        },

        {
          title: "親指 外側",
          isOpenProp: "isThumbOutOpen",
          options: this.thumbOutOptions,
          colorKey: "thumbOut",
        },

        {
          title: "親指 内側",
          isOpenProp: "isThumbInOpen",
          options: this.thumbInOptions,
          colorKey: "thumbIn",
        },

        {
          title: "人差し指 外側",
          isOpenProp: "isIndexFingerOutOpen",
          options: this.indexFingerOutOptions,
          colorKey: "indexFingerOut",
        },

        {
          title: "人差し指 内側",
          isOpenProp: "isIndexFingerInOpen",
          options: this.indexFingerInOptions,
          colorKey: "indexFingerIn",
        },


          // ライナーバック用
          {
            title: "親指 内側・人差し指・中指 内側",
            isOpenProp: "isThumbIndexAndMiddleFingerOpen",
            options: this.thumbIndexAndMiddleFingerOptions,
            colorKey: "thumbIndexAndMiddleFinger",
          },

          // 王冠用
          {
            title: "人差し指 外側・中指 内側",
            isOpenProp: "isIndexAndMiddleFingerOpen",
            options: this.indexAndMiddleFingerOptions,
            colorKey: "indexAndMiddleFinger",
          },
          {
            title: "中指 外側・薬指 内側",
            isOpenProp: "isMiddleAndThirdFingerOpen",
            options: this.middleAndThirdFingerOptions,
            colorKey: "middleAndThirdFinger",
          },
          {
            title: "薬指 外側・小指 内側",
            isOpenProp: "isThirdAndLittleFingerOpen",
            options: this.thirdAndLittleFingerOptions,
            colorKey: "thirdAndLittleFinger",
          },






        {
          title: "中指 外側",
          isOpenProp: "isMiddleFingerOutOpen",
          options: this.middleFingerOutOptions,
          colorKey: "middleFingerOut",
        },

        {
          title: "中指 内側",
          isOpenProp: "isMiddleFingerInOpen",
          options: this.middleFingerInOptions,
          colorKey: "middleFingerIn",
        },

        {
          title: "薬指 外側",
          isOpenProp: "isThirdFingerOutOpen",
          options: this.thirdFingerOutOptions,
          colorKey: "thirdFingerOut",
        },

        {
          title: "薬指 内側",
          isOpenProp: "isThirdFingerInOpen",
          options: this.thirdFingerInOptions,
          colorKey: "thirdFingerIn",
        },

        {
          title: "小指 外側",
          isOpenProp: "isLittleFingerOutOpen",
          options: this.littleFingerOutOptions,
          colorKey: "littleFingerOut",
        },

        {
          title: "小指 内側",
          isOpenProp: "isLittleFingerInOpen",
          options: this.littleFingerInOptions,
          colorKey: "littleFingerIn",
        },

        {
          title: "バンド",
          isOpenProp: "isBandColorOpen",
          options: this.bandColorOptions,
          colorKey: "bandColor",
        },

        {
          title: "捕球面",
          isOpenProp: "isCatchColorOpen",
          options: this.catchColorOptions,
          colorKey: "catchColor",
        },

        {
          title: "親指掛け",
          isOpenProp: "isThumbHangerOpen",
          options: this.thumbHangerOptions,
          colorKey: "thumbHanger",
        },

        {
          title: "小指掛け",
          isOpenProp: "isLittleFingerHangerOpen",
          options: this.littleFingerHangerOptions,
          colorKey: "littleFingerHanger",
        },

        {
          title: "ヘリ革",
          isOpenProp: "isHemLeatherOpen",
          options: this.hemLeatherOptions,
          colorKey: "hemLeather",
        },

        {
          title: "ウェブ背面側・タテ棒",
          isOpenProp: "isWebBackOpen",
          options: this.webBackOptions,
          colorKey: "webBack",
        },

        {
          title: "ウェブ捕球面・ヨコ棒",
          isOpenProp: "isWebCatchOpen",
          options: this.webCatchOptions,
          colorKey: "webCatch",
        },

        {
          title: "ウェブエッジ・その他",
          isOpenProp: "isWebEdgeOpen",
          options: this.webEdgeOptions,
          colorKey: "webEdge",
        },

        {
          title: "平裏",
          isOpenProp: "isHirauraOpen",
          options: this.hirauraOptions,
          colorKey: "hiraura",
        },

        {
          title: "トレジャーベルト",
          isOpenProp: "isTreasureBeltOpen",
          options: this.treasureBeltOptions,
          colorKey: "treasureBelt",
        },

        {
          title: "ライナーバックベルト",
          isOpenProp: "isLinerBackBeltColorOpen",
          options: this.linerBackBeltColorOptions,
          colorKey: "linerBackBeltColor",
        },

        {
          title: "指カバー・指アテ",
          isOpenProp: "isFingerCoverColorOpen",
          options: this.fingerCoverColorOptions,
          colorKey: "fingerCoverColor",
        },
          // // 王冠用
          // {
          //   title: "人差し指 外側・中指 内側",
          //   isOpenProp: "isIndexAndMiddleFingerOpen",
          //   options: this.indexAndMiddleFingerOptions,
          //   colorKey: "indexAndMiddleFinger",
          // },
          // {
          //   title: "中指 外側・薬指 内側",
          //   isOpenProp: "isMiddleAndThirdFingerOpen",
          //   options: this.middleAndThirdFingerOptions,
          //   colorKey: "middleAndThirdFinger",
          // },
          // {
          //   title: "薬指 外側・小指 内側",
          //   isOpenProp: "isThirdAndLittleFingerOpen",
          //   options: this.thirdAndLittleFingerOptions,
          //   colorKey: "thirdAndLittleFinger",
          // },
          // ライナーバック用
          // {
          //   title: "人差し指 外側・中指 内側",
          //   isOpenProp: "isthumbIndexAndMiddleFingerOpen",
          //   options: this.thumbIndexAndMiddleFingerOptions,
          //   colorKey: "thumbIndexAndMiddleFinger",
          // },
      ];
    },

    colorPaletteSecondItems() {
      return [
        {
          title: "レース",
          isOpenProp: "isLaceColorOpen",
          options: this.laceColorOptions,
          colorKey: "laceColor",
        },

        {
          title: "ステッチ",
          isOpenProp: "isStitchColorOpen",
          options: this.stitchColorOptions,
          colorKey: "stitchColor",
        },

        {
          title: "メインカラー",
          isOpenProp: "isOptionMainColorOpen",
          options: this.optionMainColorOptions,
          colorKey: "optionMainColor",
        },

        {
          title: "カゲカラー",
          isOpenProp: "isOptionShadowColorOpen",
          options: this.optionShadowColorOptions,
          colorKey: "optionShadowColor",
        },

        {
          title: "台カラー",
          isOpenProp: "isOptionStandColorOpen",
          options: this.optionStandColorOptions,
          colorKey: "optionStandColor",
        },

        {
          title: "書体カラー",
          isOpenProp: "isFontColorOpen",
          options: this.fontColorOptions,
          colorKey: "fontColor",
        },

        {
          title: "カゲカラー",
          isOpenProp: "isShadowColorOpen",
          options: this.shadowColorOptions,
          colorKey: "shadowColor",
        },

        {
          title: "フチカラー",
          isOpenProp: "isEdgeColorOpen",
          options: this.edgeColorOptions,
          colorKey: "edgeColor",
        },
      ];
    },

    // オープン状態のアイテムだけに絞り込む
    colorPaletteOpenItems() {
      return this.colorPaletteItems.filter((item) => {
        return this[item.isOpenProp] === true;
      });
    },
    colorPaletteOpenSecondItems() {
      return this.colorPaletteSecondItems.filter((item) => {
        return this[item.isOpenProp] === true;
      });
    },

    //////////////////////////////////////////
    ///////////        刺繍         //////////
    /////////////////////////////////////////

    // 選択済みの刺繍位置を除外して表示する
    availableEmbroideryPositionOptions() {
      return this.embroideryPositionOptions.filter(option => {
        // すでに使用済みなら除外
        if (this.usedEmbroideryPositions.includes(option.value)) {
          return false;
        }
        // 「平裏二段目」は、「平裏一段目」が選ばれて保存されるまで除外
        if (option.value === "平裏二段目" && !this.usedEmbroideryPositions.includes("平裏一段目")) {
          return false;
        }
        return true;
      });
    },

    //書体選択時、サンプルを表示
    selectedFontImage() {
      if (!this.selected || !this.selected.font) return null; // 🔥 `selected` のチェックを追加
      const foundOption = this.fontOptions.find(
        (opt) =>
          opt.value === this.selected.font || opt.label === this.selected.font
      );
      return foundOption && foundOption.image ? foundOption.image : null;
    },


  selectedFontDescription() {
    if (!this.selected || !this.selected.font) return null; // 🔥 `selected` のチェックを追加
    const foundOption = this.fontOptions.find(
      (opt) =>
        opt.value === this.selected.font || opt.label === this.selected.font
    );
    return foundOption && foundOption.fontDescription ? foundOption.fontDescription : null;
  },

  savedFontImagesAndDescriptions() {
    return this.savedSelections.map((selection) => {
      const foundOption = this.fontOptions.find(
        (opt) => opt.value === selection.font || opt.label === selection.font
      );
      return {
        image: foundOption && foundOption.image ? foundOption.image : null,
        description: foundOption && foundOption.fontDescription ? foundOption.fontDescription : null, // 🔥 ここを修正！
      };
    }).filter(item => item.image !== null); // 画像があるものだけフィルタリング
  },



    // ハミダシに基づく追加選択肢
    computedAdditionalOptions() {
      return hamidashiAdditionalOptions[this.selected.hamidashiChoice] || [];
    },
    dynamicAdditionalLabeldynamicAdditionalLabel() {
      if (this.selected.hamidashiChoice) {
        return `ハミダシ: ${this.selected.hamidashiChoice}`;
      }
      return "ハミダシを選択してください";
    },

    // 選択された値の説明文を取得
    // selectedDescription() {
    //   const selectedOption = this.backStyleOptions.find(
    //     (option) => option.value === this.selected.backStyle
    //   );
    //   return selectedOption ? selectedOption.description : "";
    // },

    computedMissingFields() {
      // 必要なら条件付きの無視リスト（excludeKeys, conditionalExcludes）をここで同じロジックで使う
      const conditionalExcludes = {
        beltType: () => this.selected.backStyle === "ライナーバック",
        finger: () => this.selected.backStyle === "ライナーバック",
        optionMainColor: () =>
          this.selected.treasureLabelChoice !==
          "オリジナル（+3,300円&納期+30日）",
        optionShadowColor: () =>
          this.selected.treasureLabelChoice !==
          "オリジナル（+3,300円&納期+30日）",
        optionStandColor: () =>
          this.selected.treasureLabelChoice !==
          "オリジナル（+3,300円&納期+30日）",
        webEdge: () =>
          !['W-23', 'W-27', 'W-28', 'W-T5', 'W-T6', 'W-T8', 'W-T12'].includes(this.selected.web),
        bandColor: () =>
           ['親指一体', 'Tベルト'].includes(this.selected.beltType),
      };
      const excludeKeys = [
        "embroideryPosition",
        "font",
        "fontColor",
        "shadowEdge",
        "shadowColor",
        "edgeColor",
        "embroideryContent",
      ];

      const unselectedItems = Object.entries(this.selected).filter(
        ([key, value]) => {
          // 無視するキーならスキップ
          if (excludeKeys.includes(key)) return false;
          // 条件付きで無視する項目ならスキップ
          if (key in conditionalExcludes && conditionalExcludes[key]())
            return false;
          // 未入力判定：値が falsy または "未選択" や "未入力" の場合
          return !value || value === "未選択" || value === "未入力";
        }
      );
      return unselectedItems.map(([key]) => key);
    },
  },

  watch: {
    // ハミダシの選択が変更されたら追加選択肢を更新
    "selected.hamidashiChoice": {
      handler(newValue, oldValue) {
        this.additionalOptions =
          hamidashiAdditionalOptions[this.selected.hamidashiChoice] || [];

        if (this.isDataRestoring || this.isRestoring) return;

        if (oldValue !== undefined && newValue !== oldValue) {
          this.selected.additional = "";
        }

        this.calculateTotal();
      },
      immediate: true,
    },

    //ポジションで投手選択時、オリジナルラベルの選択をリセット。
    // 「ホワイト」「Lシルバー」を選べないようにするため
    // "selected.position": {
    //   handler(newPosition) {
    //     if (this.isDataRestoring) return;

    //     if (newPosition === "投手") {
    //       this.updateTreasureLabelChoiceSelection(
    //         "標準2(ゴールド×ブラック×Lゴールド)"
    //       );
    //     }

    //     this.calculateTotal();
    //   },
    //   immediate: false,
    // },

    // 20250213ラベルの初期値は確定していて空にする必要はないためコメントアウト（藤﨑）
    // トレジャーラベルの値が変更されたとき
    // "selected.treasureLabelChoice"(newValue) {
    //   if (
    //     newValue !== "オリジナル（+3,300円&納期+30日）" &&
    //     newValue !== "some-other-value-if-needed"
    //   ) {
    //     // メインカラー、カゲカラー、台カラーをリセット
    //     this.selected.optionMainColor = "";
    //     this.selected.optionShadowColor = "";
    //     this.selected.optionStandColor = "";
    //   }
    // },
    additionalOptions(newOptions) {
      if (newOptions.length > 0 && this.selected.additional) {
        this.$nextTick(() => {
          if (this.$refs.additionalDropdown) {
            this.$refs.additionalDropdown.updateValue(this.selected.additional);
          }
        });
      }
    },
    filteredOptionMainColorOptions(newOptions) {
      if (newOptions.length > 0 && this.selected.optionMainColor) {
        this.$nextTick(() => {
          if (this.$refs.optionMainColorDropdown) {
            this.$refs.optionMainColorDropdown.updateValue(
              this.selected.optionMainColor
            );
          }
        });
      }
    },
    filteredOptionShadowColorOptions(newOptions) {
      if (newOptions.length > 0 && this.selected.optionShadowColor) {
        this.$nextTick(() => {
          if (this.$refs.optionShadowColorDropdown) {
            this.$refs.optionShadowColorDropdown.updateValue(
              this.selected.optionShadowColor
            );
          }
        });
      }
    },
    filteredOptionStandColorOptions(newOptions) {
      if (newOptions.length > 0 && this.selected.optionStandColor) {
        this.$nextTick(() => {
          if (this.$refs.optionStandColorDropdown) {
            this.$refs.optionStandColorDropdown.updateValue(
              this.selected.optionStandColor
            );
          }
        });
      }
    },

    "selected.mainColor"(newVal) {
      // 他ページから戻ってきた時は一括変更を変更させない
      if (this.isDataRestoring) return;
      // ページ内からmainColorを更新した時は一括変更
      this.mainColorDependentKeys.forEach(key => {
        this.selected[key] = newVal;
      });
    },

    // 3色あるウェブから2色のウェブに変更されたときにリセットする
     'selected.web'(newValue) {
      const allowWebEdge = ['W-23', 'W-27', 'W-28', 'W-T5', 'W-T6', 'W-T8', 'W-T12'];

      if (!allowWebEdge.includes(newValue)) {
        this.selected.webEdge = this.selected.mainColor;
      }
    }
  },

  mounted() {
    // モバイルかどうかを判定
    this.isMobile = window.innerWidth <= 768;
    window.addEventListener("resize", this.handleResize);

    // タブの初期化（存在する場合のみ）
    const tabsElement = document.querySelector("#myTab");
    if (tabsElement) {
      const tabs = tabsElement.querySelectorAll("a");
      tabs.forEach((tab) => {
        new Tab(tab);
      });
    }
    // クエリパラメータから sessionID を取得
    const querySessionID = this.$route.query.sessionID;

    if (querySessionID) {
      this.sessionID = querySessionID; // sessionID をセット
      this.loadSelections();
    }

    this.activeTab = "パーツ"; // 初期表示をパーツに設定

    this.updateBodyPadding();
    window.addEventListener("resize", this.updateBodyPadding);

    // middle-sideのスクロールイベントを監視
    this.$refs.middleSide.addEventListener("scroll", this.handleScroll);

    this.isRestoring = false;
    this.calculateTotal();

    // ツールチップ
    if ($('#customTooltip').length === 0) {
      $('body').append('<div id="customTooltip" class="custom-tooltip"></div>');
    }

    $(document)
    .on('mouseenter', '[data-tooltip]', function () {
      const $target = $(this);
      const tooltipText = $target.attr('data-tooltip');
      const $tooltip = $('#customTooltip');
      $tooltip.text(tooltipText);
      
      // ツールチップの幅と高さを取得するため一旦表示（非表示状態で）
      $tooltip.css({ display: 'block', visibility: 'hidden' });
      
      // ターゲットの位置とサイズを取得
      const offset = $target.offset();
      const targetWidth = $target.outerWidth();
      const targetHeight = $target.outerHeight();
      const tooltipWidth = $tooltip.outerWidth();
      const tooltipHeight = $tooltip.outerHeight();
      
      // 通常はターゲットの上部に表示する位置を計算
      let left = offset.left + targetWidth / 2 - tooltipWidth / 2;
      let top = offset.top - tooltipHeight - 5; // 5pxの余白
      
      // もし上に表示すると画面外に出る（top < 0）場合は、下に表示する
      if (top < 0) {
        top = offset.top + targetHeight + 5;
      }
      
      // ツールチップを配置して表示
      $tooltip.css({
        left: left + 'px',
        top: top + 'px',
        visibility: 'visible'
      });
      
      $tooltip.hide().fadeIn(200);
    })
    .on('mouseleave', '[data-tooltip]', function () {
      $('#customTooltip').fadeOut(200);
    });


    // すべての画像の読み込みを待つ
    this.waitForImages().then(() => {
      this.allImagesLoaded = true;

    });
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    document.body.style.paddingTop = "40px";

    // コンポーネント破棄前にイベントリスナーを解除
    this.$refs.middleSide.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll() {
      // しきい値（スクロール位置）を調整する
      const scrollThreshold = 18; // 必要に応じて変更
      if (this.$refs.middleSide.scrollTop > scrollThreshold) {
        this.$refs.totalPriceHeight.style.height = "138px";
      } else {
        this.$refs.totalPriceHeight.style.height = "116px";
      }
    },

    openModal() {
      // console.log("親コンポーネントの selected:", this.selected);
      // 刺繍データを取得;
      const {
        embroideryPosition,
        font,
        fontColor,
        shadowEdge,
        shadowColor,
        edgeColor,
        embroideryContent,
      } = this.selected;

      // 刺繍データが1つでも入力されている場合の条件
      if (
        embroideryPosition ||
        font ||
        fontColor ||
        shadowEdge ||
        shadowColor ||
        edgeColor ||
        embroideryContent
      ) {
        this.showAlertMessage("刺繍設定を追加またはリセットしてください"); // アラートを表示
        return; // モーダルを開かない
      }

      // 保存済みの刺繍設定のエラーフラグを、各 selection のプロパティとしてチェックする
      const hasError = this.savedSelections.some(
      selection => selection.embSavedTextInputError === true
      
      );
  
        if (hasError) {
          this.showAlertMessage("入力内容に誤りがあります");
      
        // もし現在のタブが「刺繍」でなければタブを切り替える
        if (this.activeTab !== "刺繍") {
          this.setActiveTab("刺繍");
          // タブ切り替え後、DOM の更新が終わるのを待ってからスクロール＆フォーカス
          this.$nextTick(() => {
            const errorField = document.querySelector('.emb-input-error');
            if (errorField) {
              const detailsElem = errorField.closest('details');
              if (detailsElem && !detailsElem.open) {
                detailsElem.open = true;
              }
              errorField.scrollIntoView({ behavior: "smooth", block: "center" });
              errorField.focus();
            }
          });
        } else {
          // すでに「刺繍」タブにいる場合
          this.$nextTick(() => {
            const errorField = document.querySelector('.emb-input-error');
            if (errorField) {
              const detailsElem = errorField.closest('details');
              if (detailsElem && !detailsElem.open) {
                detailsElem.open = true;
              }
              errorField.scrollIntoView({ behavior: "smooth", block: "center" });
              errorField.focus();
            }
          });
          }
        return; // これ以降は実行しない
        }

        // (B) バリデーション処理
        // 条件付きでチェックを緩める項目
        const conditionalExcludes = {
          beltType: () => this.selected.backStyle === "ライナーバック",
          finger: () => this.selected.backStyle === "ライナーバック",
          optionMainColor: () =>
            this.selected.treasureLabelChoice !==
            "オリジナル（+3,300円&納期+30日）",
          optionShadowColor: () =>
            this.selected.treasureLabelChoice !==
            "オリジナル（+3,300円&納期+30日）",
          optionStandColor: () =>
            this.selected.treasureLabelChoice !==
            "オリジナル（+3,300円&納期+30日）",
          webEdge: () =>
            !['W-23', 'W-27', 'W-28', 'W-T5', 'W-T6', 'W-T8', 'W-T12'].includes(this.selected.web),
          bandColor: () =>
           ['親指一体', 'Tベルト'].includes(this.selected.beltType),  
        };

        // 完全に無視するキー（例: 刺繍項目はここで無視）
        const excludeKeys = [
          "embroideryPosition",
          "font",
          "fontColor",
          "shadowEdge",
          "shadowColor",
          "edgeColor",
          "embroideryContent",
        ];

        // まず missingFields をリセット
        this.missingFields = [];

        // 1) グラブ選択の未選択チェック
        const unselectedItems = Object.entries(this.selected).filter(
          ([key, value]) => {
            // 無視するキー
            if (excludeKeys.includes(key)) return false;

            // 条件付きで無視する場合
            if (key in conditionalExcludes && conditionalExcludes[key]()) {
              return false;
            }

            // ここで「未選択 or 空文字」を判定
            return (
              value === "未選択" ||
              value === "未入力" ||
              value === null ||
              value === ""
            );
          }
        );
        // missingFields にキーのみ入れる
        this.missingFields = unselectedItems.map(([key]) => key);

        // 2) 刺繍設定のチェック
        let missingMessages = [];

        this.savedSelections.forEach((selection, index) => {
          // 刺繍位置
          if (
            !selection.embroideryPosition ||
            selection.embroideryPosition === "未選択"
          ) {
            missingMessages.push(
              `刺繍設定 ${index + 1}: 刺繍位置を選択してください`
            );
          }
          // 書体
          if (!selection.font || selection.font === "未選択") {
            missingMessages.push(`刺繍設定 ${index + 1}: 書体を選択してください`);
          }
          // フォントカラー
          if (!selection.fontColor || selection.fontColor === "未選択") {
            missingMessages.push(
              `刺繍設定 ${index + 1}: 書体カラーを選択してください`
            );
          }
          // 刺繍内容
          if (
            !selection.embroideryContent ||
            selection.embroideryContent.trim() === ""
          ) {
            missingMessages.push(
              `刺繍設定 ${index + 1}: 刺繍内容を入力してください`
            );
          }
          // カゲ・フチ
          if (
            selection.shadowEdge === "カゲ" &&
            (!selection.shadowColor || selection.shadowColor === "未選択")
          ) {
            missingMessages.push(
              `刺繍設定 ${index + 1}: カゲカラーを選択してください`
            );
          }
          if (
            selection.shadowEdge === "フチ" &&
            (!selection.edgeColor || selection.edgeColor === "未選択")
          ) {
                    missingMessages.push(
              `刺繍設定 ${index + 1}: フチカラーを選択してください`
            );
          }
        });

        if (missingMessages.length > 0) {
          alert(missingMessages.join("\n"));
          return;
        }

        // 次に、パーツやカラーに関する未選択（this.missingFields がある場合）
        // その場合は、タブ切替とフォーカス処理だけ行い、アラートは出さない
        if (this.missingFields.length > 0) {
          this.showAlertMessage("未選択の項目があります");
          console.log(this.missingFields);
          // まず、各タブのキー配列を作成する
          const partsKeys = this.partsDropdownItems.map((item) => item.key);
          // const colorKeys = this.colorDropdownItems.map((item) => item.key);

          // backStyleによってカラーの選択肢群を切り替え
          let selectedColorItems = [];
          if (this.backStyle === "レギュラー") {
            selectedColorItems = this.colorDropdownRegularItems;
          } else if (this.backStyle === "王冠") {
            selectedColorItems = this.colorDropdownCrownItems;
          } else if (this.backStyle === "ライナーバック") {
            selectedColorItems = this.colorDropdownLinrItems;
          }
          // 選択した配列からキーを抽出
          const colorKeys = selectedColorItems.map((item) => item.key);

          // ここで、カラータブで表示しているが colorDropdownItems には含まれていないキーを追加する
          const extraColorKeys = [
            "treasureLabelChoice",
            "additional",
            "optionMainColor",
            "optionShadowColor",
            "optionStandColor",
          ]; // 例として追加するキー
          const colorTabKeys = colorKeys.concat(extraColorKeys);

          // missingFields には未選択と判定されたキーが入っている前提
          const missingParts = this.missingFields.filter((key) =>
            partsKeys.includes(key)
          );
          const missingColor = this.missingFields.filter((key) =>
            colorTabKeys.includes(key)
          );

          // 優先度に従ってターゲットタブを決定
          let targetTab = this.activeTab; // 現在のタブを初期値とする

          // ① パーツタブに未選択項目があれば、強制的にパーツタブに切り替え
          if (missingParts.length > 0) {
            targetTab = "パーツ";
          }
          // ② もしパーツタブがすべて入力済み（missingParts が空）で、カラータブに未選択項目があれば、カラータブに切り替え
          else if (missingColor.length > 0) {
            targetTab = "カラー";
          }

          // タブを切り替える（もし必要なら）
          if (targetTab !== this.activeTab) {
            this.setActiveTab(targetTab);
          }
          this.$nextTick(() => {
            const firstMissing = document.querySelector(
              ".custom-select.is-missing"
            );
            if (firstMissing) {
              firstMissing.focus();
              firstMissing.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }
          });
          return;
        }

      this.isModalVisible = true;
    },

    showAlertMessage(message) {
    this.alertMessage = message.replace(/\n/g, "<br>"); // \n を <br> に変換
    this.showAlert = true;
  
      setTimeout(() => {
        this.showAlert = false;
      }, 5000);
    },

    // リセット機能が必要なら
    resetEmbroidery() {

      
      // ユーザーに確認メッセージを出す
      const isConfirmed = window.confirm("刺繍の選択内容をリセットしますか？");

      // 「OK」が押されたらリセット処理を実行
      if (isConfirmed) {
        this.selected.embroideryPosition = null;
        this.selected.font = null;
        this.selected.fontColor = null;
        this.selected.shadowEdge = null;
        this.selected.shadowColor = null;
        this.selected.edgeColor = null;
        this.selected.embroideryContent = "";

        this.calculateTotal();
      }
    },

    //////////////////////////////////////////
    ///////////     パーツの関数     ///////////
    //////////////////////////////////////////

    //ポジションの選択肢が変更されると発火
    updatePosition(newPosition) {
      let previous = this.previousPosition;
      const isConfirmed = window.confirm("ポジションを変更するとカラーがリセットされます。よろしいですか？");
      if (!isConfirmed) {
        this.selected.position = previous;
        return;
      }
      this.isDataRestoring = true;
      
      this.selected.position = newPosition; // newPositionが選択された値になりselected.positionへ代入
      this.selected.typeName = null;
      this.selected.finger = null;
      if(newPosition == "投手") {
        this.selected.modelChoice= "硬式用(77,000円)";
        this.selected.typeName= "TLN";
        this.selected.gloveHand= "右投げ";
        this.selected.backStyle= "レギュラー";
        this.selected.beltType= "Tベルト";
        this.selected.fingerSize= null;
        this.selected.backStrand= "クロス×ストレート";
        this.selected.hamidashiChoice= "玉はみ"; // ハミダシの選択値
        this.selected.lacePortion= "ヨコトジダブル";
        this.selected.laceStrand= "逆巻き";
        this.selected.web= "W-T7";
        this.selected.finger= "なし";

        //カラー
        this.selected.mainColor= "ネイビー";
        this.selected.thumbOut= "ネイビー";
        this.selected.thumbIn= "ネイビー";
        this.selected.indexFingerOut= "ネイビー";
        this.selected.indexFingerIn= "ネイビー";
        this.selected.middleFingerOut= "ネイビー";
        this.selected.middleFingerIn= "ネイビー";
        this.selected.thirdFingerOut= "ネイビー";
        this.selected.thirdFingerIn= "ネイビー";
        this.selected.littleFingerOut= "ネイビー";
        this.selected.littleFingerIn= "ネイビー";
        this.selected.bandColor= "ネイビー";
        this.selected.catchColor= "ネイビー";
        this.selected.thumbHanger= "ネイビー";
        this.selected.littleFingerHanger= "ネイビー";
        this.selected.hemLeather= "サックス";
        this.selected.webBack= "ネイビー";
        this.selected.webCatch= "ネイビー";
        this.selected.webEdge= "ネイビー";
        this.selected.hiraura= "Dオレンジ";
        this.selected.treasureBelt= "ネイビー";
        this.selected.fingerCoverColor= "ネイビー";
        this.selected.additional= "サックス"; // 追加ドロップダウンの選択値
        this.selected.laceColor= "ミズイロ";
        this.selected.stitchColor= "ネイビー";
        this.selected.treasureLabelChoice= "標準2(ゴールド×ブラック×Lゴールド)";
        this.selected.optionMainColor= "金糸";
        this.selected.optionShadowColor= "ブラック";
        this.selected.optionStandColor= "Lゴールド";
          // 王冠用
          this.selected.indexAndMiddleFinger= "Dオレンジ";
          this.selected.middleAndThirdFinger= "Dオレンジ";
          this.selected.thirdAndLittleFinger= "Dオレンジ";
          // ライナーバック用
          this.selected.thumbIndexAndMiddleFinger= "Dオレンジ";
      } else if(newPosition == "内野") {
        this.selected.modelChoice= "硬式用(77,000円)";
        this.selected.typeName= "NLA";
        this.selected.gloveHand= "右投げ";
        this.selected.backStyle= "レギュラー";
        this.selected.beltType= "レギュラー";
        this.selected.fingerSize= null;
        this.selected.backStrand= "クロス×ストレート";
        this.selected.hamidashiChoice= "玉はみ"; // ハミダシの選択値
        this.selected.lacePortion= "ヨコトジダブルひも抜き";
        this.selected.laceStrand= "逆巻き";
        this.selected.web= "W-24";
        this.selected.finger= "なし";

        //カラー
        this.selected.mainColor= "キャメル";
        this.selected.thumbOut= "キャメル";
        this.selected.thumbIn= "キャメル";
        this.selected.indexFingerOut= "キャメル";
        this.selected.indexFingerIn= "キャメル";
        this.selected.middleFingerOut= "キャメル";
        this.selected.middleFingerIn= "キャメル";
        this.selected.thirdFingerOut= "キャメル";
        this.selected.thirdFingerIn= "キャメル";
        this.selected.littleFingerOut= "キャメル";
        this.selected.littleFingerIn= "キャメル";
        this.selected.bandColor= "キャメル";
        this.selected.catchColor= "キャメル";
        this.selected.thumbHanger= "キャメル";
        this.selected.littleFingerHanger= "キャメル";
        this.selected.hemLeather= "キャメル";
        this.selected.webBack= "キャメル";
        this.selected.webCatch= "キャメル";
        this.selected.webEdge= "キャメル";
        this.selected.hiraura= "ブラック";
        this.selected.treasureBelt= "キャメル";
        this.selected.fingerCoverColor= "キャメル";
        this.selected.additional= "キャメル"; // 追加ドロップダウンの選択値
        this.selected.laceColor= "ミズイロ";
        this.selected.stitchColor= "ネイビー";
        this.selected.treasureLabelChoice= "オリジナル（+3,300円&納期+30日）";
        this.selected.optionMainColor= "ネイビー";
        this.selected.optionShadowColor= "銀糸";
        this.selected.optionStandColor= "サックス";
          // 王冠用
          this.selected.indexAndMiddleFinger= "キャメル";
          this.selected.middleAndThirdFinger= "キャメル";
          this.selected.thirdAndLittleFinger= "キャメル";
          // ライナーバック用
          this.selected.thumbIndexAndMiddleFinger= "キャメル";
      } else if(newPosition == "外野") {
        this.selected.modelChoice= "硬式用(77,000円)";
        this.selected.typeName= "GWA";
        this.selected.gloveHand= "右投げ";
        this.selected.backStyle= "レギュラー";
        this.selected.beltType= "レギュラー";
        this.selected.fingerSize= null;
        this.selected.backStrand= "なし";
        this.selected.hamidashiChoice= "玉はみ"; // ハミダシの選択値
        this.selected.lacePortion= "ヨコトジ";
        this.selected.laceStrand= "レギュラー巻き";
        this.selected.web= "W-T12";
        this.selected.finger= "なし";

        //カラー
        this.selected.mainColor= "オレンジ";
        this.selected.thumbOut= "オレンジ";
        this.selected.thumbIn= "オレンジ";
        this.selected.indexFingerOut= "ブラック";
        this.selected.indexFingerIn= "オレンジ";
        this.selected.middleFingerOut= "オレンジ";
        this.selected.middleFingerIn= "オレンジ";
        this.selected.thirdFingerOut= "オレンジ";
        this.selected.thirdFingerIn= "オレンジ";
        this.selected.littleFingerOut= "オレンジ";
        this.selected.littleFingerIn= "ブラック";
        this.selected.bandColor= "オレンジ";
        this.selected.catchColor= "オレンジ";
        this.selected.thumbHanger= "オレンジ";
        this.selected.littleFingerHanger= "オレンジ";
        this.selected.hemLeather= "オレンジ";
        this.selected.webBack= "オレンジ";
        this.selected.webCatch= "オレンジ";
        this.selected.webEdge= "オレンジ";
        this.selected.hiraura= "ブラック";
        this.selected.treasureBelt= "オレンジ";
        this.selected.fingerCoverColor= "オレンジ";
        this.selected.additional= "オレンジ"; // 追加ドロップダウンの選択値
        this.selected.laceColor= "ブラック";
        this.selected.stitchColor= "ブラック";
        this.selected.treasureLabelChoice= "標準2(ゴールド×ブラック×Lゴールド)";
        this.selected.optionMainColor= "金糸";
        this.selected.optionShadowColor= "ブラック";
        this.selected.optionStandColor= "Lゴールド";
          // 王冠用
          this.selected.indexAndMiddleFinger= "ブラック";
          this.selected.middleAndThirdFinger= "ブラック";
          this.selected.thirdAndLittleFinger= "ブラック";
          // ライナーバック用
          this.selected.thumbIndexAndMiddleFinger= "ブラック";
      }

      this.additionalOptions =
        hamidashiAdditionalOptions[this.selected.hamidashiChoice] || [];

      this.updateImages();

      this.$nextTick(() => {
        this.isDataRestoring = false;
        this.calculateTotal();
      });
    },

    //バックスタイルの選択によって、ベルト型・指カバー指アテの選択を制御&警告文表示
    handleBackStyleChange(value) {
      this.selected.backStyle = value;
      if (value === "ライナーバック") {
        this.selected.beltType = null;
        this.selected.finger = null;
        this.showBeltWarning = true;
        this.showFingerWarning = true;
      } else {
        this.showBeltWarning = false;
        this.showFingerWarning = false;
      }
      this.changeDirection("背面");
      // 指カバー・指アテがリセットされたので、金額も再計算する
      this.$nextTick(() => {
        this.calculateTotal();
      });
    },

    //v-forにて使い回し時、警告文の分岐条件取得
    getActiveWarnings(dropdown) {
      // warnings が無ければ空配列を返す
      if (!dropdown.warnings) {
        return [];
      }
      // condition が true のものだけフィルタ
      return dropdown.warnings.filter((w) => w.condition);
    },

    updateSelection(key, value) {
      console.log("update発火");
      this.updateImages();

      this.selected[key] = value; // 選択された値をデータに保存
      // console.log(`${this.labelMap[key] || key} が選択されました:`, value); // ラベル対応 or key
      if(key == "lacePortion" || key == "laceStrand") {
        this.changeDirection("捕球面");
      } else if (key == "beltType" || key == "backStrand" || key == "finger") {
        this.changeDirection("背面");
      }
      // console.log("updeteSelecton発火")
      // 合計計算処理が必要なら実行
      this.calculateTotal?.();
    },

    calculateTotal() {
      let total = 0;

      // モデル、サイズ、レース、指の選択によるコスト加算（既存の処理）
      const chosenModelChoice = this.modelChoiceOptions.find(
        (o) => o.label === this.selected.modelChoice
      );
      if (chosenModelChoice && chosenModelChoice.cost) {
        total += chosenModelChoice.cost;
      }
      const chosenFingerSize = this.fingerSizeOptions.find(
        (o) => o.label === this.selected.fingerSize
      );
      if (chosenFingerSize && chosenFingerSize.cost) {
        total += chosenFingerSize.cost;
      }
      const chosenLacePortion = this.lacePortionOptions.find(
        (o) => o.label === this.selected.lacePortion
      );
      if (chosenLacePortion && chosenLacePortion.cost) {
        total += chosenLacePortion.cost;
      }

      let chosenFinger = this.fingerOptions.find(
        (o) => o.label === this.selected.finger
      );

      // filteredFingerOptions() で見つからなかったら再度チェック
      if (!chosenFinger) {
        chosenFinger = this.filteredFingerOptions.find(
          (o) => o.label === this.selected.finger
        );
      }

      if (chosenFinger && chosenFinger.cost) {
        total += chosenFinger.cost;
      }

      // レースカラーとステッチカラーのコスト加算
      const chosenLaceColor = this.laceColorOptions.find(
        (o) => o.label === this.selected.laceColor
      );
      if (chosenLaceColor && chosenLaceColor.cost) {
        total += chosenLaceColor.cost;
      }

      const chosenStitchColor = this.stitchColorOptions.find(
        (o) => o.label === this.selected.stitchColor
      );
      if (chosenStitchColor && chosenStitchColor.cost) {
        total += chosenStitchColor.cost;
      }

      const chosenTreasureLabelChoice = this.treasureLabelOptions.find(
        (o) => o.label === this.selected.treasureLabelChoice
      );
      if (chosenTreasureLabelChoice && chosenTreasureLabelChoice.cost) {
        total += chosenTreasureLabelChoice.cost;
      }

      // --- 新規選択（this.selected）の金額計算 ---
      if (this.selected.embroideryPosition) {
        const chosenEmbroideryPosition = this.embroideryPositionOptions.find(
          (o) => o.label === this.selected.embroideryPosition
        );
        if (chosenEmbroideryPosition?.cost) {
          total += chosenEmbroideryPosition.cost;
        }
      }

      if (this.selected.shadowEdge === "カゲ") {
        total += 2500; // カゲの固定費用
        if (this.selected.shadowColor) {
          const chosenShadowColor = this.shadowColorOptions.find(
            (o) => o.label === this.selected.shadowColor
          );
          if (chosenShadowColor?.cost) {
            total += chosenShadowColor.cost; // カゲカラーの費用
          }
        }
      } else if (this.selected.shadowEdge === "フチ") {
        total += 3000; // フチの固定費用
        if (this.selected.edgeColor) {
          const chosenEdgeColor = this.edgeColorOptions.find(
            (o) => o.label === this.selected.edgeColor
          );
          if (chosenEdgeColor?.cost) {
            total += chosenEdgeColor.cost; // フチカラーの費用
          }
        }
      }

      // --- 保存済み選択（this.savedSelections）の金額計算 ---
      this.savedSelections.forEach((selection) => {
        if (selection.embroideryPosition) {
          const chosenEmbroideryPosition = this.embroideryPositionOptions.find(
            (o) => o.label === selection.embroideryPosition
          );
          if (chosenEmbroideryPosition?.cost) {
            total += chosenEmbroideryPosition.cost;
          }
        }

        if (selection.shadowEdge === "カゲ") {
          total += 2500; // カゲの固定費用
          if (selection.shadowColor) {
            const chosenShadowColor = this.shadowColorOptions.find(
              (o) => o.label === selection.shadowColor
            );
            if (chosenShadowColor?.cost) {
              total += chosenShadowColor.cost; // カゲカラーの費用
            }
          }
        } else if (selection.shadowEdge === "フチ") {
          total += 3000; // フチの固定費用
          if (selection.edgeColor) {
            const chosenEdgeColor = this.edgeColorOptions.find(
              (o) => o.label === selection.edgeColor
            );
            if (chosenEdgeColor?.cost) {
              total += chosenEdgeColor.cost; // フチカラーの費用
            }
          }
        }
      });

      // すべての選択された色を収集
      //コメントアウトした色は金額の加算から除外されます。
      // const allColorSelections = [
      //   // { value: this.selected.mainColor, part: "本体" },
      //   { value: this.selected.thumbOut, part: "親指外側" },
      //   { value: this.selected.thumbIn, part: "親指内側" },
      //   { value: this.selected.indexFingerOut, part: "人差し指外側" },
      //   { value: this.selected.indexFingerIn, part: "人差し指内側" },
      //   { value: this.selected.middleFingerOut, part: "中指外側" },
      //   { value: this.selected.middleFingerIn, part: "中指内側" },
      //   { value: this.selected.thirdFingerOut, part: "薬指外側" },
      //   { value: this.selected.thirdFingerIn, part: "薬指内側" },
      //   { value: this.selected.littleFingerOut, part: "小指外側" },
      //   { value: this.selected.littleFingerIn, part: "小指内側" },
      //   { value: this.selected.bandColor, part: "バンド" },
      //   { value: this.selected.catchColor, part: "捕球面" },
      //   { value: this.selected.thumbHanger, part: "親指掛け" },
      //   { value: this.selected.littleFingerHanger, part: "小指掛け" },
      //   // { value: this.selected.hemLeather, part: "ヘリ革" },
      //   { value: this.selected.webBack, part: "ウェブ背面側・タテ棒" },
      //   { value: this.selected.webCatch, part: "ウェブ捕球面側・ヨコ棒" },
      //   { value: this.selected.webEdge, part: "ウェブエッジ・その他" },
      //   { value: this.selected.hiraura, part: "平裏" },
      //   { value: this.selected.treasureBelt, part: "トレジャーベルト" },
      //   { value: this.selected.fingerCoverColor, part: "指カバー・指あて" },
      //   // { value: this.selected.additional, part: "切はみ" },
      //   // { value: this.selected.additional, part: "玉はみ" },
      //   // { value: this.selected.laceColor, part: "レース" },
      //   // { value: this.selected.stitchColor, part: "ステッチ" },
      //   // { value: this.selected.optionMainColor, part: "メインカラー" },
      //   // { value: this.selected.optionShadowColor, part: "カゲカラー" },
      //   // { value: this.selected.optionStandColor, part: "台カラー" },
      //     // 王冠用
      //     { value: this.selected.indexAndMiddleFinger, part: "人差し指外側・中指内側" },
      //     { value: this.selected.middleAndThirdFinger, part: "中指外側・薬指内側" },
      //     { value: this.selected.thirdAndLittleFinger, part: "薬指外側・小指内側" },
      //     // ライナーバック用
      //     { value: this.selected.thumbIndexAndMiddleFinger, part: "親指・人差し指・中指内側" },
      // ];
      let activeColorItems = [];

      if (this.selected.backStyle === "レギュラー") {
        activeColorItems = this.colorDropdownRegularItems;
      } else if (this.selected.backStyle === "王冠") {
        activeColorItems = this.colorDropdownCrownItems;
      } else if (this.selected.backStyle === "ライナーバック") {
        activeColorItems = this.colorDropdownLinrItems;
      }

      const allColorSelections = activeColorItems.map((item) => ({
        value: this.selected[item.key],
        part: item.name,
      }));
      // 除外する部位のリスト
      const excludedParts = [
        // "レース",
        // "ステッチ",
        "メインカラー",
        "カゲカラー",
        "台カラー",
        "ヘリ革",
      ];

      // 除外対象ではない部位の色をフィルタリング
      const validColors = allColorSelections.filter((colorSelection) => {
        // 選択された部位が除外対象でないことを確認
        const isPartExcluded = excludedParts.includes(colorSelection.part);

        // 色が mainColors に含まれているか確認
        const isColorValid =
          this.mainColors.some(
            (mainColor) => mainColor.value === colorSelection.value
          ) ||
          this.laceColorOptions.some(
            (laceColor) => laceColor.value === colorSelection.value
          ) ||
          this.stitchColorOptions.some(
            (stitchColor) => stitchColor.value === colorSelection.value
          );

        // 部位が除外対象でなく、かつ色が有効であれば加算対象とする
        return colorSelection.value && !isPartExcluded && isColorValid;
      });

      // 異なる色の数を計算
      const uniqueColors = [
        ...new Set(validColors.map((color) => color.value)),
      ]; // 重複を削除
      const extraColorCount =
        uniqueColors.length > 1 ? uniqueColors.length - 1 : 0;

      // 色ごとの追加料金計算（消費税は最後に適用）
      const additionalCost = extraColorCount * 3000;
      total += additionalCost;

      // --- 新規選択（this.selected）の色計算 ---
      // --- 刺繍タブのすべての色を収集 ---
      const allEmbroideryColors = [];

      // 新規選択の色を収集
      allEmbroideryColors.push(
        this.selected.fontColor,
        this.selected.shadowColor,
        this.selected.edgeColor
      );

      // 保存済み選択の色を収集
      this.savedSelections.forEach((selection) => {
        allEmbroideryColors.push(
          selection.fontColor,
          selection.shadowColor,
          selection.edgeColor
        );
      });

      // 有効な色のみをフィルタリングしてユニークな色を計算
      const uniqueEmbroideryColors = [
        ...new Set(allEmbroideryColors.filter((color) => color)),
      ];

      // 異なる色が選択されている数に応じて加算
      const extraEmbroideryColorCount =
        uniqueEmbroideryColors.length > 2
          ? uniqueEmbroideryColors.length - 2
          : 0;
      const embroideryAdditionalCost = extraEmbroideryColorCount * 1000;

      total += embroideryAdditionalCost;
      console.log('刺繍金額:', embroideryAdditionalCost);

      // **消費税率をここで適用**
      this.totalPrice = Number((total * 1.1).toFixed(0));
    },

    onClickEmbroideryPosition() {
      // disabled のとき、ポップアップとか alert を出す
      // alert("刺繍位置を変更する場合は一度設定を削除してください");
    },

    handleShadowEdgeChange(
      value,
      isNewSelection = true,
      index = null,
      skipColorReset = false
    ) {
      if (isNewSelection) {
        // 新規選択の場合
        this.updateSelection("shadowEdge", value);
        this.isShadowColorOpen = false;
        this.isEdgeColorOpen = false;

        // ★ ここでskipColorResetがfalseならカラーをリセット、trueならリセットしない
        if (!skipColorReset) {
          if (value === "カゲ") {
            this.isShadowColorEnabled = true;
            this.isEdgeColorEnabled = false;
            this.selected.edgeColor = null;
            this.selected.shadowColor = null;
          } else if (value === "フチ") {
            this.isShadowColorEnabled = false;
            this.isEdgeColorEnabled = true;
            this.selected.shadowColor = null;
            this.selected.edgeColor = null;
          } else {
            this.isShadowColorEnabled = false;
            this.isEdgeColorEnabled = false;
            this.selected.shadowColor = null;
            this.selected.edgeColor = null;
          }
        } else {
          // ★ skipColorReset = true の場合でも、
          //    「カゲならカゲ選択肢を有効に、フチならフチ選択肢を有効に」はやる必要がある
          if (value === "カゲ") {
            this.isShadowColorEnabled = true;
            this.isEdgeColorEnabled = false;
          } else if (value === "フチ") {
            this.isShadowColorEnabled = false;
            this.isEdgeColorEnabled = true;
          } else {
            this.isShadowColorEnabled = false;
            this.isEdgeColorEnabled = false;
          }
        }
      } else if (index !== null) {
        // 保存済み選択の場合
        const selection = this.savedSelections[index];
        selection.shadowEdge = value;

        // ★ ここも同じようにskipColorReset制御
        if (!skipColorReset) {
          if (value === "カゲ") {
            selection.isShadowColorEnabled = true;
            selection.isEdgeColorEnabled = false;
            selection.shadowColor = null;
            selection.edgeColor = null;
          } else if (value === "フチ") {
            selection.isShadowColorEnabled = false;
            selection.isEdgeColorEnabled = true;
            selection.shadowColor = null;
            selection.edgeColor = null;
          } else {
            selection.isShadowColorEnabled = false;
            selection.isEdgeColorEnabled = false;
            selection.shadowColor = null;
            selection.edgeColor = null;
          }
        } else {
          if (value === "カゲ") {
            selection.isShadowColorEnabled = true;
            selection.isEdgeColorEnabled = false;
          } else if (value === "フチ") {
            selection.isShadowColorEnabled = false;
            selection.isEdgeColorEnabled = true;
          } else {
            selection.isShadowColorEnabled = false;
            selection.isEdgeColorEnabled = false;
          }
        }
      }

      // 金額再計算
      this.calculateTotal();
    },

    saveAndReset() {
      this.embTextInputError = false;
       // ② 入力内容に日本語が含まれているかをチェックする。入っていればtrue
      const containsJapanese = /[\p{sc=Han}ぁ-んァ-ヶ々〆〤]/u.test(this.selected.embroideryContent);
       // ③ 選ばれた書体が日本語非対応（isJapaneseAllowed が false）で、なおかつ日本語が含まれている(containsJapanese場合
      if (this.selected.font && !this.isJapaneseAllowed(this.selected.font) && containsJapanese) {
        this.embTextInputError = true;
        this.showAlertMessage("入力内容に誤りがあります");
      } else {

        const errors = [];

        // 刺繍内容未入力バリデーション
        if (!this.selected.embroideryContent) {
          errors.push("刺繍内容を入力してください");
        }

        // 刺繍位置未選択バリデーション
        if (!this.selected.embroideryPosition) {
          errors.push("刺繍位置を選択してください");
        }

        // 書体未選択バリデーション
        if (!this.selected.font) {
          errors.push("書体を選択してください");
        }

        // 書体カラー未選択バリデーション
        if (!this.selected.fontColor) {
          errors.push("書体カラーを選択してください");
        }

        // カゲ・フチ未選択バリデーション
        if (!this.selected.shadowEdge) {
          errors.push("カゲ・フチを選択してください");
        }

        // カゲ・フチの選択に応じたバリデーション
        if (this.selected.shadowEdge === "カゲ") {
          if (
            !this.selected.shadowColor ||
            this.selected.shadowColor === "未選択"
          ) {
            errors.push("カゲを選択した場合はカゲカラーを選択してください");
          }
        } else if (this.selected.shadowEdge === "フチ") {
          if (!this.selected.edgeColor || this.selected.edgeColor === "未選択") {
            errors.push("フチを選択した場合はフチカラーを選択してください");
          }
        }
      

        // 🔥 エラーがある場合、エラーメッセージを表示し処理を中断
        if (errors.length > 0) {
          this.showAlertMessage("刺繍設定が未選択、または入力内容に誤りがあります");
          return;
        }

        // エラーがない場合の処理
        this.showError = false;




        // 設定を保存
         // deep copy
        const savedSelection = JSON.parse(JSON.stringify(this.selected)); 
        // const savedSelection = this.selected; 

        // savedSelection.isFontColorOpen = false;
        // savedSelection.isShadowColorOpen = false;
        // savedSelection.isEdgeColorOpen = false;

        this.savedSelections.push(savedSelection);

        // ここで新しく追加された要素の index を取得して
        const newIndex = this.savedSelections.length - 1;

        // その index を使って handleShadowEdgeChange を呼び出す
        // 第1引数には "カゲ・フチ" の状態が入るはず、
        // savedSelection.shadowEdge を渡す
        // shadowEdge があるならここで発火させる
        // ただし、カラーをリセットしたくないので skipColorReset = true を指定
        if (savedSelection.shadowEdge) {
          this.handleShadowEdgeChange(
            savedSelection.shadowEdge,
            false,
            newIndex,
            true // skipColorReset
          );
        }
        
        // もし選択された刺繍位置が「平裏一段目」なら、平裏二段目を有効化する
        if (this.selected.embroideryPosition === "平裏一段目") {
          this.enableSecondRow = true;
        }
        // 使用済みの刺繍位置に追加
        this.usedEmbroideryPositions.push(this.selected.embroideryPosition);

        // 新規設定をリセットする
        this.resetSelection();

        // 刺繍設定後の金額計算を更新
        this.calculateTotal();

        // 成功時のアラート追加
        this.showAlertMessage(`刺繍設定「${savedSelection.embroideryPosition}」を追加しました。`);
      }
    },

    resetSelection() {
      this.selected.embroideryPosition = null;
      this.selected.font = null;
      this.selected.fontColor = null;
      this.selected.shadowEdge = null;
      this.selected.shadowColor = null;
      this.selected.edgeColor = null;
      this.selected.embroideryContent = "";
      // これらを追加してカラー選択を無効にする
      this.isShadowColorEnabled = false;
      this.isEdgeColorEnabled = false;
    },
    switchTab(index) {
      // 新規タブから別のタブに移る場合は、現在の newSelection をキャッシュに保存する
      if (this.activeTabIndex === null) {
        // 現在が新規タブ（activeTabIndex === null）のときは selected の内容を newSelectionCache に退避しておく
        this.newSelectionCache = JSON.parse(JSON.stringify(this.selected));
      }

      // タブを切り替える
      this.activeTabIndex = index;

      if (index === null) {
        // 新規タブに切り替えるとき：以前キャッシュしておいた内容があれば復元、なければ初期化
        if (this.newSelectionCache) {
          this.selected = JSON.parse(JSON.stringify(this.newSelectionCache));
        } else {
          this.resetSelection();
        }
      } else {
        // 既存タブの場合は、保存済みの配列のデータを読み込む（ここはそのまま）
        // たとえば、既存タブの内容を this.selected に deep copy したりする処理を入れる
        // ※ すでに PC版などと同じ処理があればそのままでOK
        // this.selected = JSON.parse(JSON.stringify(this.savedSelections[index]));
        // ここは「既存タブ」用の処理を書く感じ
      }

      this.calculateTotal();
      // this.activeTabIndex = index;

      // if (index === null) {
      //   // 新規タブを選択するとき：全項目を初期化
      //   this.resetSelection();
      // } else {
      //   // 既存タブを選んだとき
      //   // ① savedSelections[index] の内容を深いコピーしてtempに入れる
      //   let temp = JSON.parse(JSON.stringify(this.savedSelections[index]));

      //   // ② カゲ・フチ(shadowEdge)の値に応じて、カラー選択の有効/無効フラグを設定
      //   if (temp.shadowEdge === "カゲ") {
      //     temp.isShadowColorEnabled = true; // カゲカラーは有効
      //     temp.isEdgeColorEnabled = false; // フチカラーは無効
      //     // ※ temp.shadowColor はそのまま保持される
      //   } else if (temp.shadowEdge === "フチ") {
      //     temp.isShadowColorEnabled = false; // カゲカラーは無効
      //     temp.isEdgeColorEnabled = true; // フチカラーは有効
      //     // ※ temp.edgeColor はそのまま保持される
      //   } else {
      //     // どちらも選ばれていない場合
      //     temp.isShadowColorEnabled = false;
      //     temp.isEdgeColorEnabled = false;
      //   }

      //   // ③ deep copyしたtempをthis.selectedにセットする（これで編集用データが更新される）
      //   this.selected = temp;
      // }
    },

    filterColors(options) {
      // if (this.selected.position === "投手") {
      //   return options.filter((option) => {
      //     return (
      //       !option.label.includes("ホワイト") &&
      //       !option.label.includes("Lシルバー")
      //     );
      //   });
      // }
      return options;
    },

    // 一時保存
    // 選択肢を一時保存してIDを生成
    // saveSelections() {
    //   this.sessionID = uuidv4(); // UUIDを生成
    //   localStorage.setItem(this.sessionID, JSON.stringify(this.selected));
    //   alert(`一時保存しました！ セッションID: ${this.sessionID}`);
    // },
    // // 入力されたIDから選択肢を復元
    // loadSelections() {
    //   const savedData = localStorage.getItem(this.sessionID);
    //   if (savedData) {
    //     this.selected = JSON.parse(savedData);
    //     this.calculateTotal(); // 金額を再計算
    //     alert("データを復元しました！");
    //   } else {
    //     alert("データが見つかりません。IDを確認してください。");
    //   }
    // },
    async saveSelections() {
  try {
    this.sessionID = uuidv4().replace(/-/g, "").substring(0, 12);

    const dataToSave = {
      selected: this.selected,
      selection: this.selection,
      savedSelections: this.savedSelections,
    };

    const apiUrl = process.env.VUE_APP_SIMULATION_API_URL;

    if (!apiUrl) {
      alert("VUE_APP_SIMULATION_API_URL が未設定です。");
      return;
    }

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        sessionID: this.sessionID,
        data: dataToSave,
      }),
    });

    if (!response.ok) {
      const text = await response.text();
      alert(`保存に失敗しました。\n${response.status}\n${text}`);
      return;
    }

    await navigator.clipboard.writeText(this.sessionID);

    this.showAlertMessage(
      "選択した内容を保存しました。\n発行されたIDを入力すると続きから作業できます"
    );
  } catch (error) {
    console.error(error);
    alert(`保存処理でエラーが発生しました。\n${error.message}`);
  }
},

async loadSelections() {
  const response = await fetch(
    `${process.env.VUE_APP_SIMULATION_API_URL}?sessionID=${this.sessionID}`
  );

  if (!response.ok) {
    alert("IDが見つかりませんでした。もう一度ご確認ください。");
    return;
  }

  const parsedData = await response.json();

  const restoreData = parsedData.data || parsedData;

  this.isDataRestoring = true;

  const savedHamidashiChoice =
    restoreData?.selected?.hamidashiChoice || "";

  this.updateHamidashiChoiceSelection(
    savedHamidashiChoice
  );

  const savedTreasureLabelChoice =
    restoreData?.selected?.treasureLabelChoice || "";

  this.updateTreasureLabelChoiceSelection(
    savedTreasureLabelChoice
  );

  this.$nextTick(() => {
    this.selected.additional =
      restoreData?.selected?.additional || "";

    this.selected.optionMainColor =
      restoreData?.selected?.optionMainColor || "";

    this.selected.optionShadowColor =
      restoreData?.selected?.optionShadowColor || "";

    this.selected.optionStandColor =
      restoreData?.selected?.optionStandColor || "";

    if (this.$refs.additionalDropdown) {
      this.$refs.additionalDropdown.updateValue(
        this.selected.additional
      );
    }

    if (this.$refs.optionMainColorDropdown) {
      this.$refs.optionMainColorDropdown.updateValue(
        this.selected.optionMainColor
      );
    }

    if (this.$refs.optionShadowColorDropdown) {
      this.$refs.optionShadowColorDropdown.updateValue(
        this.selected.optionShadowColor
      );
    }

    if (this.$refs.optionStandColorDropdown) {
      this.$refs.optionStandColorDropdown.updateValue(
        this.selected.optionStandColor
      );
    }

    this.selected = {
      ...this.selected,
      ...(restoreData.selected || {}),
    };

    this.selection =
      restoreData.selection || {};

    this.savedSelections =
      restoreData.savedSelections || [];

    this.$nextTick(() => {
      this.isDataRestoring = false;
      this.calculateTotal();

      alert(
        "保存していたシミュレーションを復元しました。続きからカスタマイズできます。"
      );
    });
  });
},

    updateHamidashiChoiceSelection(value) {
      // 復元中、または previousHamidashiChoice が設定されていなければ、確認せずに更新する
      if (this.isRestoring || typeof this.previousHamidashiChoice === 'undefined') {
          this.selected.hamidashiChoice = value;
          this.additionalOptions = hamidashiAdditionalOptions[value] || [];
          this.updateSelection("hamidashiChoice", value);
          this.calculateTotal();
          return;
        }

      console.log(this.selected.hamidashiChoice);
      let currentHamidashi = this.previousHamidashiChoice;
  
      // 変更前の値を使って確認ダイアログを表示
      const isConfirmed = window.confirm(`ハミダシを変更すると${currentHamidashi}のカラーがリセットされますがよろしいですか？`);
      
      // キャンセルなら何もせず終了
      if (!isConfirmed) {
        this.selected.hamidashiChoice = currentHamidashi;
        return;
      }
  
      this.selected.hamidashiChoice = value;
      this.additionalOptions = hamidashiAdditionalOptions[value] || [];

      // ★ ここで `updateSelection` を呼ぶ
      //   (key は "hamidashiChoice"、value は今受け取った value)
      this.updateSelection("hamidashiChoice", value);

      this.calculateTotal();
    },

    updateTreasureLabelChoiceSelection(value) {
      this.selected.treasureLabelChoice = value;
      const additionalOptions = treasureLabelOptions[value] || {};

      this.filteredOptionMainColorOptions =
        additionalOptions.optionMainColor || [];
      this.filteredOptionShadowColorOptions =
        additionalOptions.optionShadowColor || [];
      this.filteredOptionStandColorOptions =
        additionalOptions.optionStandColor || [];

      // 選択肢が変更された場合、関連する選択値をリセット
      // this.selected.optionMainColor = "";
      // this.selected.optionShadowColor = "";
      // this.selected.optionStandColor = "";

      if(value == "標準1(ゴールド×レッド×ブラック)") {
        this.selected.optionMainColor = "金糸";
        this.selected.optionShadowColor = "レッド";
        this.selected.optionStandColor = "ブラック";
      } else if(value == "標準2(ゴールド×ブラック×Lゴールド)") {
        this.selected.optionMainColor = "金糸";
        this.selected.optionShadowColor = "ブラック";
        this.selected.optionStandColor = "Lゴールド";
      }

      this.calculateTotal();
    },

    setActivePart(part) {
      this.activePart = part; // アクティブな部位を設定
    },
    handleResize() {
      // 画面サイズ変更時にモバイル判定を更新
      this.isMobile = window.innerWidth <= 768;
    },
    handleDropdownState(isOpen, options = []) {
      this.isDropdownOpen = isOpen; // 既存の動作
      this.activeOptions = options; // 既存の動作
      // console.log("isDropdownOpen:", this.isDropdownOpen);
      // console.log("Active Options:", this.activeOptions);

      if (isOpen) {
        this.activeDropdownId = null; // 初期化
        for (const [dropdownId, dropdownOptions] of Object.entries(
          this.dropdownOptionsMap
        )) {
          if (options === dropdownOptions) {
            // オプションの参照が一致するか確認
            this.activeDropdownId = dropdownId;
            break;
          }
        }
      } else {
        this.activeDropdownId = null;
      }
      // console.log("Active Dropdown ID:", this.activeDropdownId);
    },

    setActiveTab(tabName) {
      this.activeTab = tabName;

      // テンプレート直書き部分のドロップダウン自動close
      this.$nextTick(() => {
        let refItem = this.$refs.labelPositionDropdown;
        if (Array.isArray(refItem)) {
          refItem.forEach(r => {
            if (typeof r.resetDropdown === 'function') {
              r.resetDropdown();
            }
          });
        } else if (refItem && typeof refItem.resetDropdown === 'function') {
          refItem.resetDropdown();
        } 
      });

      if (this.$refs.additionalDropdown) {
        this.$refs.additionalDropdown.resetDropdown();
      }
      if (this.$refs.treasureLabelDropdown) {
        this.$refs.treasureLabelDropdown.resetDropdown();
      }
      if (this.$refs.optionMainColorDropdown) {
        this.$refs.optionMainColorDropdown.resetDropdown();
      }
      if (this.$refs.optionShadowColorDropdown) {
        this.$refs.optionShadowColorDropdown.resetDropdown();
      }
      if (this.$refs.optionStandColorDropdown) {
        this.$refs.optionStandColorDropdown.resetDropdown();
      }

      if (this.$refs.embroideryPositionDropdown) {
        this.$refs.embroideryPositionDropdown.resetDropdown();
      }
      if (this.$refs.fontDropdown) {
        this.$refs.fontDropdown.resetDropdown();
      }
      if (this.$refs.fontColorDropdown) {
        this.$refs.fontColorDropdown.resetDropdown();
      }
      if (this.$refs.shadowEdgeDropdown) {
        this.$refs.shadowEdgeDropdown.resetDropdown();
      }
      if (this.$refs.shadowColorDropdown) {
        this.$refs.shadowColorDropdown.resetDropdown();
      }
      if (this.$refs.edgeColorDropdown) {
        this.$refs.edgeColorDropdown.resetDropdown();
      }

      // sevedSelectionのドロップダウンclose
      const refPrefixes = [
        'embroideryPositionDropdown_',
        'fontDropdown_',
        'fontColorDropdown_',
        'shadowEdgeDropdown_',
        'shadowColorDropdown_',
        'edgeColorDropdown_'
      ];
      refPrefixes.forEach(prefix => {
        this.savedSelections.forEach((selection, index) => {
          const refName = prefix + index;
          const refItem = this.$refs[refName];
          if (refItem) {
            if (Array.isArray(refItem)) {
              refItem.forEach(d => {
                if (typeof d.resetDropdown === 'function') {
                  d.resetDropdown();
                }
              });
            } else if (typeof refItem.resetDropdown === 'function') {
              refItem.resetDropdown();
            }
          }
        });
      });

      // 共通のリセット関数を定義
      const resetDropdownItems = (dropdownItems) => {
        if (!dropdownItems) {
          console.warn("dropdownItems is undefined!");
          return;
        }
        dropdownItems.forEach(item => {
          const refName = item.refName;
          let dropdown = this.$refs[refName];
          if (dropdown) {
            if (Array.isArray(dropdown)) {
              dropdown.forEach(d => {
                if (d.resetDropdown) {
                  d.resetDropdown();
                }
              });
            } else {
              if (dropdown.resetDropdown) {
                dropdown.resetDropdown();
              }
            }
        }
      });
    };

      // for文のドロップダウン群をリセットする
      resetDropdownItems(this.partsDropdownItems);
      resetDropdownItems(this.colorDropdownItems);
      resetDropdownItems(this.colorDropdownRegularItems);
      resetDropdownItems(this.colorDropdownCrownItems);
      resetDropdownItems(this.colorDropdownLinrItems);
      resetDropdownItems(this.colorDropdownSecondItems);


      // カラーパレットを非表示にするコード
      this.colorPaletteItems.forEach(item => {
        this[item.isOpenProp] = false;
      });
      this.colorPaletteSecondItems.forEach(item => {
        this[item.isOpenProp] = false;
      });

      // 直書きの切はみ・玉はみのカラーパレット
      this.isAdditionalPaletteOpen = false;

      // 刺繍プレビューの画像と説明文表
      this.displayEmbroideryPreview = false;

      // savedSelections 内の各カラーパレットを非表示にする
      this.savedSelections.forEach(selection => {
        selection.isFontColorOpen = false;
        selection.isShadowColorOpen = false;
        selection.isEdgeColorOpen = false;
      });

      // 説明文を非表示にするコード
      this.activeDropdownId = null;

      //タブを切り替えるたびスクロールバーを一番上に
      this.$nextTick(() => {
        const leftSide = document.querySelector(".left-side");
        if (leftSide) {
          leftSide.scrollTop = 0;
        }
      });
    },



    confirmDelete(index) {
      const position = this.savedSelections[index].embroideryPosition;
      // 平裏一段目の場合、savedSelections 内に「平裏二段目」があるかチェック
      const hasSecondRow = position === "平裏一段目" &&
        this.savedSelections.some(selection => selection.embroideryPosition === "平裏二段目");

      // 確認メッセージを選択
      const message = hasSecondRow
        ? "平裏一段目を削除すると平裏二段目も削除されますがよろしいですか？"
        : "この刺繍設定を削除してもよろしいでしょうか？";

      if (confirm(message)) {
        this.deleteSelection(index);
      }
    },

    deleteSelection(index) {
      // 削除対象の刺繍位置を取り出してリストから削除
      const deletedPosition = this.savedSelections[index].embroideryPosition;
      // 保存済みリストから削除
      this.savedSelections.splice(index, 1);
      // 使用済みリストから削除
      this.usedEmbroideryPositions = this.usedEmbroideryPositions.filter(
        (position) => position !== deletedPosition
      );

      if (deletedPosition === "平裏一段目") {
        // 「平裏二段目」が存在している場合は、平裏二段目も削除する
        this.savedSelections = this.savedSelections.filter(
          selection => selection.embroideryPosition !== "平裏二段目"
        );
        this.usedEmbroideryPositions = this.usedEmbroideryPositions.filter(
          position => position !== "平裏二段目"
        );
        // 必要に応じて selected.embroideryPosition もクリアするなどの処理を追加
        this.selected.embroideryPosition = null;
      }

      // 金額を再計算
      this.calculateTotal();
    },

    updateBodyPadding() {
      if (window.innerWidth <= 350) {
        // 350px以下
        document.body.style.paddingTop = "0px";
      } else if (window.innerWidth <= 768) {
        // 768px以下
        document.body.style.paddingTop = "40px";
      } else {
        // 768pxを超える場合
        document.body.style.paddingTop = "0px";
      }
    },

    // ColorPaletteで色が選ばれた時に呼ばれるメソッド
    handleColorSelected(key, value) {
      this.selected[key] = value; // 選択された値をデータに保存
      // this.closeAllColorDropdowns();
      // // 2) ドロップダウンを閉じる
      // this.isOptionMainColorOpen = false;
      // this.isOptionShadowColorOpen = false;
      // this.isOptionStandColorOpen = false;

      // //刺繍
      // this.isFontColorOpen = false;
      // this.isShadowColorOpen = false;
      // this.isEdgeColorOpen = false;

      // if (this.$refs.optionMainColorDropdown) {
      //   this.$refs.optionMainColorDropdown.closeDropdown();
      // }
      // if (this.$refs.optionShadowColorDropdown) {
      //   this.$refs.optionShadowColorDropdown.closeDropdown();
      // }
      // if (this.$refs.optionStandColorDropdown) {
      //   this.$refs.optionStandColorDropdown.closeDropdown();
      // }

      // //刺繍
      // this.$refs.fontColorDropdown.closeDropdown();
      // this.$refs.shadowColorDropdown.closeDropdown();
      // this.$refs.edgeColorDropdown.closeDropdown();

      // if (this.$refs.fontColorDropdown) {
      //   this.$refs.fontColorDropdown.closeDropdown();
      // }
      // if (this.$refs.shadowColorDropdown) {
      //   this.$refs.shadowColorDropdown.closeDropdown();
      // }
      // if (this.$refs.edgeColorDropdown) {
      //   this.$refs.edgeColorDropdown.closeDropdown();
      // }
      this.updateImages();

      //金額更新
      this.calculateTotal();
    },

    // closeAllColorDropdowns() {
    //   // 両方の配列をマージ（展開）して1つの配列にする
    //   const allColorDropdowns = [
    //     ...this.colorDropdownItems,
    //     ...this.colorDropdownSecondItems,
    //   ];
    //   allColorDropdowns.forEach((dropdown) => {
    //     const refInstance = this.$refs[dropdown.refName];
    //     if (refInstance) {
    //       if (Array.isArray(refInstance)) {
    //         // 複数インスタンスがある場合はすべてに対して closeDropdown() を呼ぶ
    //         refInstance.forEach((instance) => {
    //           if (instance && typeof instance.closeDropdown === "function") {
    //             instance.closeDropdown();
    //           }
    //         });
    //       } else {
    //         // 単体の場合
    //         if (typeof refInstance.closeDropdown === "function") {
    //           refInstance.closeDropdown();
    //         }
    //       }
    //     }
    //     // 関連するフラグもリセットする
    //     if (dropdown.isOpenProp) {
    //       this[dropdown.isOpenProp] = false;
    //     }
    //   });
    // },

    handleAdditionalColorSelected(selectedValue) {
      // 1) 選んだ色を追加ドロップダウンの v-model に反映させる
      this.selected.additional = selectedValue;

      // // 2) もう要らなければカラーパレットを閉じる
      // this.isAdditionalPaletteOpen = false;

      // // 3) カスタムドロップダウンも閉じる（ref があれば OK）
      // if (this.$refs.additionalDropdown) {
      //   this.$refs.additionalDropdown.closeDropdown();
      // }

      //金額更新
      this.calculateTotal();
    },

    // ▼ 各 savedSelections[i] 用のカラー選択ハンドラ
    handleColorSelectedForSaved(index, key, value) {
      // console.log("handleColorSelectedForSaved呼び出し", index, key, value);
      this.savedSelections[index][key] = value;

      // // カラーパレット閉じる
      // this.savedSelections[index].isFontColorOpen = false;
      // this.savedSelections[index].isShadowColorOpen = false;
      // this.savedSelections[index].isEdgeColorOpen = false;

      // ref名
      const fontRef = `fontColorDropdown_${index}`;
      console.log("fontRef", fontRef, "の中身は…", this.$refs[fontRef]);

      // もし中身が undefined ならそもそも ref ついてない/コンポーネントが存在しない
      // // もし中身がオブジェクトなら OK
      // if (this.$refs[fontRef]) {
      //   console.log("closeDropdownは？", this.$refs[fontRef].closeDropdown);
      //   // ↑ ここで function が返ってくればOK
      //   //    undefined なら存在しない

      //   if (typeof this.$refs[fontRef].closeDropdown === "function") {
      //     this.$refs[fontRef].closeDropdown();
      //   }
      // }

      this.calculateTotal();
    },

    // カラーパレット開くときは全部 false にしてから、必要なとこだけ true
    onDropDownOpenForSaved(index, target) {
      this.savedSelections[index].isFontColorOpen = false;
      this.savedSelections[index].isShadowColorOpen = false;
      this.savedSelections[index].isEdgeColorOpen = false;
      this.savedSelections[index][target] = true;
      // let keyMap = {
      //   isFontColorOpen: "fontColor",
      //   isShadowColorOpen: "shadowColor",
      //   isEdgeColorOpen: "edgeColor",
      // };

      // if (keyMap[target]) {
      //   this.updateSelection(keyMap[target], this.savedSelections[index][keyMap[target]]);
      // }
      
    },

    handleColorChange(index, colorKey, value) {
      // updateSelection() を呼び出して、選択データを更新
      this.updateSelection(colorKey, value);
      // calculateTotal() を呼び出して、合計金額を再計算
      this.calculateTotal();
    },

    restoreDataFromLocalStorage() {
      console.log("復元コマンド発火！＊！");
      this.isDataRestoring = true;
      const selectedData = localStorage.getItem("selectedData");
      if (selectedData) {
        const parsedSelected = JSON.parse(selectedData);

        // まずはハミダシの値をセット
        const savedHamidashiChoice = parsedSelected.hamidashiChoice || "";
        this.updateHamidashiChoiceSelection(savedHamidashiChoice);

        // もしトレジャーラベルも同様なら同じように呼ぶ
        // const savedTreasureLabelChoice = parsedSelected.treasureLabelChoice || "";
        // this.updateTreasureLabelChoiceSelection(savedTreasureLabelChoice);

        // $nextTick で additional やその他の依存項目を再設定
        this.$nextTick(() => {
          // this.selected に他のプロパティをマージ
          this.selected = {
            ...this.selected,
            ...parsedSelected,
          };

          // もし additional を UI に反映したい場合は、Dropdown の updateValue を呼ぶ
          if (this.$refs.additionalDropdown) {
            this.$refs.additionalDropdown.updateValue(this.selected.additional);
          }

          // savedSelections も復元
          const savedSelectionsStr = localStorage.getItem("savedSelections");
          if (savedSelectionsStr) {
            this.savedSelections = JSON.parse(savedSelectionsStr);
            // ここで usedEmbroideryPositions を復元する
            this.usedEmbroideryPositions = this.savedSelections.map(
              selection => selection.embroideryPosition
            );
          }

          this.$nextTick(() => {
            this.isDataRestoring = false;
          });
      

          this.calculateTotal();

        });
      }
    },
    // 楷書体・行書体なら日本語OK、それ以外は英数字のみ
    isJapaneseAllowed(font) {
      return font === "楷書体" || font === "行書体";
    },

// 刺繍内容のバリデーション（新規入力用）
validateEmbroideryContent() {
  if (!this.selected.embroideryContent) return;

  const containsJapanese = /[\p{sc=Han}ぁ-んァ-ヶ々〆〤]/u.test(this.selected.embroideryContent);
  const containsNonAllowedChars = /[^\p{sc=Han}ぁ-んァ-ヶ々〆〤A-Za-z0-9 ]/u.test(this.selected.embroideryContent);

  if (!this.isJapaneseAllowed(this.selected.font)) {
    // 日本語禁止フォントで日本語を使っている場合はエラー
    this.showError = containsJapanese;
  } else {
    // 日本語OKのフォントでも、特殊記号が含まれている場合はエラー
    this.showError = containsNonAllowedChars;
  }
},

// 保存された刺繍設定のバリデーション
validateEmbroideryContentForSaved(selection) {
  if (!selection.embroideryContent) return;

  const containsJapanese = /[\p{sc=Han}ぁ-んァ-ヶ々〆〤]/u.test(selection.embroideryContent);
  const containsNonAllowedChars = /[^\p{sc=Han}ぁ-んァ-ヶ々〆〤A-Za-z0-9 ]/u.test(selection.embroideryContent);

  if (!this.isJapaneseAllowed(selection.font)) {
    selection.showError = containsJapanese;
  } else {
    selection.showError = containsNonAllowedChars;
  }
},

    // 新規の書体変更時、刺繍内容をリセットしつつ updateSelection() を呼ぶ
    handleFontChange(newFont) {
    // if (!this.selected) { // 🔥 `selected` の存在を確認
    //   console.error("selected is undefined!");
    //   return;
    // }

    // // 🔥 刺繍内容が入力されている場合のみアラートを出す
    // if (this.selected.embroideryContent) {
    //   const isConfirmed = window.confirm("書体を変更すると刺繍内容がリセットされます。よろしいですか？");

    //   if (isConfirmed) {
    //     this.selected.embroideryContent = "";
    //     this.beforeFontChange = newFont;
    //   } else {
    //     // キャンセルなら元のフォントに戻す
    //     this.selected.font = this.beforeFontChange;
    //     return; // ❌ ここで return しないと変更が適用されてしまう
    //   }
    // } else {
    //   this.beforeFontChange = newFont;
    // }
    this.displayEmbroideryPreview = true;
    // 🔥 フォントを実際に変更（追加）
     this.beforeFontChange = newFont;
    this.selected.font = newFont;
    
    // 🔥 必要なら updateSelection() を呼び出す
    this.updateSelection("selected.font", newFont);
  },

    // 保存済みの書体変更時、該当の刺繍内容をリセットしつつ updateSelection() を呼ぶ
    
    handleSavedFontChange(selection, index) {
      this.displayEmbroideryPreview = true;
      // もし書体が日本語対応なら、エラーフラグを false にする
      if (this.isJapaneseAllowed(selection.font)) {
        selection.embSavedTextInputError = false;
        return;
      }


      // 日本語非対応な書体を選んだときは入力言語チェックを行う。  
      const containsJapanese = /[\p{sc=Han}ぁ-んァ-ヶ々〆〤]/u.test(selection.embroideryContent);
      if (containsJapanese) {
        selection.embSavedTextInputError = true;
        this.showAlertMessage("入力内容に使用できない言語が含まれています");
        } else {
        selection.embSavedTextInputError = false;
      }

      // 初回の変更時に `beforeSavedFontChange` に保存する（すでに記録済みならそのまま）
      if (!this.beforeSavedFontChange[index]) {
        this.beforeSavedFontChange[index] = selection.font;
      }

        // 刺繍内容が入力されている場合のみ確認アラートを出す
        // if (selection.embroideryContent) {
        //   const isConfirmed = window.confirm(
        //     `「${selection.embroideryContent}」の刺繍内容がリセットされます。よろしいですか？`
        //   );

        //   if (isConfirmed) {
        //     // OKなら刺繍内容をリセット
        //     selection.embroideryContent = "";
        //   } else {
        //     // キャンセルならフォントを元に戻す
        //     this.$set(this.savedSelections, index, { 
        //       ...selection, 
        //       font: this.beforeSavedFontChange[index] // 🔥 変更前のフォントに戻す
        //     });
        //     return;
        //   }
        // }
        // 既存のフォント変更処理を実行
      this.updateSelection(`savedSelections[${index}].font`, selection.font);
    },

    handleDropdownClick(refName) {
      console.log("ハンドル発火");
      this.$nextTick(() => {
        // this.$refs[refName] の内容を myVariable に代入する
        let dropdownComp = this.$refs[refName];

        // dropdownComp が配列かどうか確認する
        if (Array.isArray(dropdownComp)) {
          console.log("配列");
          // 配列なら最初の要素を使う
          dropdownComp = dropdownComp[0];
        } else {
          console.log("配列ではない");
        }

        // 修正後の dropdownComp を使ってスクロール処理を呼び出す
        this.scrollContainerForDropdown(dropdownComp);
      });
    },

    scrollContainerForDropdown(dropdownComp) {
      // 768px以下では自動スクロールしない
      if (this.isMobile) {
        return;
      }

      if (!dropdownComp) {
        return;
      }

      // ドロップダウンが開いているかチェック
      if (!dropdownComp.isOpen) {
        return;
      }

      let dropdownEl = dropdownComp.$refs.dropdownOptions;
      if (!dropdownEl) {
        return;
      }

      let containerEl = this.$refs.leftSide;
      if (!containerEl) {
        return;
      }

      let containerRect = containerEl.getBoundingClientRect();
      let dropdownRect = dropdownEl.getBoundingClientRect();
      let offset = dropdownRect.top - containerRect.top;
      let headerOffset = 265;
      let targetScrollTop = containerEl.scrollTop + offset - headerOffset;
      containerEl.scrollTo({
        top: targetScrollTop,
        behavior: "smooth",
      });
    },

    handleMissingFields(keys) {
      // モーダルから届いた未選択キー配列をセット
      this.missingFields = keys;
    },
    changeDirection(globeDirection) {
      this.isGlobeDirection = globeDirection;
      this.updateImages();
    },
    selectedColorCon(part) {
      // console.log(part);
      // console.log(this.selected[part]);
      if (part == "stitchColor") {
        return this.colorCon(part) || "lgd";
      } else if (part == "webBack") {
        return this.colorCon(part) || "dor";
      } else if (part == "stitch") {
        return this.colorCon(part) || "lgd";
      } else {
        return this.colorCon(part) || "wht";
      }
    },
    colorCon(part) {
      if (this.selected[part] == "ブラック") {
        return "blk";
      } else if (this.selected[part] == "ネイビー") {
        return "nvy";
      } else if (this.selected[part] == "ブルー") {
        return "blu";
      } else if (this.selected[part] == "サックス") {
        return "sax";
      } else if (this.selected[part] == "オレンジ") {
        return "orn";
      } else if (this.selected[part] == "Dオレンジ") {
        return "dor";
      } else if (this.selected[part] == "レッド") {
        return "red";
      } else if (this.selected[part] == "ピンク") {
        return "pnk";
      } else if (this.selected[part] == "パープル") {
        return "ppl";
      } else if (this.selected[part] == "レモン") {
        return "lmn";
      } else if (this.selected[part] == "コルク") {
        return "crk";
      } else if (this.selected[part] == "チョコ") {
        return "cho";
      } else if (this.selected[part] == "グリーン") {
        return "grn";
      } else if (this.selected[part] == "Mグリーン") {
        return "mgn";
      } else if (this.selected[part] == "グレー") {
        return "gry";
      } else if (this.selected[part] == "ホワイト") {
        return "wht";
      } else if (this.selected[part] == "キャメル") {
        return "cml";
      } else if (this.selected[part] == "シルバー") {
        return "sil";
      } else if (this.selected[part] == "ゴールド") {
        return "gld";
      } else if (this.selected[part] == "エンジ") {
        return "enj";
      } else if (this.selected[part] == "Sピンク") {
        return "spk";
      } else if (this.selected[part] == "Lシルバー") {
        return "lsl";
      } else if (this.selected[part] == "Lゴールド") {
        return "lgd";
      } else if (this.selected[part] == "Rピンク") {
        return "rpk";
      } else if (this.selected[part] == "Lイエロー") {
        return "lyw";
      } else if (this.selected[part] == "Lグリーン") {
        return "lgn";
      } else if (this.selected[part] == "銀糸") {
        return "sil";
      } else if (this.selected[part] == "金糸") {
        return "gld";
      } else if (this.selected[part] == "中白パープル") {
        return "wpl";
      } else if (this.selected[part] == "中白チョコ") {
        return "wch";
      } else if (this.selected[part] == "中白ブラック") {
        return "wbk";
      } else if (this.selected[part] == "ミズイロ") {
        return "sbu";
      } else if (this.selected[part] == "イエロー") {
        return "ylw";
      }
    },

    //最低表示時間設定バージョン
      //   updateImages() {
      //   this.allImagesLoaded = false;
      //   const startTime = Date.now();
      //   this.$nextTick(() => {
      //     this.waitForImages().then(() => {
      //       const elapsed = Date.now() - startTime;
      //       const minDisplayTime = 1000; // 最低1秒表示
      //       if (elapsed < minDisplayTime) {
      //         setTimeout(() => {
      //           this.allImagesLoaded = true;
      //         }, minDisplayTime - elapsed);
      //       } else {
      //         this.allImagesLoaded = true;
      //       }
      //     });
      //   });
      // },

      updateImages() {
        this.allImagesLoaded = false;
      this.$nextTick(() => {
        this.waitForImages().then(() => {
          this.allImagesLoaded = true;
        });
      });
    },

    waitForImages() {
      // order-background 内のすべての画像を取得
      const images = this.$el.querySelectorAll('.order-background img');
      const promises = [];
      images.forEach(img => {
        if (img.complete) return;
        promises.push(new Promise(resolve => {
          img.addEventListener('load', resolve);
          img.addEventListener('error', resolve);
        }));
      });
      return Promise.all(promises);
    },

    /**
     * 色変更時の処理
     * @param {Number|null} index - 保存された設定のインデックス。グローバルな色変更なら null を渡す
     * @param {String} key - 更新対象のプロパティ名（例："fontColor"）
     * @param {String} value - 選択された色の値
     */
    handleColorUpdateChange(index, key, value) {
      // 保存用の selection を更新する
      this.savedSelections[index][key] = value;
      // 必要なら金額再計算など
      this.calculateTotal();
    },
    handleTypeNameChange(value) {
      this.updateSelection("typeName", value);

      // 連動リセット
      this.selected.finger = "";
      this.selected.backStyle = "";

      this.$nextTick(() => {
        this.calculateTotal();
      });
    },
  }
};
</script>

<style scoped>
@media (max-width: 1500px) {
  .middle-side {
    width: 25%;
  }
}

.warning-text {
  font-size: 12px;
  color: red;
margin-top: -19px;
  margin-bottom: 6px;
}
@media (max-width: 1000px) {
  .warning-text {
    margin-top: -13px;
  }
}
@media (max-width: 768px) {
  .warning-text {
  margin-top: -9px;
    display: flex;
    justify-content: flex-end;
    margin-bottom: -6px;
  }
}

label {
  display: block;
  margin-bottom: 4px;
  font-size: 14px;
  /* font-weight: bold; */
}
.saved-summary {
  cursor: pointer;
  font-weight: bold;
  color: #fff;
  padding: 5px;
  margin-bottom: 5px;
  border-radius: 3px;
  background-color: #000;
}

.saved-details {
  padding: 10px;
  border-radius: 3px;
  background-color: #000;
}
details {
  width: 99%;
  margin-left: auto;
  margin-right: auto;
}
.mobile-only-contact {
  display: none;
}

@media (max-width: 768px) {
  body {
    padding-top: 70px;
  }

  .mobile-only-contact {
    display: block;
  }

  .left-side {
    overflow-y: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .left-side::-webkit-scrollbar {
    display: none;
  }
  .saved-details {
    padding: 0;
  }
  details {
    border: none;
    width: 100%;
  }
  .tab-header {
    border-bottom: 1px solid #fff;
    margin-bottom: 12px;
  }

  .saved-summary {
    display: none;
  }
}

.tab-header {
  display: flex;
  overflow-x: auto;
}

.tab {
  padding: 10px;
  cursor: pointer;
  background-color: #000;
  border: 1px solid #fff;
  color: #fff;
  margin-right: 5px;
  border-radius: 8px 8px 0 0;
  width: 20%;
  text-align: center;
}

.tab.active {
  background-color: #fff;
  font-weight: bold;
  border-bottom: 2px solid #000;
  color: #000;
}
.caution-text-nowrop {
  margin: 2% 3% 8% 6%;
  font-size: clamp(0.1rem, 2.3vw, 1.8rem);
  white-space: nowrap;
  overflow: hidden;
}

.dropdown-descriptions {
  margin-top: 10px;
  padding: 10px;
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
  color: #333;
}

.nav-item {
  cursor: pointer;
  flex: 1;
}
.description-item {
  margin-bottom: 8px;
}
.btn-primary {
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #fff;
  --bs-btn-active-border-color: #fff;
  --bs-btn-disabled-bg: gray;
  --bs-btn-disabled-border-color: gray;
}

.order-id-test {
  height: 35px;
  margin-top: 20px;
}

.position-all {
  position: absolute;
  top: 0;
}

.nav-tabs .nav-link {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  display: flex;
  justify-content: center;
  border-top: 1px solid;
  border-left: 0.5px solid;
  border-right: 0.5px solid;
  border-bottom: 1px solid;
  padding: 5px;
}


.nav-tabs .nav-link.active {
  background-color: #fff;
  color: #000;
  border: 1px solid #fff;
}

.nav-tabs {
  width: 100%;
}

@media (min-width: 769px) and (max-width: 1751px) {
  .nav-tabs {
    white-space: nowrap;
    flex-wrap: nowrap;
  }

  .left-side {
    width: 30%;
  }
  .rigth-side {
    width: 70%;
  }
}

@media (min-width: 769px) and (max-width: 1116px) {
  .responsive-resize {
    font-size: 0.8rem;
  }
  .container-split .left-side label {
    font-size: 0.75rem;
  }
  .container-split .left-side .nav-item {
    flex: 1 1 auto;
    width: clamp(80px, 20%, 150px);
    text-align: center;
  }
  .embroidery-addition-btn {
    width: 55%;
  }
  .custom-select {
    padding: 10px 26px 10px 6px;
  }
  .right-side {
    width: 60%;
  }
}

@media (min-width: 769px) and (max-width: 975px) {
  .container-split .left-side .form-group .order-id-input {
    font-size: 0.8rem;
    height: 35px;
  }
}

@media (min-width: 769px) and (max-width: 1212px) {
  .nav {
    --bs-nav-link-padding-x: 0.5rem;
  }
  .container-split .left-side .form-group .order-id-input {
    font-size: 0.5rem;
    height: 35px;
  }
}

@media (max-height: 1100px) and (min-width: 351px) and (max-width: 768px) {
  .left-side {
    padding-bottom: 100px;
  }
}
@media (max-width: 450px) {
  .tab {
    padding: 10px 5px;
    margin-right: 3px;
    width: 16%;
    font-size: 12px;
  }
}
@media (max-width: 325px) {
  .tab {
    padding: 10px 0px;
  }
}
/* 幅の小さいsp対応 */
@media (max-width: 350px) {
  .navbar {
    display: none;
  }
  .nav-tabs {
    position: static;
  }
  body {
    padding-top: 0px !important;
  }
  .bottom-space .right-button {
    font-size: 13px;
  }
  .bottom-space .total-amount {
    font-size: 12px;
  }
}

@media (max-width: 768px) {
  .nav-tabs .nav-link {
    border-radius: 8px !important;
    display: block; /* 初期状態に戻す */
    justify-content: initial;
  }

  .nav-item {
    flex: initial; /* 初期状態に戻す */
  }

  .nav-tabs {
    width: initial; /* 初期状態に戻す */
  }
}

.font-preview-desktop {
  width: 100%;
  padding: 0px 10px 20p 10px;
  margin-left: auto;
  margin-right: auto;
}

.font-preview-desktop img {
  width: 100% !important;
  height: auto !important;
  margin-bottom: 8px;
}
.-preview-desktop {
  width: 100%;
  padding: 0px 10px 20p 10px;
  margin-left: auto;
  margin-right: auto;
}

.emb-font-preview-desktop img {
  width: 100% !important;
  height: auto !important;
  margin-bottom: 8px;
  background-color: #fff;
  padding: 4px;
}

.font-preview-desktop p {
  font-size: 0.85rem;
}

.emb-font-preview-desktop p {
  font-size: 0.85rem;
  background-color: #000;
  color: #fff;
  margin-top: -4px;
}
.type-detail-flex {
  display: flex;
  padding-top: 16px;
}
.type-detail-flex-l {
  display: block;
  width: 32%;
}
.type-length {
  border-top: 1px solid #fff;
  padding-top: 4px;
  /* margin-top: 22px; */
  font-size: 0.75rem;
  height: 100%;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
}
table {
  margin-bottom: 16px;
  height: 100%;
}
.type-detail-flex-r {
  border-bottom: 1px solid #fff;
  border-left: 1px solid #fff;
  width: 70%;
  margin-top: 20px;
  padding-left: 8px;
  padding-right: 0px;
  font-size: 0.75rem;
  margin-left: 0px;
  vertical-align: bottom;
}

.type-name {
  font-size: 1.5rem;
  display: flex;
  justify-content: center;
  text-align: center;
  /* padding-top: 20px;
  height: 44%; */
  vertical-align: middle;
}

.type-name-long-text {
  font-size: 1.5rem;
  display: flex;
  justify-content: center;
  text-align: center;
  vertical-align: middle;
}
/* @media (max-width: 1555px) {
  .type-name-long-text {
      padding-top: 20px;
      margin-bottom: 20px;
  }
}
@media (max-width: 930px) {
  .type-name {
    padding-top: 15px;
    margin-bottom: 17px;
  }
  .type-name-long-text {
    padding-top: 52px;
    margin-bottom: 33px;
  }
} */

/* @media (max-width: 1751px) {
  .type-length {
    height: 37.5%;
    padding-left: 12%;
  }
  .type-name {
    font-size: 1.5rem;
    padding-top: 32px;
  }
}
@media (max-width: 1552px) {
  .type-detail-flex .type-detail-long-text {
    height: 41%;
  }
}

@media (max-width: 1500px) {
  .type-length {
    height: 37.5%;
    padding-left: 0;
  }
  .type-detail-flex .type-detail-long-text {
    height: 38%;
  }
}

@media (max-width: 1411px) {
  .type-length {
    font-size: 0.7rem;
  }
  .type-detail-flex .type-detail-long-text {
    height: 39%;
    padding-top: 20px;
  }
  .type-length {
    height: 37%;
  }
}

@media (max-width: 1271px) {
  .type-detail-flex {
    display: block;
    padding-top: 8px;
  }
  .type-detail-flex-l {
    display: flex;
  }
  .type-length {
    border-top: none;
    border-right: none;
    font-size: 0.7rem;
    padding-left: 12%;
  }
  .type-detail-flex-r {
    width: 95%;
    margin-top: 8px;
    padding-left: 4px;
  }
  .type-detail-flex .type-detail-long-text {
    all: unset;
    display: inherit;
    font-size: 0.7rem;
    padding-top: 12px;
    margin-top: 22px;
    padding-left: 12%;
  }
} */

.mds-display-total-price {
  font-size: clamp(0.7rem, 1.5vw, 1.5rem);
  justify-content: space-between;
  display: flex;
  height: 116px;
  line-height: 1;
  position: sticky;
  top: 0px;
  background-color: #000;
  padding-top: 30px;
}

@media (max-width: 1116px) {
  .mds-display-total-price {
    height: 117px;
  }
}
.mds-color-palette {
  padding: 26px 0px 20px 0px;
  margin-left: auto;
  margin-right: auto;
}
.mds-color-palette h5 {
  font-size: 1rem;
}

.emb-d etail-flex {
  display: flex;
  justify-content: space-between;
  border: 1px solid #fff;
  padding: 4px 8px;
}
.mds-active-embroidery p {
  margin-top: 12px;
  font-size: 0.85rem;
}
.mds-type-title {
  font-size: 1rem;
  border-bottom: 2px solid #fff;
}

.embroidery-detailsn {
  margin-top: 4px !important;
}
.embroidery-text {
  padding: 5px 28px 5px 10px !important;
}

.embroidery-detailsn:-webkit-autofill {
  background-color: black !important; /* 自動入力時の背景色を黒に設定 */
  -webkit-text-fill-color: white !important; /* テキストの色を白に設定 */
  color: #fff !important;
  box-shadow: 0 0 0px 1000px black inset !important; /* 背景色を完全に上書き */
}

.embroidery-detailsn:-moz-autofill {
  background-color: black !important; /* Firefox用背景色 */
  color: white !important; /* Firefox用テキスト色 */
}

#sessionID:-webkit-autofill {
  background-color: #fff !important; /* 自動入力時の背景色を白 */
  -webkit-text-fill-color: #000 !important; /* 自動入力時のテキスト色を黒 */
  box-shadow: 0 0 0px 1000px #fff inset !important; /* 背景色を完全に上書き */
}

#sessionID:-moz-autofill {
  background-color: #fff !important; /* Firefox用の背景色 */
  color: #000 !important; /* Firefox用のテキスト色 */
}

.emb-detail-flex {
  display: flex;
  justify-content: space-between;
  border: 1px solid #fff;
  padding: 4px;
  margin-top: 20px;
}
.emb-detail-flex1 {
  display: flex;
  justify-content: space-between;
  border-left: 1px solid #fff;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
  padding: 4px;
}
.stitch-shadow-white {
  filter: drop-shadow(0.5px 0.5px 0px #fff);
}
.stitch-shadow-black {
  filter: drop-shadow(0.5px 0.5px 0px #000);
}
@media (max-width: 820px) {
  .order-id-test {
    display: none;
  }
}

@media (max-width: 768px) {
  .order-id-test {
    display: block;
  }
  .custom-select {
    margin-bottom: 24px;
  }
  .order-center-image {
    height: 96%;
    max-width: none;
  }
}

@media screen and (max-width: 768px) {
  details {
    display: none;
    margin-top: -0.5px;
    padding: 0px 0px;
  }
  details > summary {
    pointer-events: none; /* タイトル部分のクリックを無効にして折りたたみさせない */
  }
  /* 必要に応じて、toggle用の矢印なども隠す */
  details > summary::before,
  details > summary::after {
    display: none;
  }
  .saved-details {
    border: none;
  }
}
.desktop-tab-sticky {
  position: sticky;
  z-index: 1000;
  background-color: black;
  opacity: 1;
  top: 0px;
}
body {
  font-size: clamp(0.7rem, 1.5vw, 1.5rem) !important;
}
.cautionーtext {
  font-size: 0.75rem;
  color: red;
}

.hint-text {
  font-size: 12px;
  margin-top: -20px;
}
.info-text {
  font-size: 0.85rem;
  margin-bottom: 8px;
}
.tabel-end-margin {
  margin-bottom: 8px;
}
.reverse-flip {
  transform: scale(-1, 1);
}

::v-deep input.form-control.embroidery-detailsn.emb-input-error,
::v-deep input.form-control.embroidery-detailsn.emb-input-error:-webkit-autofill {
  background-color: red !important;
  -webkit-box-shadow: 0 0 0 1000px red inset !important;
}

.dropdown-options {
  width: 99.5%;
    margin-left: auto;
    margin-right: auto;
}

/* カスタムアラートのスタイル */
.custom-alert {
  position: fixed;
  top: 5%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ED4F64;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 16px;
  z-index: 999000;
  text-align: center;
  animation: fadeInOut 5s ease-in-out;
}
@keyframes fadeInOut {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}



</style>
